/*
  ATLANTICUS / CASTRA Kişiselleştirme Sihirbazı v2 — <atlanticus-customizer>.
  Tasarım kaynağı: Claude Design "Castra Sihirbaz v2.dc.html" (birebir tasarım dili).

  VERİ-GÜDÜMLÜ. İki <script> okur:
    .atlc-structure -> sihirbaz v2 şeması: { handle, steps:[{kind,label,fields:[...]}] }
                       veya { src: "<asset json url>" } (fetch edilir)
                       Alan: { prop, label, kind:'choice'|'text', ui:'swatch'|'tiles'|'chips'|'text',
                               values:[{v,img}], max, ph, showIf:[{p,eq|ne}], gate:{prop,yes,no},
                               gateFor:[prop...], propAlias }
    .atlc-runtime   -> { title, variants[], images[], price, krem, cakmak, boxUp, routes, ... }

  Şema BİREBİR canlı (kolektiftasarim.com / Cloudlift) verisinden üretilir
  (.tooling/sihirbaz-convert.mjs). prop adları ve değerler sepete `properties[...]`
  olarak AYNEN gider ('HAKİ ' sondaki boşluk dahil — DOKUNMA).

  Kademe: showIf koşulları geçen alanlar görünür (renk -> renge özel model ->
  'Özel baskılı' -> baskı modeli). Metin alanları HEP AÇIK; Evet/Hayır geçidi
  yerine "Baskı istemiyorum" onay kutusu (gate prop'una Hayır yazar).

  README (uyulması zorunlu):
  - Reveal animasyonları TRANSFORM-only (translateY); opacity'ye bağlama.
  - Strap/önizleme görselleri background-image ile; galeri <img> (kırpılmaz).
  - Yorumlara kaydırma window.scrollTo ile (scrollIntoView KULLANMA).
*/
(function () {
  'use strict';

  var ICON_PRESS = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#D3242D" stroke-width="1.6" style="flex:none;margin-top:1px;"><rect x="5" y="3" width="14" height="6" rx="1"/><rect x="4" y="9" width="16" height="6" rx="1"/><path d="M8 15v6M16 15v6M8 19h8"/></svg>';
  var ICON_COPY = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h8"/></svg>';
  var ICON_TRUCK = '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#D3242D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="flex:none;"><path d="M3.5 7h8a1 1 0 0 1 1 1v7.6H5a1 1 0 0 1-1-1V7.5a.5.5 0 0 1 .5-.5z"/><path d="M12.5 10h3.6a1.5 1.5 0 0 1 1.15.54l2 2.4a1 1 0 0 1 .25.66v2H12.5z"/><circle cx="7.2" cy="17.4" r="1.7"/><circle cx="16.8" cy="17.4" r="1.7"/><path d="M1.6 10H3M1.1 12.8h2.1"/></svg>';
  var ICON_TL_BAG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#211C18" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="8" width="14" height="12" rx="1.5"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var ICON_TL_TRUCK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#211C18" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 7h8a1 1 0 0 1 1 1v7.6H5a1 1 0 0 1-1-1V7.5a.5.5 0 0 1 .5-.5z"/><path d="M12.5 10h3.6a1.5 1.5 0 0 1 1.15.54l2 2.4a1 1 0 0 1 .25.66v2H12.5z"/><circle cx="7.2" cy="17.4" r="1.7"/><circle cx="16.8" cy="17.4" r="1.7"/></svg>';
  var ICON_TL_PIN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#211C18" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21s-6.5-5.1-6.5-10a6.5 6.5 0 0 1 13 0c0 4.9-6.5 10-6.5 10z"/><circle cx="12" cy="11" r="2.3"/></svg>';
  var ICON_TL_CLOCK = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#D3242D" stroke-width="1.8" stroke-linecap="round" style="flex:none;margin-top:2px;"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';
  var ICON_CARD = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#5C4434" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="flex:none;"><rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="M2.5 9.5h19"/><rect x="5" y="12.5" width="3.6" height="2.8" rx=".5"/><path d="M14 15h4"/></svg>';
  // info-tab icons (stroke=currentColor -> aktif/pasif renklenir)
  var ICON_TAB_DESC = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="3.5" width="14" height="17" rx="1.5"/><path d="M9 9h6"/><path d="M9 13h6"/><path d="M9 17h3.5"/></svg>';
  var ICON_TAB_PERS = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 10.5V7a2.5 2.5 0 0 1 5 0v3.5"/><path d="M6 15.5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1H6z"/><path d="M5 20.5h14"/></svg>';
  var ICON_TAB_SHIP = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="6.5" width="12" height="10" rx="1.2"/><path d="M14.5 10h3.6l2.4 3v3.5h-6"/><circle cx="7" cy="18" r="1.8"/><circle cx="16.8" cy="18" r="1.8"/></svg>';
  var ICON_TAB_PAY = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 2.5v5.2c0 4.6-3 7.8-7 9.3-4-1.5-7-4.7-7-9.3V5.5z"/><path d="M9 11.6l2.2 2.2 4-4.2"/></svg>';
  var ICON_TAB_FREE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12.6 3.3l7.7 7.7a1.8 1.8 0 0 1 0 2.6l-6.7 6.7a1.8 1.8 0 0 1-2.6 0l-7.7-7.7A1.8 1.8 0 0 1 2.8 11V4.6a1.8 1.8 0 0 1 1.8-1.8H11a1.8 1.8 0 0 1 1.6.5z"/><circle cx="7.6" cy="7.6" r="1.3"/></svg>';
  var ICON_TAB_HAND = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="9.5" r="5.2"/><path d="M9.2 13.9L8 20.5l4-2.3 4 2.3-1.2-6.6"/><path d="M10 9.7l1.5 1.5 2.7-2.9"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function trUpper(s) { return String(s || '').toLocaleUpperCase('tr-TR'); }
  function bgImg(url) { return url ? "background-image:url('" + esc(url) + "')" : ''; }
  function tv(s) { return String(s == null ? '' : s).trim(); }
  // ekran etiketi temizliği (M025): veri adlarındaki kopya soneki ve yazım hataları YALNIZ görüntüde düzelir.
  // Sepete giden property anahtarları (f.prop) ile showIf/gate prop'ları bu fonksiyondan GEÇMEZ.
  function cleanLbl(s) {
    return String(s == null ? '' : s)
      .replace(/(?:_copy)+\s*$/i, '')
      .replace(/(^|\s)(eksta)(?=\s)/gi, function (m, a, w) { return a + w.slice(0, 4) + (w === w.toUpperCase() ? 'R' : 'r') + w.slice(4); })
      .replace(/(^|\s)(pasapor)(?=\s)/gi, function (m, a, w) { return a + w + (w === w.toUpperCase() ? 'T' : 't'); })
      .replace(/İSTERMİSİN\s*\?/g, 'İSTER MİSİNİZ?')
      .replace(/([İi])stermisin\s*\?/g, '$1ster misiniz?');
  }
  // standart kutunun görünen adı (10.10.2026, kullanıcı: "Kolektif Kutu" → 12.10.2026: "Kolektif Kraft Kutu"); sepete giden değer veride aynı kalır
  function boxName(s) { return String(s == null ? '' : s).replace(/Standart Karton Kutu/g, 'Kolektif Kraft Kutu'); }
  // Gerekli piksel = CSS genişliği × cihaz DPR'ı (3 ile sınırlı). Mobilde küçük
  // dosya iner, retina masaüstünde keskin kalır — sabit büyük boy istemeye gerek yok.
  function imgW(cssPx) {
    var dpr = Math.max(1, Math.min(window.devicePixelRatio || 1, 3));
    return Math.round(cssPx * dpr);
  }
  // dokunmatik cihaz (hover yok) — v2: hover ön-izleme popup'ı mobilde tamamen kapalı
  function noHover() {
    try { return window.matchMedia('(hover: none)').matches; } catch (e) { return false; }
  }
  // Shopify CDN boyut: '_100x' -> '_<w>x' (keskin model/tile fotoğrafları için)
  function cdnSize(url, w) {
    if (!url) return url;
    // tema asset'i (/cdn/shop/t/N/assets/…): _NNNx soneki yok, ?width= ile boyutlanır
    if (/\/cdn\/shop\/t\/\d+\/assets\//.test(url)) return url.replace(/[?&]width=\d+/, '') + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    if (/_\d+x\d*(\.(?:jpe?g|png|webp|gif))/i.test(url)) {
      return url.replace(/_\d+x\d*(\.(?:jpe?g|png|webp|gif))/i, '_' + w + 'x$1');
    }
    return url.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2');
  }
  // handle karşılaştırma (5 handle'da birleşik nokta U+0307 var): NFC + küçük harf
  function hnorm(h) { try { return String(h || '').normalize('NFC').toLowerCase(); } catch (e) { return String(h || '').toLowerCase(); } }
  // renk geçişi önbelleği (14.10.2026): handle → Promise<{bölüm id: html}>, handle → runtime, sihirbaz verisi src → ham metin
  var SWAP = { sec: {}, rt: {}, struct: {} };
  // bölümü Section Rendering API cevabıyla (shopify-section-… sarmalı) yerinde değiştir.
  // Stil bağlantıları yerinde kalır (yeniden yüklenirken stilsiz an olmasın); satır içi betikler yeniden çalıştırılır.
  function swapSection(el, html) {
    var tp = document.createElement('template'); tp.innerHTML = html || '';
    var w = tp.content.firstElementChild;
    var src = (w && /^shopify-section-/.test(w.id || '')) ? w : tp.content;
    var isCss = function (n) { return n.nodeType === 1 && n.tagName === 'LINK' && /stylesheet/i.test(n.getAttribute('rel') || ''); };
    var keep = {};
    Array.prototype.slice.call(el.childNodes).forEach(function (n) { if (isCss(n)) keep[n.getAttribute('href')] = 1; else el.removeChild(n); });
    Array.prototype.slice.call(src.childNodes).forEach(function (n) {
      if (isCss(n) && keep[n.getAttribute('href')]) return;
      el.appendChild(document.importNode(n, true));
    });
    Array.prototype.forEach.call(el.querySelectorAll('script'), function (s) {
      if (s.src || (s.type && !/javascript/i.test(s.type))) return;
      var n = document.createElement('script'); n.textContent = s.textContent; s.parentNode.replaceChild(n, s);
    });
  }
  // Evet/Hayır geçidi mi? (addon aç/kapa satırı olarak çizilir)
  function isYesNo(f) {
    if (f.kind !== 'choice' || !f.values || f.values.length !== 2) return false;
    var s = f.values.map(function (v) { return tv(v.v); });
    return s.indexOf('Evet') > -1 && s.indexOf('Hayır') > -1;
  }
  // "Gelince haber ver" kaydı (17.10.2026): STOQ uygulaması (app embed açık olmalı). İstek STOQ SDK'sının createSignup'ıyla aynı;
  // ürün stoğa girince e-postayı STOQ gönderir. Sonuç: 'ok' | 'dup' | 'bad-email' | 'err'
  function stoqCfg() { return window._RestockRocketConfig || window._StoqConfig || null; }
  function stockSignup(o) {
    var cfg = stoqCfg() || {};
    var body = {
      intent: { shopify_variant_id: +o.variantId, shopify_product_id: +o.productId, shopify_market_id: cfg.marketId, quantity: 1, source: 'storefront-sdk' },
      customer: { email: o.email, locale: cfg.locale || 'tr', accepts_marketing: !!o.consent },
      product: { title: o.title, variant_title: o.variantTitle }
    };
    return fetch('https://app.stoqapp.com/api/v1/intents.json', {
      method: 'POST',
      headers: { 'X-Shopify-Shop-Domain': cfg.shop || (window.Shopify && window.Shopify.shop) || '', 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.status === 201) return 'ok';
        var e = (j && j.errors) || {};
        if (e.already_registered) return 'dup';
        if (e.email) return 'bad-email';
        return 'err';
      });
    });
  }

  class AtlanticusCustomizer extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;
      this.fmtNum = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      // Veri OKUNAMAZ/YÜKLENEMEZSE (ağ hatası, HTTP !ok, JSON parse hatası) sihirbaz yerine
      // "yüklenemedi + Yeniden dene" çıkar ve sepete ekleme KAPALI kalır — eskiden boş adım listesiyle
      // yalnız ÖZET açılıyor, isimsiz kişiye özel ürün sepete eklenebiliyordu.
      // Veri başarıyla gelip adım listesi gerçekten boşsa eski davranış (yalnız ÖZET) korunur.
      this.rt = this._readJSON('script.atlc-runtime');
      var struct = this._readJSON('script.atlc-structure');
      if (!this.rt) { this.rt = {}; this._loadFailed(new Error('runtime JSON okunamadı')); return; }
      this._galAll = (this.rt.images || []).slice(); // renk grubu süzgecinin kaynağı (19.10.2026)
      if (!struct) { this._loadFailed(new Error('structure JSON okunamadı')); return; }
      if (struct.src) this._fetchStruct(struct.src, false);
      else this._init(struct);
    }

    _fetchStruct(src, fresh) {
      var self = this;
      this._src = src;
      // renk geçişinde önceden alınmış veri: ağı beklemeden kur (sayfa boş görünüp zıplamasın)
      if (!fresh && SWAP.struct[src]) {
        var cd = null; try { cd = JSON.parse(SWAP.struct[src]); } catch (e) {}
        if (cd && typeof cd === 'object' && !Array.isArray(cd)) { this._failed = false; this._init(cd); return; }
      }
      fetch(src, fresh ? { cache: 'no-store' } : undefined)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (tx) {
          var d = JSON.parse(tx);
          if (!d || typeof d !== 'object' || Array.isArray(d)) throw new Error('geçersiz sihirbaz verisi');
          SWAP.struct[src] = tx;
          return d;
        })
        // ikinci argüman yalnız YÜKLEME hatasını yakalar (_init içindeki bir hata "yüklenemedi" gibi görünmesin)
        .then(function (d) { self._failed = false; self._init(d); }, function (e) { self._loadFailed(e); });
    }
    _loadFailed(err) {
      this._failed = true;
      this._track('wizard_load_error', { src: this._src || '', message: String((err && err.message) || err || '') });
      try { console.warn('[atlanticus-customizer] sihirbaz verisi yüklenemedi:', err); } catch (e) {}
      // kabuk (galeri, başlık, fiyat, bilgi sekmeleri) yine kurulur; yalnız sihirbaz kartı hata kutusuna döner
      if (!this.$) this._init({ steps: [] });
      else this.update();
      this._renderLoadFail();
    }
    _renderLoadFail() {
      var w = this.querySelector('[data-wizard]'); if (!w) return;
      w.classList.add('is-failed');
      var box = w.querySelector('[data-loadfail]');
      if (!box) {
        box = document.createElement('div');
        box.className = 'atlc-loadfail';
        box.setAttribute('data-loadfail', '');
        box.setAttribute('role', 'alert');
        w.appendChild(box);
      }
      box.innerHTML = '<p class="atlc-loadfail__msg">Kişiselleştirme seçenekleri yüklenemedi.</p>' +
        '<p class="atlc-loadfail__sub">Seçenekler yüklenmeden sepete ekleme kapalı. Bağlantınızı kontrol edip yeniden deneyin.</p>' +
        '<button type="button" class="atlc-loadfail__btn" data-action="retry">Yeniden deneyin</button>';
      this.querySelectorAll('[data-action="cart"]').forEach(function (b) { b.disabled = true; });
    }
    retryLoad() {
      var b = this.querySelector('[data-loadfail] [data-action="retry"]');
      if (b) { b.disabled = true; b.textContent = 'Yükleniyor…'; }
      if (this._src) this._fetchStruct(this._src, true);
      else window.location.reload(); // gömülü (metafield/runtime) veri bozuksa ancak sayfa yenilenince düzelir
    }

    _init(struct) {
      // yeniden kurulum (hata sonrası "Yeniden dene" başarılı olunca) için gözlemciler sıfırlanır
      if (this._railRO) { this._railRO.disconnect(); this._railRO = null; }
      if (this._stepRO) { this._stepRO.disconnect(); this._stepRO = null; }
      this.struct = struct || {};
      var dataSteps = (this.struct.steps || []).slice();
      this.steps = [];
      // onlyParam (17.10.2026): adım yalnız adres bu parametreyi içerince görünür (yayın öncesi önizleme)
      dataSteps.forEach(function (s) { if (s.onlyParam && String(window.location.search).indexOf(s.onlyParam) < 0) return; this.steps.push(s); }.bind(this));
      // Gerçek Shopify varyant adımı: KUTU'dan HEMEN SONRA (kutu yoksa en başa).
      // "KUTU her zaman ilk adım" kuralı varyantlı ürünlerde de geçerli.
      // variantFromField (17.10.2026): varyantı sihirbazdaki bir seçim belirler (ör. Pusulalı Anahtarlık 3.300 / Multiwallet 3.250) — ayrı varyant adımı yok
      // 19.10.2026 kullanıcı: renk seçimi "Hediyeni Kişiselleştir"in üstünde, sihirbazda RENK adımı yok — veride colorTop: true ya da
      // rt.colorTopDim (liquid: renk seçeneğinin sırası; setler ve kupalar hariç)
      // 20.10.2026: birden çok seçenekte yalnız renk boyutu üstte (colorTopDim); diğer seçenekler (Uzunluk, Boyut) sihirbazda kalır
      // 20.10.2026 kullanıcı ("silüet çantalarda da rengi üst kısma alalım"): renkler ayrı ürünse (nav adımı, varyant yok) veride colorTop: true
      // → RENK adımı sihirbazdan çıkar, aynı kutucuklar üstte; tıklama yine o rengin ürününe geçer (_swapColor)
      this._ctopNav = null;
      if (this.struct.colorTop && !this.rt.hasVariants) {
        var nsi = this.steps.findIndex(function (s) { var fs = s.fields || []; return fs.length === 1 && fs[0].nav; });
        if (nsi >= 0) { this._ctopNav = this.steps[nsi].fields[0]; this.steps.splice(nsi, 1); }
      }
      // 21.10.2026 kullanıcı: "kupalarda da renk seçeneği Hediyenizi Kişiselleştirin üstünde olsun, sonra model ve kişiselleştirme"
      // → renk ayrı ürünse (nav) ve KUPA adımında model/isim alanlarıyla birlikteyse yalnız renk alanı üste alınır (6 emaye kupa).
      // Setler hariç (setlerde her kupanın rengi kendi adımında, zaten ilk sırada). Önizleme: ?renkust=1 (KUPA_CTOP_ON false iken).
      var KUPA_CTOP_ON = true; // 21.10.2026 kullanıcı önizlemeyi onayladı
      if (!this._ctopNav && !this.rt.hasVariants && !this.rt.isSet && (KUPA_CTOP_ON || /[?&]renkust=1/.test(window.location.search))) {
        this.steps.some(function (s) {
          var fs = s.fields || [], ni = fs.findIndex(function (f) { return f.nav; });
          if (ni < 0 || fs.length < 2) return false;
          this._ctopNav = fs[ni]; fs.splice(ni, 1); s._navMoved = true;
          return true;
        }, this);
      }
      var ctd = typeof this.rt.colorTopDim === 'number' ? this.rt.colorTopDim : -1, nOpt = (this.rt.options || []).length;
      if (ctd < 0 && this.struct.colorTop && nOpt === 1) ctd = 0;
      this._colorTopDim = ctd;
      this._colorTop = ctd >= 0 && ctd < nOpt && !!this.rt.hasVariants && !this.struct.variantFromField;
      if (this.rt.hasVariants && nOpt && !this.struct.variantFromField && !(this._colorTop && nOpt === 1)) {
        var restOpts = this._colorTop ? this.rt.options.filter(function (o, i) { return i !== ctd; }) : this.rt.options;
        var vLbl = (restOpts.length === 1) ? trUpper(restOpts[0].name || 'Seçenek') : 'SEÇENEK';
        var vStep = { kind: 'variant', label: vLbl, fields: [] };
        if (this.struct.variantStep) { if (this.struct.variantStep.label) vStep.label = trUpper(this.struct.variantStep.label); if (this.struct.variantStep.title) vStep.title = this.struct.variantStep.title; if (this.struct.variantStep.sub) vStep.sub = this.struct.variantStep.sub; } // 17.10.2026: adım adı da veriden (kemerlerde UZUNLUK) // veride adım başlığı/alt yazısı (13.10.2026)
        var bi = this.steps.findIndex(function (s) { return s.kind === 'box'; });
        this.steps.splice(bi >= 0 ? bi + 1 : 0, 0, vStep);
      }
      if (!this.steps.some(function (s) { return s.kind === 'summary'; })) {
        this.steps.push({ kind: 'summary', label: 'ÖZET', fields: [] });
      }
      this._renameAccBox();
      this._injectCakmak();
      this._injectBasis();
      this._mergeStraps();
      // görüntü etiketleri (M025): yalnız sd.label / f.label temizlenir; f.prop (sepet anahtarı) aynen kalır
      // kısa adım adları (M015): HAM veri etiketiyle eşlenir (cleanLbl'dan önce). 'PASAPOR CÜZDANI' travectio'da
      // harf baskısı adımı — yalnız yazım düzeltmesi komşu 'PASAPORT CÜZDANI' adımıyla aynı adı üretirdi.
      var SHORT = { 'MUMLU KANVAS KESE': 'KESE', 'KALEMLİK EKLEMEK İSTERMİSİN ?': 'KALEMLİK', 'PASAPOR CÜZDANI': 'PASAPORT BASKISI' };
      this.steps.forEach(function (sd) {
        if (sd._rawLabel == null) sd._rawLabel = sd.label; // galeri anahtar kelimeleri ham addan (davranış aynı kalsın)
        if (SHORT[tv(sd.label)]) sd.label = SHORT[tv(sd.label)];
        sd.label = cleanLbl(sd.label);
        if (sd.kind === 'extra') sd.label = 'BİRLİKTE ALIN'; // 12.10.2026: "Ekstra" adımının yeni adı (kullanıcı kararı; bundle karşılığı)
        (sd.fields || []).forEach(function (f) { if (f.label) f.label = cleanLbl(f.label); });
      });
      // büyük set ahşap kutusunun eski görseli (DSCF2669-site, 40 ürün) yeni fotoğrafla değişir (10.10.2026, tema asset'i)
      // ahşap kutu görselleri (tema asset'leri, 11.10.2026): eski görsel adı → yeni fotoğraf.
      // aynı eski görsel (a_37Dr_aa) iki yerde: tekli emaye kupalarda emayeBoxImg (yalnız orada dolu), cüzdan/aksesuarlarda walletBoxImg.
      // 21.10.2026: eski krem fotoğrafı (a_EXjq_DSCF9860-kopya, 278 sihirbazda) canlıda 404 → kremin ürün fotoğrafı (dekupe)
      var boxMap = [[/DSCF9860-kopya/, this.rt.krem && this.rt.krem.image], [/DSCF2669-site/, this.rt.bigBoxImg], [/a_37Dr_aa_/, this.rt.emayeBoxImg || this.rt.walletBoxImg], [/bak_C4_B1r-emaye-kutu/, this.rt.bakirBoxImg], [/DSCF2661-kopya/, this.rt.miniBoxImg], [/DSCF9772-kopya/, this.rt.blackBigBoxImg], [/a_mz2u_bak/, this.rt.bakirSetBoxImg]]; // 17.10.2026: bakır set kutusu → Hediye Kutuları'ndaki Yaldız Baskılı set kutusu fotoğrafı
      // "asset:dosya.webp" → tema asset'i (13.10.2026: emaye kupa model/baskı fotoğrafları temada)
      var aBase = String(this.rt.assetBase || '').split('?')[0];
      // 17.10.2026: sürümsüz asset adresi tarayıcıda 1 yıl önbellekte kalır (yeni görsel görünmez) → renk görsellerinin sürümlü adresi varsa o
      var aMap = {}, addMap = function (m) { Object.keys(m || {}).forEach(function (k) { var u = m[k]; if (u) aMap[String(u).split('?')[0].split('/').pop()] = u; }); };
      addMap(this.rt.colorImgs); Object.keys(this.rt.linkColorImgs || {}).forEach(function (h) { addMap(this.rt.linkColorImgs[h]); }, this);
      // 17.10.2026 kullanıcı: emaye setlerinde her rengin "kupa modeli" ve "baskı modeli" kutuları o rengin yeni kupa fotoğrafıyla
      // (tekli emaye kupalardaki kupa-<renk>-<model>.webp); alan, showIf'teki emaye rengine göre seçilir
      var EMC = { bal: 'bal', haki: 'haki', fildisi: 'fildisi', mavi: 'mavi', cikolata: 'cikolata', olive: 'olive' };
      var EMM = { 'İsme Özel': 'isim', 'Geyikli': 'geyik', 'Özel baskılı': 'balta', 'At': 'at', 'Ayı': 'ayi', 'Balta': 'balta', 'Kurt': 'kurt', 'Pati': 'pati', 'Pusula': 'pusula', 'Wilderness Camping': 'kamp', 'Stay Wild': 'staywild' };
      var emK = function (s) { return tv(s).toLocaleLowerCase('tr').replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ö/g, 'o').replace(/ü/g, 'u'); };
      if (aBase) this.steps.forEach(function (sd) {
        (sd.fields || []).forEach(function (f) {
          if (f.ui !== 'tiles') return;
          var c = null; (f.showIf || []).some(function (cd) { if (/emaye\s*reng/i.test(cd.p || '')) { c = EMC[emK(cd.eq)] || null; return true; } return false; });
          if (!c) return;
          (f.values || []).forEach(function (v) { var m = EMM[tv(v.v)]; if (m) v.img = aBase + 'kupa-' + c + '-' + m + '.webp'; });
        });
      });
      // üstteki nav renkleri (_ctopNav) adımlardan çıkarıldı; görselleri de çözülsün
      this.steps.concat(this._ctopNav ? [{ fields: [this._ctopNav] }] : []).forEach(function (sd) {
        // adım yanı örnek görseli (20.10.2026: Duffle isim etiketi) — "asset:dosya" çözülür
        if (sd.sideImg && sd.sideImg.indexOf('asset:') === 0) { var sfn = sd.sideImg.slice(6); sd.sideImg = aMap[sfn] || (aBase ? aBase + sfn : ''); }
        (sd.fields || []).forEach(function (f) { (f.values || []).forEach(function (v) {
          if (v.img && v.img.indexOf('asset:') === 0) { var fn = v.img.slice(6); v.img = aMap[fn] || (aBase ? aBase + fn : ''); }
          if (v.img) boxMap.forEach(function (bm) { if (bm[1] && bm[0].test(v.img)) v.img = bm[1]; });
        }); });
      });
      this.lastStep = this.steps.length - 1;

      // alan endeksi + varsayılanlar
      this.fieldsFlat = [];
      // baskıyı zaten bir "Hayır" seçeneğiyle açan alanlar (cüzdanlarda "Harf Baskısı İsteği: Hayır / Ön Yüze / İç Yüze")
      var noChoice = {};
      this.steps.forEach(function (s) { (s.fields || []).forEach(function (f) {
        if (f.kind === 'choice' && (f.values || []).some(function (v) { return tv(v.v) === 'Hayır'; })) noChoice[f.prop] = true;
      }); });
      this.steps.forEach(function (s, si) {
        (s.fields || []).forEach(function (f) {
          f._step = si;
          // 13.10.2026 kullanıcı: ahşap kutu isim baskısı da isteğe bağlı — "Baskı istemiyorum" ve "Baskısız devam et" (tüm ürünler).
          // Sihirbaz verisinde (assets/sihirbaz-*.json, 95 üründe) bu alanda gate yok; burada eklenir, veri dosyalarına dokunulmaz.
          if (f.kind === 'text' && !f.gate && /Ahşap Kutu|Kutu üzerindeki deriye/i.test((f.prop || '') + ' ' + (f.label || ''))) {
            f.gate = { prop: f.prop + ' İsteği', yes: 'Evet', no: 'Hayır' };
          }
          // 16.10.2026 kullanıcı: "tüm ürünlerdeki kişiselleştirmede Baskı istemiyorum olsun" — gate'i olmayan harf baskısı alanları
          // (İsme Özel emaye/bakır/Black Edition kupa, set kupaları, orta deri, mini kupa…; 76 üründe) da isteğe bağlı. "Hayır" seçeneğine
          // bağlı alanlara eklenmez; orada baskısız seçim zaten var.
          if (f.kind === 'text' && !f.gate && /Harf Baskı/i.test(f.prop || '') && !(f.showIf || []).some(function (c) { return noChoice[c.p]; })) {
            f.gate = { prop: f.prop + ' İsteği', yes: 'Evet', no: 'Hayır' };
          }
          this.fieldsFlat.push(f);
        }.bind(this));
      }.bind(this));
      if (this._ctopNav) { this._ctopNav._step = -1; this.fieldsFlat.push(this._ctopNav); }
      var vals = {}, txts = {}, skips = {}, ons = {};
      this.fieldsFlat.forEach(function (f) {
        if (f.kind === 'choice') {
          if (isYesNo(f)) { vals[f.prop] = 'Hayır'; ons[f.prop] = false; }
          else if (f.nav) { var me = (f.values || []).filter(function (v) { return hnorm(v.h) === hnorm(this.rt.handle); }.bind(this))[0]; vals[f.prop] = me ? me.v : ''; }
          else vals[f.prop] = (f.values && f.values[0]) ? f.values[0].v : '';
        } else {
          txts[f.prop] = '';
          if (f.gate) skips[f.gate.prop] = false;
        }
      }.bind(this));
      var firstAvail = (this.rt.variants || []).filter(function (v) { return v.available; })[0] || (this.rt.variants || [])[0];
      this.state = {
        step: 0, vals: vals, txts: txts, skips: skips, ons: ons,
        optSel: (firstAvail && firstAvail.options) ? firstAvail.options.slice() : [],
        qty: 1, tried: false, added: false, galIdx: null, infoTab: 0, persText: ''
      };

      this._restoreCarry();
      this._syncVarField();
      this._buildShell();
      if (!this._bound) { this._bound = true; this._bind(); } // olaylar delege: kabuk yeniden kurulsa da bir kez bağlanır
      this.update();
      this.setAttribute('data-ready', ''); // CSS yer tutucusu kalkar (14.10.2026)
      this._loadRecs();
      this._maybeEdit();
      if (!this._failed) { this._funnel('personalization_view'); this._funnel('personalization_step_view'); }
    }

    _readJSON(sel) {
      var el = this.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    /* ---------- koşul motoru (birebir Cloudlift semantiği) ---------- */
    visible(f) {
      var conds = f.showIf || [];
      for (var i = 0; i < conds.length; i++) {
        var c = conds[i], cur = this.state.vals[c.p];
        if (c.inList) { // Cloudlift çoklu-değer (OR): cur listeden biri olmalı
          var ok = false;
          for (var k = 0; k < c.inList.length; k++) { if (tv(cur) === tv(c.inList[k])) { ok = true; break; } }
          if (!ok) return false;
        }
        else if (c.ne != null) { if (tv(cur) === tv(c.ne)) return false; }
        else { if (tv(cur) !== tv(c.eq)) return false; }
      }
      // gate'li metin hep görünür (tasarım kararı) — gate koşulu ayrı ele alınır
      return true;
    }
    // adımın görünür alanları
    stepFields(si) {
      var s = this.steps[si]; if (!s || !s.fields) return [];
      return s.fields.filter(this.visible.bind(this));
    }
    // eksik zorunlu metinler: görünür + (gate'liyse skip değil) + boş
    missingIn(si) {
      var out = [];
      this.stepFields(si).forEach(function (f) {
        if (f.kind !== 'text') return;
        if (f.gate && this.state.skips[f.gate.prop]) return;
        if (!tv(this.state.txts[f.prop])) out.push(f);
      }.bind(this));
      return out;
    }
    missingAll() {
      var out = [];
      for (var i = 0; i < this.steps.length; i++) out = out.concat(this.missingIn(i));
      return out;
    }
    canAdd() { return this.missingAll().length === 0; }
    // analitik: dataLayer (GA4) — yoksa sessiz
    // Kolektif funnel v1 (2026-10-22): metadata only, never engraving text.
    _funnel(ev, data) {
      try {
        if (this.rt && this.rt.preview) return;
        var st = this.state || {}, si = typeof st.step === 'number' ? st.step : 0;
        if (data && data.field_id) {
          var ff = (this.fieldsFlat || []).filter(function (f) { return f.prop === data.field_id; })[0];
          if (ff && typeof ff._step === 'number') si = ff._step;
        }
        var step = (this.steps || [])[si] || {};
        var p = { send_to: 'G-6DXK7HP2D2', funnel_version: '1',
          product_handle: (this.rt || {}).handle || '',
          step_number: si + 1, step_name: step.label || '', step_kind: step.kind || '',
          step_count: (this.steps || []).length };
        ['field_id', 'reason', 'choice', 'via', 'missing_count'].forEach(function (k) {
          if (data && data[k] != null) p[k] = data[k];
        });
        window.dataLayer = window.dataLayer || [];
        // Existing GTM Google tag owns configuration, consent and Stape routing.
        (function () { window.dataLayer.push(arguments); })('event', ev, p);
      } catch (e) {}
    }
    _funnelStart() {
      if (this._funnelStarted) return;
      this._funnelStarted = true;
      this._funnel('personalization_start');
    }
    _track(ev, data) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, data || {})); } catch (e) {}
      var map = { wizard_load_error: 'personalization_load_error',
        engrave_skip_prompt: 'personalization_skip_choice', engrave_skipped: 'personalization_skipped',
        engrave_unskipped: 'personalization_unskipped' };
      if (map[ev]) this._funnel(map[ev], { field_id: data && data.field, choice: data && data.choice, via: data && data.via });
    }
    // baskıya gidecek metinler (atlanmayan text alanları)
    _printTexts() {
      var s = this.state, out = [];
      var self = this;
      this.fieldsFlat.forEach(function (f) {
        if (f.kind !== 'text') return;
        if (!self.visible(f)) return; // showIf ile gizli alanlar (ör. karton kutuda ahşap kutu baskısı) listelenmez
        if (f.gate && s.skips[f.gate.prop]) return;
        // etiket: kısa alan adı (uzun yönerge cümleleri yerine prop adı, ör. "Kutu Harf Baskısı")
        var lbl = cleanLbl((f.label && f.label !== f.prop && f.label.length <= 28) ? f.label : f.prop);
        var t = tv(s.txts[f.prop]); if (t) out.push({ label: lbl, text: trUpper(t) });
      });
      return out;
    }
    // "Böyle basılacak" — baskı metinlerinin önizlemesi (onay kutusu yok; atölye onayı da DEĞİL)
    _printCheckHtml() {
      var pts = this._printTexts(); if (!pts.length) return '';
      return '<div class="atlc-check" data-check>' +
        '<div class="atlc-check__title">Böyle basılacak</div>' +
        pts.map(function (p) { return '<div class="atlc-check__row"><span class="atlc-check__lbl">' + esc(trUpper(p.label)) + '</span><span class="atlc-check__txt">' + esc(p.text) + '</span></div>'; }).join('') +
      '</div>';
    }
    // iade yok / kusur bizden — tema ayarındaki cümle (PDP, özet, sepet, kargo sayfası aynı metin)
    _noticeHtml() {
      var t = this.rt.policyNotice; if (!t) return '';
      if (!this._noticeSeen) { this._noticeSeen = true; this._track('defect_notice_view'); }
      return '<div class="atlc-press atlc-notice" data-notice>' + ICON_PRESS + '<span>' + esc(t) + '</span></div>';
    }

    money(cents) { return this.fmtNum.format((cents || 0) / 100) + ' TL'; }

    /* ---------- varyant / fiyat ---------- */
    currentVariant() {
      var vs = this.rt.variants || [], sel = this.state.optSel || [];
      if (this.rt.hasVariants && sel.length) {
        var m = vs.find(function (v) {
          return v.options && v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
        });
        if (m) return m;
      }
      return vs[0] || null;
    }
    // seçili opsiyonlarla BİREBİR eşleşen varyant; yoksa null (currentVariant() gibi ilk varyanta DÜŞMEZ)
    exactVariant(sel) {
      var vs = this.rt.variants || [];
      if (!this.rt.hasVariants) return vs[0] || null;
      sel = sel || this.state.optSel || [];
      return vs.find(function (v) {
        return v.options && v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      }) || null;
    }
    // seçili varyant tükendi mi (ya da bu opsiyon birleşimi hiç yok mu) -> DEVAM / SEPETE EKLE kapalı
    soldOut() {
      if (!(this.rt.variants || []).length) return false;
      var v = this.exactVariant();
      return !v || v.available === false;
    }
    _soldOutMsg() { return this.rt.hasVariants ? 'Bu seçenek tükendi' : 'Bu ürün tükendi'; }
    basePrice() { var v = this.currentVariant(); return v ? v.price : (this.rt.price || 0); }
    baseCompareAt() { var v = this.currentVariant(); return (v && v.compareAt) || this.rt.compareAt || null; }

    // ücretli yardımcı ürünler (section'dan): ahşap kutu / krem / %50 çakmak
    _boxField() {
      var s = this.steps.find(function (x) { return x.kind === 'box'; });
      return s && s.fields && s.fields[0] && s.fields[0].kind === 'choice' ? s.fields[0] : null;
    }
    paidBoxValue() {
      var f = this._boxField(); if (!f) return null;
      var v = (f.values || []).find(function (x) { return /ah[şs]ap|müh[üu]rl/i.test(x.v); });
      return v ? v.v : null;
    }
    boxUpActive() {
      var f = this._boxField(), pv = this.paidBoxValue();
      return !!(f && pv && this.rt.boxUp && this.rt.boxUp.id && tv(this.state.vals[f.prop]) === tv(pv));
    }
    _gateOn(prop) { return tv(this.state.vals[prop]) === 'Evet'; }
    creamGate() {
      var f = this.fieldsFlat.find(function (x) { return isYesNo(x) && /bak.m\s*krem/i.test(x.prop); });
      return f ? f.prop : null;
    }
    // 17.10.2026: oran %25 olunca eski '%50' yakalaması düştü; JS /i 'İ' ile 'i'yi eşlemez → kalıp [İIiı]ndirimli
    cakmakGate() {
      var f = this.fieldsFlat.find(function (x) { return isYesNo(x) && /%\s*\d+\s*[İIiı]ndirimli\s*[çÇcC]akmak|indirimli\s*[çc]akmak/i.test(x.prop); });
      return f ? f.prop : null;
    }
    // İndirimli çakmak teklifi her üründe (karar 25.09; oran 17.10.2026'dan beri %25, rt.cakmakPct): veride yoksa EKSTRA adımına eklenir; çakmağın kendi sayfasında çıkmaz.
    // 17.10.2026: sepete gizli Birlikte Al kopyası gider (rt.cakmak varyantları); indirim yalnız ona uygulanır.
    // İndirimi Shopify otomatik indirimi uygular; burada teklif, doğru renk varyantı ve gösterilen fiyat var.
    _injectCakmak() {
      // 17.10.2026 kullanıcı: "çakmak ürününü kupalardan çıkar" — Kupalar/Kahve Kupaları ürünlerinde teklif yok (veride olsa da kaldırılır)
      if (this.rt.kupaExtra && this.rt.kupaExtra.noCakmak) {
        var re0 = /%\s*\d+\s*[İIiı]ndirimli\s*[çÇcC]akmak|indirimli\s*[çc]akmak/i;
        this.steps.forEach(function (st) { if (st.fields) st.fields = st.fields.filter(function (f) { return !re0.test(f.prop || ''); }); });
        return;
      }
      var re = /%\s*\d+\s*[İIiı]ndirimli\s*[çÇcC]akmak|indirimli\s*[çc]akmak/i, myH = this.rt.handle;
      // 17.10.2026 kullanıcı: çakmak indirimi %25 — veride (36 sihirbaz) "%50 İndirimli Çakmak EKLE" yazıyor; görünen ad ve sepet özelliği
      // indirim oranıyla (rt.cakmakPct) yeniden adlandırılır (prop, etiket, koşullar birlikte)
      var pctTxt = '%' + this._cakmakPct() + ' İndirimli Çakmak', reOld = /%\s*\d+\s*İndirimli Çakmak/g;
      var ren = function (s) { return typeof s === 'string' ? s.replace(reOld, pctTxt) : s; };
      this.steps.forEach(function (st) {
        (st.fields || []).forEach(function (f) {
          if (!re.test(f.prop || '')) return;
          f.prop = ren(f.prop); f.label = ren(f.label); f.title = ren(f.title); f.propAlias = ren(f.propAlias);
          if (f.gateFor) f.gateFor = f.gateFor.map(ren);
          (f.showIf || []).forEach(function (x) { x.p = ren(x.p); });
        });
      });
      var c = this.rt.cakmak;
      if (!c || !c.id || !(c.variants || []).length || c.handle === this.rt.handle) return;
      // 17.10.2026 kullanıcı: "çakmakta sitedeki tüm renkleri önersin" — renkler her zaman sitedeki çakmak varyantlarından (stokta olanlar);
      // veride eski 4 renkli liste (TABA/SİYAH/YEŞİL/KIRMIZI) varsa o da güncel listeyle değişir
      var allColors = c.variants.filter(function (v) { return v.available && v.h !== myH; }).map(function (v) { return { v: trUpper(v.title), img: v.image || c.image }; });
      var had = false;
      this.steps.forEach(function (st) {
        (st.fields || []).forEach(function (f) {
          if (!re.test(f.prop || '')) return; had = true;
          if (f.kind === 'choice' && !isYesNo(f) && (f.showIf || []).length && allColors.length) f.values = allColors.slice();
        });
      });
      if (had) return;
      var ex = this.steps.find(function (st) { return st.kind === 'extra'; });
      if (!ex) return;
      var gate = pctTxt + ' EKLE';
      var colors = allColors;
      if (!colors.length) return;
      ex.fields = (ex.fields || []).concat([
        { prop: gate, kind: 'choice', ui: 'tiles', values: [{ v: 'Hayır' }, { v: 'Evet' }] },
        { prop: gate + ' — Seçim', kind: 'choice', ui: 'tiles', values: colors, showIf: [{ p: gate, eq: 'Evet' }] }
      ]);
    }
    // 17.10.2026 kullanıcı: "basis ürününü tüm kupalarda birlikte al'a ekle" — EKSTRA adımına Basis satırı; fiyat, toplam ve sepet satırı
    // bağlı ürün (linkUps, değerde link) üzerinden; ürünün kendi indirimli fiyatı, eski fiyat üstü çizili
    // 17.10.2026 kullanıcı: "Cüzdan Kutusunun ismi QR Kodlu Özel Ahşap Aksesuar Kutusu olsun her yerde" — cüzdan ahşap kutusunu kullanan
    // ürünlerde (cüzdanlar, kemerler) KUTU adımındaki ahşap seçenek adı (ve ona bağlı koşullar) bu adla; sepet özelliği de bu adla gider
    // 17.10.2026 kullanıcı: büyük çantalar ve laptop ürünlerinde (PassengerBag 16", Vector, Viator, Iter, Tabula, Nuntia) kutu adı
    // "QR Kodlu ve Mühürlü Özel Ahşap Çanta Kutusu ( Büyük Boy )" — bu ürünlere özel, aramada gizli ek ücret ürünü; görsel büyük kutu
    _renameAccBox() {
      var bu = this.rt.boxUp; if (!bu) return;
      var CFG = {
        'qr-kodlu-muhurlu-ozel-cuzdan-ahsap-kutusu-ek-ucreti': ['QR Kodlu Özel Ahşap Aksesuar Kutusu', this.rt.walletBoxImg],
        'qr-kodlu-ve-muhurlu-ozel-ahsap-canta-kutusu-buyuk-boy': ['QR Kodlu ve Mühürlü Özel Ahşap Çanta Kutusu ( Büyük Boy )', this.rt.bigBoxImg],
        // 17.10.2026 kullanıcı: emaye kupaların ahşap kutusu "QR Kodlu Mühürlü Emaye Ahşap Hediye Kutusu" (görsel aynı kalır)
        'emaye-ozel-ahsap-kutu-ek-ucreti': ['QR Kodlu Mühürlü Emaye Ahşap Hediye Kutusu', null],
        // 21.10.2026 kullanıcı: L çanta kutusu her yerde (sihirbaz, ödeme sayfası, sipariş) aynı adla — ek ücret ürününün adı da bu
        'qr-kodlu-muhurlu-ozel-ahsap-l-canta-kutusu-ek-ucreti': ['QR Kodlu ve Mühürlü Özel Ahşap Çanta Kutusu (L Boy)', null],
        'qr-kodlu-muhurlu-ozel-ahsap-l-canta-kutusu-ek-ucreti-1': ['QR Kodlu ve Mühürlü Özel Ahşap Çanta Kutusu (L Boy)', null]
      }[bu.handle];
      // 17.10.2026 kullanıcı (Hediye Kutuları adları): set kutuları (doğal / Black Edition / Yaldız Baskılı) ve Black Edition / Yaldız
      // Baskı kupa kutuları sihirbazın KUTU seçeneğinde de Hediye Kutuları'ndaki adlarıyla — ad paketleme kutusundan (rt.packBox.name)
      // 21.10.2026 kullanıcı: mini aksesuar kutusu da Hediye Kutuları'ndaki adıyla (ödeme sayfası/siparişteki kutu satırıyla aynı ad)
      var PB = ['mini-aksesuar-ahsap-kutu-ek-ucreti', 'ozel-ahsap-kutu-ek-ucreti', 'bakir-qr-kodlu-muhurlu-ozel-ahsap-kutu-ek-ucreti', 'siyah-qr-kodlu-muhurlu-ozel-ahsap-kutu-ek-ucreti',
        'qr-kodlu-kemerli-bakir-siyah-emaye-ozel-ahsap-kutu-ek-ucreti', 'siyah-qr-kodlu-muhurlu-emaye-ozel-ahsap-kutu-ek-ucreti', 'bakir-qr-kodlu-muhurlu-emaye-ozel-ahsap-kutu-ek-ucreti'];
      if (!CFG && PB.indexOf(bu.handle) > -1 && this.rt.packBox && this.rt.packBox.name) CFG = [this.rt.packBox.name, null];
      // 17.10.2026 kullanıcı: NABITCU STELLA → Yaldız Baskı emaye kupa kutusu (ad ve görsel Hediye Kutuları'ndaki üründen)
      if (!CFG && bu.handle === 'qr-kodlu-muhurlu-bakir-kupa-ozel-ahsap-kutu-ek-ucreti' && this.rt.packBox && this.rt.packBox.name) CFG = [this.rt.packBox.name, this.rt.packBox.image];
      // 17.10.2026 kullanıcı: BLACK STELLA → Black Edition emaye kupa kutusu (ad ve görsel Hediye Kutuları'ndaki üründen; tekli siyah kupalar değişmez)
      if (bu.handle === 'siyah-qr-kodlu-muhurlu-emaye-ozel-ahsap-kutu-ek-ucreti' && /^set-/.test(this.rt.handle || '') && this.rt.packBox && this.rt.packBox.name) CFG = [this.rt.packBox.name, this.rt.packBox.image];
      if (!CFG) return;
      var NEW = CFG[0], IMG = CFG[1];
      // 17.10.2026 kullanıcı: "cüzdan kutularını bu görseldeki aksesuar kutusu ile değiştir" → bu kutuyla gönderilen bütün ürünlerde
      // ahşap seçeneğin görseli aksesuar kutusu (kutu-cuzdan-aksesuar.webp); veride büyük set kutusu vb. olsa da
      this.steps.forEach(function (st) {
        if (st.kind !== 'box') return;
        var map = {};
        (st.fields || []).forEach(function (f) {
          (f.values || []).forEach(function (v) { if (/ah[şs]ap/i.test(v.v || '')) { if (v.v !== NEW) { map[v.v] = NEW; v.v = NEW; } if (IMG) v.img = IMG; } });
        });
        (st.fields || []).forEach(function (f) { (f.showIf || []).forEach(function (c) { if (map[c.eq]) c.eq = map[c.eq]; }); });
      });
    }
    // 17.10.2026 kullanıcı: cüzdanlarda Clavis anahtarlık (renk seçmeli; renk kutucuklarında tek tek fiyat yazmaz, fiyat satırda)
    _injectBasis() {
      var offers = [];
      var b = this.rt.kupaExtra && this.rt.kupaExtra.basis; if (b && b.handle) offers.push({ o: b, values: [{ v: b.name, link: b.handle, img: b.image }] });
      var cl = this.rt.cuzdanExtra && this.rt.cuzdanExtra.clavis;
      if (cl && cl.handle) offers.push({ o: cl, values: (cl.colors || []).filter(Boolean).map(function (c) { return { v: c.v, link: cl.handle, opt: c.v, img: c.img || cl.image, noTilePrice: true }; }) });
      // 17.10.2026 kullanıcı: bakım kreminde 2. krem %50 (krem sihirbazında BİRLİKTE AL yok → özetten önce eklenir)
      var k2 = this.rt.kremSecond;
      if (k2 && k2.handle) {
        offers.push({ o: k2, values: [{ v: k2.name, link: k2.handle, img: k2.image, disc: 50 }] });
        if (!this.steps.some(function (st) { return st.kind === 'extra'; })) {
          var si = this.steps.findIndex(function (st) { return st.kind === 'summary'; });
          this.steps.splice(si < 0 ? this.steps.length : si, 0, { kind: 'extra', label: 'EKSTRA', fields: [] });
        }
      }
      var ex = this.steps.find(function (st) { return st.kind === 'extra'; }); if (!ex) return;
      var L = this.rt.linkUps || {};
      offers.forEach(function (x) {
        var o = x.o; if (!(L[o.handle] || []).length || !x.values.length) return;
        var gate = '_' + o.name + ' İsteği', dep = '_' + o.name;
        if ((ex.fields || []).some(function (f) { return f.prop === gate; })) return;
        ex.fields = (ex.fields || []).concat([
          { prop: gate, kind: 'choice', ui: 'chips', values: [{ v: 'Hayır' }, { v: 'Evet' }], gateFor: [dep], img: o.image },
          { prop: dep, kind: 'choice', ui: 'tiles', label: x.values.length > 1 ? 'Rengini seçin' : undefined, values: x.values, showIf: [{ p: gate, eq: 'Evet' }] }
        ]);
      });
    }
    // 13.10.2026 kullanıcı: PAMUK ASKI + EKSTRA DERİ ASKI tek adım ("ASKI"). Pamuk askı hediye, önce o seçilir; altında gerçek deri
    // askı önerisi (+fiyat, rt.strapUpPrice — şimdilik yalnız gösterilen fiyat, sepete ek ücret ürünü bağlanınca eklenecek).
    // Alan adları (f.prop = sepet anahtarı) değişmez; yalnız görünen etiketler ve adım birleşir.
    _mergeStraps() {
      var pi = this.steps.findIndex(function (s) { return /PAMUK\s*ASKI/i.test(s.label || ''); });
      if (pi < 0) return;
      var di = this.steps.findIndex(function (s, i) { return i !== pi && /DER[İI]\s*ASKI/i.test(s.label || ''); });
      if (di < 0) return;
      var p = this.steps[pi], d = this.steps[di];
      var su = this.rt.strapUp, price = (su && su.price) ? this.money(su.price).replace(',00 TL', ' TL') : (this.rt.strapUpPrice ? this.rt.strapUpPrice + ' TL' : '');
      (p.fields || []).forEach(function (f) { if (f.kind === 'choice') f.label = 'Pamuk askının rengini seçin · çantanızla birlikte hediye'; });
      (d.fields || []).forEach(function (f) {
        if (f.gateFor) { f.label = 'Gerçek deri askı da ekleyelim mi?' + (price ? ' (+' + price + ')' : ''); p._strapGate = f.prop; }
        else if (f.kind === 'choice') p._strapColor = f.prop;
        if (!f.gateFor && f.kind === 'choice') f.label = 'Deri askının rengini seçin';
      });
      p._rawLabel = p.label; p._strap = true;
      (p.fields || []).forEach(function (f) { if (f.kind === 'choice' && !f.gateFor && !f.showIf) p._strapCotton = f.prop; });
      p.fields = (p.fields || []).concat(d.fields || []);
      p.label = 'ASKI'; p.title = 'Askı';
      p.sub = 'Pamuk askı çantanızla birlikte hediye. İsterseniz gerçek deri askı da ekleyebilirsiniz.';
      this.steps.splice(di, 1);
    }
    cakmakVariant() {
      var c = this.rt.cakmak; if (!c || !c.id) return null;
      var vs = c.variants || [], g = this.cakmakGate(), s = this.state, pick = null;
      if (g) {
        var cf = this.fieldsFlat.find(function (f) { return f.kind === 'choice' && !isYesNo(f) && (f.showIf || []).some(function (x) { return x.p === g; }); });
        var val = cf ? trUpper(tv(s.vals[cf.prop])) : '';
        if (val) pick = vs.find(function (v) { return trUpper(v.title) === val; });
      }
      return pick || vs.find(function (v) { return v.available; }) || { id: c.id, price: c.price };
    }
    cakmakPrice(full) {
      var v = this.cakmakVariant(); if (!v) return 0;
      var p = v.price || 0, pct = this._cakmakPct();
      return full ? p : p - Math.floor(p * pct / 100); // Shopify indirim tutarını kuruşa aşağı yuvarlar (499,99 × %25 → 124,99 → 375,00)
    }
    _cakmakPct() { return this.rt.cakmakPct != null ? +this.rt.cakmakPct : 25; } // 17.10.2026: %50 → %25 (kullanıcı)
    creamOn() { var g = this.creamGate(); return !!(g && this._gateOn(g)); }
    // gerçek deri askı ek ücreti (13.10.2026): rt.strapUp = 'Deri Askı Ek Ücreti' ürünü (renk varyantları); seçilen deri askı rengine göre varyant
    _strapStep() { return this.steps.find(function (x) { return x._strap; }); }
    strapOn() { var st = this._strapStep(), su = this.rt.strapUp; return !!(st && st._strapGate && su && (su.variants || []).length && this._gateOn(st._strapGate)); }
    strapVariant() {
      var st = this._strapStep(), su = this.rt.strapUp; if (!st || !su) return null;
      var want = tv(this.state.vals[st._strapColor] || ''), vs = su.variants || [];
      return vs.find(function (v) { return tv(v.title) === want && v.available; }) || vs.find(function (v) { return v.available; }) || null;
    }
    strapPrice() { var v = this.strapVariant(); return v ? (v.price || 0) : 0; }
    // mumlu kanvas kese ek ücreti (14.10.2026 kullanıcı: "kese ekstra fiyat eklenmeli, şimdilik 350 TL"):
    // rt.keseUp = 'Mumlu Kanvas Organizer Kese Ek Ücreti' ürünü (renk varyantları); kutucuklu kese seçilince renge göre varyant
    _keseGate() { return (this.fieldsFlat || []).find(function (f) { return f.addon && f.pick && /kese/i.test(f.prop); }) || null; }
    keseOn() { var g = this._keseGate(), ku = this.rt.keseUp; return !!(g && ku && (ku.variants || []).length && this._gateOn(g.prop)); }
    keseVariant() {
      var g = this._keseGate(), ku = this.rt.keseUp; if (!g || !ku) return null;
      var want = tv(this.state.vals[(g.gateFor || [])[0]] || ''), vs = ku.variants || [];
      return vs.find(function (v) { return tv(v.title) === want && v.available; }) || vs.find(function (v) { return v.available; }) || null;
    }
    kesePrice() { var v = this.keseVariant(); return v ? (v.price || 0) : 0; }
    // bağlı ürün seçimleri (14.10.2026 kullanıcı: ahşap kalemde kalemlik paneldeki fiyatla): görünür seçim alanında seçili değerin
    // "link" (ürün handle) + "opt" (varyant adı) bilgisi varsa o varyant ayrı satır olarak eklenir; fiyatı toplama girer
    linkPicks() {
      var self = this, L = this.rt.linkUps || {}, out = [];
      (this.fieldsFlat || []).forEach(function (f) {
        if (f.kind !== 'choice' || !self.visible(f)) return;
        var cur = tv(self.state.vals[f.prop] || ''); if (!cur) return;
        var val = (f.values || []).find(function (x) { return x.link && tv(x.v) === cur; }); if (!val) return;
        var vs = L[val.link] || [], want = tv(val.opt || '');
        var vr = vs.find(function (x) { return tv(x.title) === want && x.available; }) || (want ? null : vs.find(function (x) { return x.available; }));
        if (vr) out.push({ f: f, val: val, v: vr });
      });
      return out;
    }
    // gate'e bağlı seçimde bağlı ürün değeri (Basis gibi tek değerli eklenti satırı için)
    _gateLinkVal(f, deps) {
      var lv = null;
      (deps || []).some(function (d) { var v = (d.values || []).find(function (x) { return x.link; }); if (v) lv = v; return !!v; });
      return lv && this.linkPrice(lv) ? lv : null;
    }
    _linkWas(val) {
      var vs = (this.rt.linkUps || {})[val.link] || [], want = tv(val.opt || '');
      var vr = vs.find(function (x) { return tv(x.title) === want; }) || vs[0];
      return vr ? Math.max(vr.compare || 0, vr.price || 0) * (+val.q || 1) : 0;
    }
    linkPrice(val, full) {
      var vs = (this.rt.linkUps || {})[val.link] || [], want = tv(val.opt || '');
      var vr = vs.find(function (x) { return tv(x.title) === want; }) || vs[0];
      if (!vr) return 0;
      return full ? vr.price * (+val.q || 1) : this.linkUnit(val, vr);
    }
    // değerde disc (yüzde) varsa sepette otomatik indirimle düşecek fiyat gösterilir (17.10.2026 kullanıcı: kupa alana 2. orta deri %50)
    // 20.10.2026 kullanıcı (İvory Defter, A5 organizer): değerde q = adet, disc2 = her 2. adette yüzde (otomatik indirim "İvory Defter 1 alana 2. %25")
    linkUnit(val, vr) {
      var d = +(val && val.disc) || 0, q = +(val && val.q) || 1, d2 = +(val && val.disc2) || 0;
      var u = d ? vr.price - Math.floor(vr.price * d / 100) : vr.price; // ödemeyle aynı: indirim aşağı yuvarlanır
      return u * q - (d2 ? Math.floor(vr.price * d2 / 100) * Math.floor(q / 2) : 0);
    }
    // bağlı ürünün kendi satırına yazılacak özellikler: forLink = bağlı seçim alanının prop'u; ad linkName (yoksa prop)
    _linkProps(linkProp) {
      var s = this.state, self = this, out = {};
      (this.fieldsFlat || []).forEach(function (f) {
        if (f.forLink !== linkProp || !self.visible(f)) return;
        var name = f.linkName || f.prop;
        if (f.kind === 'choice') { var val = s.vals[f.prop]; if (val != null && val !== '') out[name] = val; return; }
        if (f.gate) {
          var gn = '_' + (f.gate.linkName || f.gate.prop);
          if (s.skips[f.gate.prop]) { out[gn] = f.gate.no || 'Hayır'; return; }
          out[gn] = f.gate.yes || 'Evet';
        }
        var t = tv(s.txts[f.prop]); if (t) out[name] = trUpper(t);
      });
      return out;
    }
    cakmakOn() { var g = this.cakmakGate(); return !!(g && this._gateOn(g)); }
    total() {
      var s = this.state, t = this.basePrice() * (s.qty || 1);
      if (this.boxUpActive()) t += (this.rt.boxUp.price || 0) * (s.qty || 1);
      if (this.creamOn() && this.rt.krem && this.rt.krem.id) t += (this.rt.krem.price || 0);
      if (this.cakmakOn() && this.rt.cakmak && this.rt.cakmak.id) t += this.cakmakPrice();
      if (this.strapOn()) t += this.strapPrice() * (s.qty || 1);
      if (this.keseOn()) t += this.kesePrice() * (s.qty || 1);
      var self = this; this.linkPicks().forEach(function (p) { t += self.linkUnit(p.val, p.v) * (s.qty || 1); });
      return t;
    }
    compareAtTotal() {
      var old = this.baseCompareAt();
      if (!old) return 0;
      var t = old * (this.state.qty || 1);
      if (this.boxUpActive()) t += (this.rt.boxUp.price || 0) * (this.state.qty || 1);
      if (this.creamOn() && this.rt.krem && this.rt.krem.id) t += (this.rt.krem.price || 0);
      if (this.cakmakOn() && this.rt.cakmak && this.rt.cakmak.id) t += this.cakmakPrice(true);
      if (this.strapOn()) t += this.strapPrice() * (this.state.qty || 1);
      if (this.keseOn()) t += this.kesePrice() * (this.state.qty || 1);
      var q3 = this.state.qty || 1;
      this.linkPicks().forEach(function (p) { t += (p.v.compare > p.v.price ? p.v.compare : p.v.price) * (+p.val.q || 1) * q3; });
      return t;
    }
    discountPct() {
      var p = this.basePrice(), o = this.baseCompareAt();
      return (o && o > p) ? Math.round((1 - p / o) * 100) : 0;
    }

    /* ---------- kabuk ---------- */
    _buildShell() {
      var c = this.rt, pct = this.discountPct();
      var noText = !this._failed && !(this.steps || []).some(function (st) { return (st.fields || []).some(function (f) { return f.kind === 'text' || f.gate; }); });
      var badge = (pct > 0 && c.showBadge !== false) ? '<span class="atlc-badge">%' + pct + ' İNDİRİM</span>' : '';
      // Judge.me vb. bir yorum uygulaması reviews.rating metafield'ını doldurunca otomatik görünür
      // 13.10.2026 kullanıcı: başlık altındaki '★ 4,0 · 1 yorum' kaldırıldı (rt.showRating true olursa geri gelir)
      var rating = (c.showRating && c.rating && c.rating.count) ? '<div class="atlc-rating"><button type="button" class="atlc-rating__txt" data-action="reviews" style="background:none;border:0;padding:0;cursor:pointer;color:inherit;font:inherit">★ ' + esc(c.rating.avg) + ' · ' + c.rating.count + ' yorum</button></div>' : '';
      // breadcrumb koleksiyonu runtime'dan (c.crumb: geliniş koleksiyonu / ürünün ilk koleksiyonu) — sabit "Hediye Setleri" DEĞİL
      var crumb = '<a href="/">Anasayfa</a>&nbsp;&nbsp;/&nbsp;&nbsp;<a href="' + esc((c.crumb && c.crumb.url) || '/collections/hediye-setleri') + '">' + esc((c.crumb && c.crumb.title) || 'Hediye Setleri') + '</a>&nbsp;&nbsp;/&nbsp;&nbsp;<span>' + esc(trUpper(c.title || '')) + '</span>';
      this.innerHTML =
        '<div class="atlc"><div class="atlc__grid">' +
          // 21.10.2026 kullanıcı: mobilde breadcrumb görselin üstünde (≤989px bu kopya görünür, .atlc-main içindeki gizlenir)
          '<div class="atlc-breadcrumb atlc-breadcrumb--top">' + crumb + '</div>' +
          '<div class="atlc-gallery" data-gallery>' +
            '<div class="atlc-gallery__thumbs" data-galthumbs></div>' +
            '<div class="atlc-gallery__stage">' +
              // ray: tüm görseller yan yana; translateX ile kayar (mobilde parmağı takip eder). İlk görsel hemen, komşular ihtiyaç anında yüklenir.
              '<div class="atlc-gallery__frame" data-galframe><div class="atlc-gallery__track" data-galtrack>' +
                (c.images || []).map(function (src, i) {
                  return '<div class="atlc-gallery__slide"><img class="atlc-gallery__main" data-src="' + esc(src) + '"' + (i === 0 ? ' src="' + esc(src) + '"' : '') + ' alt="' + esc(c.title) + '" draggable="false"></div>';
                }).join('') +
              '</div></div>' +
              '<span class="atlc-gallery__cap" data-galcap></span>' +
              // önceki / sonraki görsel okları (14.10.2026 kullanıcı: arka plansız, yalnız ok; uçlarda başa/sona döner)
              ((c.images || []).length > 1 ?
                '<button type="button" class="atlc-gallery__nav atlc-gallery__nav--prev" data-action="galprev" aria-label="Önceki görsel"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
                '<button type="button" class="atlc-gallery__nav atlc-gallery__nav--next" data-action="galnext" aria-label="Sonraki görsel"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' : '') +
              // indirim etiketi fiyatın yanına taşındı (10.10.2026)
            '</div>' +
          '</div>' +
          '<div class="atlc-main">' +
            '<div class="atlc-breadcrumb">' + crumb + '</div>' +
            '<h1 class="atlc-title">' + esc(c.title) + '</h1>' + (c.kisa ? '<p class="atlc-subtitle">' + esc(c.kisa) + '</p>' : '') + rating + // kısa açıklama (12.10.2026)
            '<div class="atlc-pricerow">' +
              // 20.10.2026 kullanıcı: fiyat + üstü çizili fiyat mavi gri çerçeve içinde (rozet dışarıda)
              '<span class="atlc-pricebox"><span class="atlc-price__now" data-now></span>' +
              '<span class="atlc-price__old" data-old></span></span>' +
              badge +
            '</div>' +
            // taksit notu (10.10.2026, kullanıcı onayı: peşin fiyatına 3 taksit sunuluyor)
            '<div class="atlc-taksit"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2"/><path d="M2.5 9.5h19"/><rect x="5" y="12.5" width="3.6" height="2.8" rx=".5"/><path d="M14 15h4"/></svg><span>2.500 TL üzeri siparişlerde peşin fiyatına 3 taksit</span></div>' +
            this._contentsHtml() +
            '<div class="atlc-rule"></div>' +
            '<div class="atlc-ctop" data-ctop hidden></div>' +
            '<div class="atlc-wizard" data-wizard>' +
              '<div class="atlc-wizard__head">' +
                '<div class="atlc-wizard__headL">' +
                  '<div class="atlc-pershead">' +
                    // 17.10.2026 kullanıcı: kahve kupalarında (rt.noPers) kişiselleştirme yok → "Hediyeni Hazırla", ÜCRETSİZ yok
                    // 20.10.2026 kullanıcı: sihirbazında yazı (baskı) alanı olmayan ürünlerde (kalem, krem, İvory Defter…) → "Hediyeni Tamamla"
                    '<span class="atlc-pershead__title">' + (c.noPers ? 'Hediyenizi Hazırlayın' : noText ? 'Hediyenizi Tamamlayın' : 'Hediyenizi Kişiselleştirin') + '</span>' +
                    ((c.noPers || noText) ? '' : '<span class="atlc-pill-free">ÜCRETSİZ</span>') +
                    // 21.10.2026 kullanıcı: "yaklaşık 1 dakika" ve "İsim baskısı ve renk seçimleri ücretsizdir." kaldırıldı
                  '</div>' +
                  ((c.noPers || noText) ? '<div class="atlc-pershead__sub">' + (c.noPers ? 'Kahve kupalarında kişiselleştirme (isim baskısı) yoktur.' : 'Bu üründe isim baskısı yoktur.') + '</div>' : '') +
                '</div>' +
                // adım sayacı (10.10.2026): "ADIM 1 / 7" — _renderStepper günceller
                '<div class="atlc-wizard__headR"><span class="atlc-stepcount" data-stepcount></span></div>' +
              '</div>' +
              '<div class="atlc-stepper" data-stepper></div>' +
              '<div class="atlc-wizard__rule"></div>' +
              '<div class="atlc-wizard__body">' +
                '<div class="atlc-step-body" data-body></div>' +
                '<div class="atlc-nav" data-nav>' +
                  '<button type="button" class="atlc-back" data-action="prev">← GERİ</button>' +
                  '<button type="button" class="atlc-next" data-action="next">DEVAM</button>' +
                '</div>' +
                // isim girilmemiş ve baskı isteğe bağlıysa: tek dokunuşla baskısız ilerle (11.10.2026)
                '<button type="button" class="atlc-skipnext" data-action="skipnext" hidden>Baskısız devam et →</button>' +
                this._notifyHtml() +
                this._advisorHtml() +
              '</div>' +
            '</div>' +
            '<div class="atlc-ship" data-ship></div>' +
            '<div class="atlc-setrecs" data-setrecs hidden></div>' + // set önerisi (12.10.2026)
            '<div class="atlc-delivery atlc-delivery--tl" data-delivery><div data-eta></div></div>' +
            this._boxMakeHtml() +
            this._b2bHtml() +
            '<div class="atlc-err" data-err role="status" aria-live="polite"></div>' +
            '<div class="atlc-accordions" data-accordions></div>' +
            this._trustHtml() +
          '</div>' +
        '</div>' +
        '</div>' +
        '<div class="atlc-recs" data-recs style="display:none">' +
          '<h2 class="atlc-recs__title">Bunları da beğenebilirsiniz</h2>' +
          '<div class="atlc-recs__row" data-recs-row></div>' +
        '</div>' +
        '<div class="atlc-sticky" data-sticky>' +
          '<div class="atlc-sticky__info"><div class="lbl">TOPLAM</div><div class="val" data-total-m></div></div>' +
          '<button type="button" class="atlc-add atlc-add--sticky" data-action="stickycta"></button>' +
        '</div>' +
        '<div class="atlc-modelpop" data-modelpop aria-hidden="true"><div class="atlc-modelpop__img" data-modelpop-img></div><div class="atlc-modelpop__cap" data-modelpop-cap></div></div>' +
        '<div class="atlc-strappop" data-strappop aria-hidden="true"><div class="atlc-strappop__strip" data-strappop-strip><div class="atlc-strappop__text" data-strappop-text></div></div><div class="atlc-strappop__cap">Baskı önizleme</div></div>';

      this.$ = {
        galFrame: this.querySelector('[data-galframe]'),
        galTrack: this.querySelector('[data-galtrack]'),
        galThumbs: this.querySelector('[data-galthumbs]'),
        galCap: this.querySelector('[data-galcap]'),
        now: this.querySelector('[data-now]'),
        old: this.querySelector('[data-old]'),
        save: this.querySelector('[data-save]'),
        stepper: this.querySelector('[data-stepper]'),
        body: this.querySelector('[data-body]'),
        nav: this.querySelector('[data-nav]'),
        next: this.querySelector('.atlc-next'),
        skipNext: this.querySelector('.atlc-skipnext'),
        back: this.querySelector('.atlc-back'),
        delivery: this.querySelector('[data-delivery]'),
        ship: this.querySelector('[data-ship]'),
        eta: this.querySelector('[data-eta]'),
        totalM: this.querySelector('[data-total-m]'),
        err: this.querySelector('[data-err]'),
        accordions: this.querySelector('[data-accordions]'),
        sticky: this.querySelector('[data-sticky]'),
        stickyBtn: this.querySelector('[data-action="stickycta"]'),
        modelpop: this.querySelector('[data-modelpop]'),
        modelpopImg: this.querySelector('[data-modelpop-img]'),
        modelpopCap: this.querySelector('[data-modelpop-cap]'),
        strappop: this.querySelector('[data-strappop]'),
        strappopStrip: this.querySelector('[data-strappop-strip]'),
        strappopText: this.querySelector('[data-strappop-text]'),
        wizard: this.querySelector('[data-wizard]'),
        stepcount: this.querySelector('[data-stepcount]')
      };
      // mobil sabit çubuk (10.10.2026): panel ekranda değilken düğme "KİŞİSELLEŞTİR" olur ve panele kaydırır
      var selfW = this;
      if (this.$.wizard && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var off = !(en[0].isIntersecting && en[0].intersectionRatio >= 0.1); // panel ekranın üst %70'inde en az %10 görünmeli
          if (off !== selfW._wizOff) { selfW._wizOff = off; if (selfW.steps) selfW._renderNav(); }
        }, { threshold: [0, 0.1, 0.2, 0.5], rootMargin: '0px 0px -30% 0px' }).observe(this.$.wizard);
      }
      // çerçeve oranı ilk görselden (tüm slaytlar aynı kutuya oturur -> görsel değişince yükseklik zıplamaz)
      var fr = this.$.galFrame, first = this.$.galTrack && this.$.galTrack.querySelector('img');
      if (fr && first) {
        var setAr = function () { if (first.naturalWidth && first.naturalHeight) fr.style.setProperty('--atlc-gal-ar', first.naturalWidth + ' / ' + first.naturalHeight); };
        if (first.complete && first.naturalWidth) setAr(); else first.addEventListener('load', setAr, { once: true });
      }
      this._renderInfo();
    }

    /* ---------- olaylar (delege) ---------- */
    _bind() {
      this.addEventListener('click', (e) => {
        // ana görsele tıklayınca yakından inceleme (14.10.2026 kullanıcı); kaydırma (swipe) sonrası gelen tıklama sayılmaz
        var gf = e.target.closest && e.target.closest('.atlc-gallery__frame');
        if (gf && this.contains(gf) && !(this._swipeT && Date.now() - this._swipeT < 450)) return this.openLightbox(this._galCur || 0);
        var t = e.target.closest('[data-action]');
        if (!t || !this.contains(t)) return;
        var a = t.getAttribute('data-action');
        if (a === 'step') return this.goStep(+t.getAttribute('data-step'));
        if (a === 'prev') return this.goBack();
        if (a === 'next') return this.goNext();
        // 20.10.2026 kullanıcı: telefonda renk seçilince ekran yukarı, görsele çıksın (ürünün kendi rengi: üstteki renk kutucukları
        // ya da varyant renk kutucuğu; setlerin parça renklerinde kaymaz). Renk ayrı üründe (nav) _swapColor yeni bölümde tamamlar.
        // 21.10.2026 kullanıcı: YALNIZ üstteki "Renk seçin" (data-ctop); sihirbaz adımlarındaki kutucuklar (renk dahil, ör. isimlik
        // Küçük/Büyük) sayfayı hiçbir yere kaydırmaz — müşteri sihirbazda kalır.
        // 21.10.2026 kullanıcı (sonra): "renk değişimde tüm ürünlerdeki yukarı atlamaları kapatalım; görseller renge göre değişsin
        // ama yukarı atmasın" → COLOR_SCROLL=false; galeri renge göre değişmeye devam eder, sayfa yerinde kalır.
        var COLOR_SCROLL = false;
        if (COLOR_SCROLL && (a === 'pick' || a === 'vopt') && !this.rt.isSet && t.closest('[data-ctop]') &&
            window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
          SWAP.galWant = Date.now();
          var gme = this;
          setTimeout(function () { if (gme.isConnected) gme._scrollToGallery(true); }, 60);
        }
        if (a === 'pick') {
          var pp = t.getAttribute('data-prop'), pv = t.getAttribute('data-val');
          // 18.10.2026 kullanıcı: cüzdanlarda "harf baskısı ister misiniz"de Hayır'a basınca da baskısız onayı (sayfada bir kez)
          if (!this._skipAsked && tv(pv) === 'Hayır') {
            var pf = this.fieldsFlat.filter(function (f) { return f.prop === pp; })[0], me = this;
            if (pf && this._isPrintChoice(pf)) return this._skipConfirm(function () { me.setVal(pp, pv); }, null, function () { me._addPrint(pf); });
          }
          return this.setVal(pp, pv);
        }
        if (a === 'vopt') return this.setVariantOpt(+t.getAttribute('data-dim'), t.getAttribute('data-val'));
        if (a === 'skip') return this.toggleSkip(t.getAttribute('data-gate'));
        if (a === 'skipnext') return this.skipAndNext();
        if (a === 'gate') return this.toggleGate(t.getAttribute('data-prop'));
        if (a === 'addonpick') return this.addonPick(t.getAttribute('data-prop'), t.getAttribute('data-dep'), t.getAttribute('data-val'));
        if (a === 'copy') return this.copyKupa();
        if (a === 'thumb') return this.setGallery(+t.getAttribute('data-idx'));
        if (a === 'galprev') return this.galStep(-1);
        if (a === 'galnext') return this.galStep(1);
        if (a === 'qtyminus') return this.setQty(-1);
        if (a === 'qtyplus') return this.setQty(1);
        if (a === 'tab') return this.setTab(+t.getAttribute('data-idx'));
        if (a === 'xacc') return this._toggleAcc(t);
        if (a === 'reviews') return this.scrollReviews();
        if (a === 'cart') return this.addToCart();
        if (a === 'stickycta') return this.stickyCta();
        if (a === 'retry') return this.retryLoad();
        if (a === 'notifyopen') return this.openNotify(true);
      });
      // "Gelince haber ver" formu (Enter da gönderir); STOQ yapılandırması sayfa sonunda gelirse düğme o zaman görünür
      this.addEventListener('submit', (e) => {
        var f = e.target.closest && e.target.closest('[data-notify-form]');
        if (!f || !this.contains(f)) return;
        e.preventDefault();
        this.sendNotify(f);
      });
      if (!stoqCfg()) window.addEventListener('load', () => { if (this.steps) this._renderNav(); }, { once: true });
      // galeri swipe (mobil): ray parmağı TAKİP EDER (is-dragging: geçiş kapalı), bırakınca
      // eşik/hız kararıyla en yakın görsele yumuşak oturur; uçlarda direnç. Dikey kaydırma bozulmaz (pan-y).
      var _g = null;
      this.addEventListener('touchstart', (e) => {
        _g = null;
        if (!e.target.closest || !e.target.closest('.atlc-gallery__stage')) return;
        var tr = this.$.galTrack; if (!tr || tr.children.length < 2) return;
        _g = { x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, dir: null, w: tr.clientWidth || 1, t: Date.now() };
      }, { passive: true });
      this.addEventListener('touchmove', (e) => {
        if (!_g) return;
        var dx = e.touches[0].clientX - _g.x, dy = e.touches[0].clientY - _g.y;
        if (_g.dir === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          _g.dir = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (_g.dir === 'x') this.$.galTrack.classList.add('is-dragging');
        }
        if (_g.dir !== 'x') return;
        var cur = this._galCur || 0, n = this.$.galTrack.children.length;
        if ((cur === 0 && dx > 0) || (cur === n - 1 && dx < 0)) dx *= 0.35;
        _g.dx = dx;
        this.$.galTrack.style.transform = 'translate3d(calc(' + (-cur * 100) + '% + ' + dx.toFixed(1) + 'px),0,0)';
      }, { passive: true });
      this.addEventListener('touchend', () => {
        if (!_g) return;
        var g = _g; _g = null;
        if (g.dir !== 'x') return;
        this._swipeT = Date.now();
        var cur = this._galCur || 0, n = this.$.galTrack.children.length;
        var fast = (Date.now() - g.t) < 320 && Math.abs(g.dx) > 24;
        var nx = cur;
        if (g.dx < -g.w * 0.2 || (fast && g.dx < 0)) nx = cur + 1;
        else if (g.dx > g.w * 0.2 || (fast && g.dx > 0)) nx = cur - 1;
        nx = Math.max(0, Math.min(n - 1, nx));
        if (nx !== cur) this.setGallery(nx); // gerçekten kaydıysa elle seçim (chip gizlenir)
        else this._galGo(cur);              // eşik altı: yerine oturur, seçim değişmez
      });
      this.addEventListener('touchcancel', () => { if (_g) { _g = null; this._galGo(this._galCur || 0); } });
      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-wizard] [data-action]')) this._funnelStart();
      }, true);
      this.addEventListener('focusout', (e) => {
        var t = e.target;
        if (!t.matches('[data-text]') || !tv(t.value)) return;
        var prop = t.getAttribute('data-prop');
        this._funnelCompletedFields = this._funnelCompletedFields || {};
        if (!this._funnelCompletedFields[prop]) {
          this._funnelCompletedFields[prop] = true;
          this._funnel('personalization_input_complete', { field_id: prop });
        }
      });
      this.addEventListener('input', (e) => {
        var t = e.target;
        if (t.matches('[data-persdemo]')) {
          var pv = t.value.slice(0, 12);
          if (t.value !== pv) t.value = pv;
          this.state.persText = pv;
          this._updateStrap('persdemo', pv, false);
          var pm = t.parentNode && t.parentNode.querySelector('.atlc-eng__count');
          if (pm) pm.textContent = trUpper(pv).length + ' / 12';
          return;
        }
        if (!t.matches('[data-text]')) return;
        var prop = t.getAttribute('data-prop');
        var max = +t.getAttribute('maxlength') || 20;
        // baskı kuralları (12.10.2026, kullanıcı): harf (Türkçe dâhil), rakam, boşluk ve ! , . # + & / ( ) = ? _ - * " ♥ ∞ — başka simge/emoji girilemez.
        // telefon klavyesinin kalp emojileri (❤ ❤️ ♡ 🤍 🖤) baskıdaki ♥ işaretine çevrilir
        var v = t.value.replace(/\u2764\uFE0F?|\u2661|\uD83E\uDD0D|\uD83D\uDDA4/g, '\u2665').replace(/\uFE0F/g, '')
          .replace(/[^0-9A-Za-zÇĞİÖŞÜçğıöşü !,.#+&\/()=?_\-*"\u2665\u221E]/g, '').replace(/ {2,}/g, ' ').slice(0, max);
        if (t.value !== v) t.value = v;
        this.state.txts[prop] = v; this.state.added = false;
        if (tv(v)) {
          this._funnelStart();
          this._funnelStartedFields = this._funnelStartedFields || {};
          if (!this._funnelStartedFields[prop]) {
            this._funnelStartedFields[prop] = true;
            this._funnel('personalization_input_start', { field_id: prop });
          }
        }
        this._updateStrap(prop, v, false);
        var meta = t.closest('.atlc-eng') && t.closest('.atlc-eng').querySelector('.atlc-eng__count');
        if (meta) { meta.textContent = trUpper(v).length + ' / ' + max; meta.classList.toggle('is-over', v.length >= (max - 1)); }
        this._renderTotals();
        this._renderNav();
        this._renderCart();
      });
      // model fotoğrafı popup: hover (masaüstü); strap şeridi hover -> temiz kesit
      this.addEventListener('mouseover', (e) => {
        var c = e.target.closest('[data-pop]');
        if (c && this.contains(c)) this._showModelPop(c);
        var s = e.target.closest('.atlc-strap');
        if (s && this.contains(s)) this._showStrapPop(s);
      });
      this.addEventListener('mouseout', (e) => {
        if (e.target.closest('[data-pop]')) this._hideModelPop();
        if (e.target.closest('.atlc-strap')) this._hideStrapPop();
      });
      this.addEventListener('click', (e) => {
        var s = e.target.closest('.atlc-strap');
        if (s && this.contains(s)) this._showStrapPop(s);
      });
      // 17.10.2026 kullanıcı: "mobilde fotoğrafın üzerine gelince hover özelliği yok mu? tüm ürünlerde aç" → dokunmatikte kutucuğa
      // dokununca büyük fotoğraf (seçim de yapılır); 2,5 sn sonra, kaydırınca ya da başka yere dokununca kapanır. mouseover yerine click:
      // iPhone'da üzerine gelmede içerik değişirse ilk dokunuş yutulur (seçim için iki dokunuş gerekirdi). Seçimle kart yeniden çizilirse
      // aynı fotoğraflı yeni kart bulunur.
      this.addEventListener('click', (e) => {
        // 21.10.2026 kullanıcı: "mobilde sihirbaz içindeki ürünlere tıklayınca büyümesin (birlikte al, özelleştirme, tüm setler)"
        // → dokunmatikte büyük fotoğraf KAPALI; dokunuş yalnız seçim yapar. Masaüstü üzerine gelme (mouseover) aynen. Geri açmak: TAP_POP = true
        var TAP_POP = false;
        if (!TAP_POP || !noHover()) return;
        var c = e.target.closest('[data-pop]');
        if (!c || !this.contains(c)) return;
        var url = c.getAttribute('data-pop');
        setTimeout(() => {
          var el = c.isConnected ? c : Array.prototype.find.call(this.querySelectorAll('[data-pop]'), function (x) { return x.getAttribute('data-pop') === url; });
          if (el) this._showModelPop(el, true);
        }, 0);
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-pop]') && !e.target.closest('[data-modelpop]')) this._hideModelPop();
        if (!e.target.closest('.atlc-strap') && !e.target.closest('[data-strappop]')) this._hideStrapPop();
      });
      window.addEventListener('scroll', () => { this._hideModelPop(); this._hideStrapPop(); }, { passive: true });
    }

    /* ---------- model fotoğrafı popup (koyu kart — v2) ---------- */
    _showModelPop(card, touch) {
      if (noHover() && !touch) return; // dokunmatikte üzerine gelme yok; dokununca açılır (17.10.2026, yukarıdaki click)
      clearTimeout(this._popT);
      if (touch) this._popT = setTimeout(() => this._hideModelPop(), 2500);
      if (!card || !this.$ || !this.$.modelpop) return;
      var url = card.getAttribute('data-pop');
      if (!url) return;
      var pop = this.$.modelpop;
      this.$.modelpopImg.style.backgroundImage = "url('" + url + "')";
      if (this.$.modelpopCap) this.$.modelpopCap.textContent = card.getAttribute('data-pop-name') || '';
      // renk büyütmesi her zaman beyaz zeminde (14.10.2026 kullanıcı: "siyahta renkler karışıyor")
      pop.classList.toggle('is-light', card.classList.contains('atlc-tile--vcolor') || card.classList.contains('atlc-tile--color') || card.classList.contains('atlc-sw') ||
        card.classList.contains('atlc-addon__row') || /\.png(\?|$)|renk-|dekupe/i.test(url)); // dekupe görsel her zaman beyaz zeminde
      pop.classList.add('is-on');
      pop.setAttribute('aria-hidden', 'false');
      var r = card.getBoundingClientRect();
      var pw = pop.offsetWidth, ph = pop.offsetHeight;
      var left = Math.max(8, Math.min(r.left, window.innerWidth - pw - 8));
      var top = r.bottom + 9;
      if (top + ph > window.innerHeight - 8) top = r.top - ph - 9;
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    }
    _hideModelPop() {
      if (this.$ && this.$.modelpop) { this.$.modelpop.classList.remove('is-on'); this.$.modelpop.setAttribute('aria-hidden', 'true'); }
    }

    /* ---------- deri şerit kesit popup ---------- */
    _showStrapPop(strapEl) {
      if (!strapEl || !this.$ || !this.$.strappop || !this.rt.leatherStripCut) return;
      var txtEl = strapEl.querySelector('.atlc-strap__text');
      if (!txtEl) return;
      var pop = this.$.strappop;
      this.$.strappopStrip.style.backgroundImage = "url('" + this.rt.leatherStripCut + "')";
      this.$.strappopText.textContent = txtEl.textContent;
      var faded = /is-empty|is-skip/.test(txtEl.className);
      this.$.strappopText.className = 'atlc-strappop__text' + (faded ? ' is-faded' : '');
      this.$.strappopText.style.fontSize = '';
      pop.classList.add('is-on');
      pop.setAttribute('aria-hidden', 'false');
      this._fitStrap(this.$.strappopText);
      var r = strapEl.getBoundingClientRect();
      var pw = pop.offsetWidth, ph = pop.offsetHeight;
      var left = Math.max(8, Math.min(r.left + r.width / 2 - pw / 2, window.innerWidth - pw - 8));
      var top = r.top - ph - 10;
      if (top < 8) top = r.bottom + 10;
      pop.style.left = left + 'px';
      pop.style.top = top + 'px';
    }
    _hideStrapPop() {
      if (this.$ && this.$.strappop) { this.$.strappop.classList.remove('is-on'); this.$.strappop.setAttribute('aria-hidden', 'true'); }
    }

    /* ---------- state ---------- */
    goStep(i) {
      var n = Math.max(0, Math.min(this.lastStep, i));
      this.state.step = n; this.state.added = false; this.state.galIdx = null;
      if ((this.steps[n] || {}).kind === 'summary') this.state.sawSummary = true; // 13.10.2026: özetten dönüşte adım adım gezdirme
      this._track('wizard_step', { step: n, kind: (this.steps[n] || {}).kind, label: (this.steps[n] || {}).label });
      this._funnel('personalization_step_view');
      if ((this.steps[n] || {}).kind === 'summary') this._funnel('personalization_summary_view');
      this._hideModelPop(); this._hideStrapPop();
      this.update();
      this._scrollToStep();
    }
    // Yalnız başlık ekran dışındaysa kaydır (görünürdeyse DOKUNMA — her adımda
    // koşulsuz kaydırma, galeri foto değişimiyle birleşince mobilde titremeye
    // yol açıyordu). scrollIntoView değil window.scrollTo (README kuralı).
    _scrollToStep() {
      // 21.10.2026 kullanıcı: "yukarı atmaları iptal et, devama basınca yukarı atıyor" → telefonda, ardından "masaüstünde de
      // kaymasın" → adım değişince sayfa HİÇBİR cihazda kaymaz. Geri açmak: STEP_SCROLL = true
      var STEP_SCROLL = false;
      // 21.10.2026 kullanıcı (telefon): "devam dediğimizde Hediyenizi Kişiselleştirin kısmı ekranın tepesine gelsin, sabit kalınca zor oluyor"
      // → telefonda sihirbaz kartının üstü sabit header'ın hemen altına hizalanır; masaüstünde kaydırma yok (STEP_SCROLL).
      if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
        var wz = this.querySelector('.atlc-wizard');
        if (!wz) return;
        var woff = 8, whdr = document.getElementById('AtlHeader');
        if (whdr) { var whr = whdr.getBoundingClientRect(); if (whr.bottom > 0 && whr.top <= 1) woff += whr.bottom; }
        var wy = Math.max(0, wz.getBoundingClientRect().top + window.pageYOffset - woff);
        if (Math.abs(window.pageYOffset - wy) < 4) return;
        try { window.scrollTo({ top: wy, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, wy); }
        return;
      }
      if (!STEP_SCROLL) return;
      // hedef: FİYAT satırı ekranın 16px altında → fiyat + sihirbaz kartı görünür, ürün adı yarım kalmaz.
      // Header gerçekten sabitse (kaydırınca görünür kalıyorsa) onun yüksekliği kadar ek pay.
      var el = this.querySelector('.atlc-pricerow') || this.querySelector('.atlc-wizard') || this;
      if (!el) return;
      var off = 16, hdr = document.getElementById('AtlHeader');
      if (hdr) {
        var hr = hdr.getBoundingClientRect();
        if (window.scrollY > hdr.offsetHeight && hr.top >= 0 && hr.bottom > 0) off += hr.bottom;
      }
      var r = el.getBoundingClientRect();
      if (r.top >= off && r.top <= off + 140) return;
      var y = r.top + window.scrollY - off;
      try { window.scrollTo({ top: y, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, y); }
    }
    goNext() {
      var cur = this.steps[this.state.step];
      if (cur && cur.kind === 'variant' && this.soldOut()) { this._renderNav(); return; }
      var miss = this.missingIn(this.state.step);
      if (miss.length) { this._funnel('personalization_validation_error', { reason: 'required_text', missing_count: miss.length }); this._focusField(miss[0]); this.state.tried = true; this.update(); return; }
      // 18.10.2026 kullanıcı: cüzdanlarda "Harf Baskısı İsteği: Hayır" ile sonraki adıma geçerken de baskısız onayı sorulur
      var np = this._skipAsked ? null : this._noPrintPick(this.state.step);
      if (np) { var me = this; return this._skipConfirm(function () { me.goNext(); }, null, function () { me._addPrint(np); }); }
      this._funnel('personalization_step_complete');
      // özete bir kez gelinmişse (ör. "İSMİNİ GİR" ile geri dönüldü): sıradaki adım yerine kalan ilk eksik alana, eksik yoksa özete
      if (this.state.sawSummary) {
        var all = this.missingAll(), si = this.steps.findIndex(function (x) { return x.kind === 'summary'; });
        var target = all.length ? all[0]._step : si;
        if (target >= 0 && target !== this.state.step) return this.goStep(target);
      }
      this.goStep(this.state.step + 1);
    }
    goBack() { this.goStep(this.state.step - 1); }
    // renk adımı (nav: true, değerlerde h = ürün handle'ı): başka renk seçilince o rengin ürün sayfasına geçilir,
    // seçimler sessionStorage ile taşınır (13.10.2026 kullanıcı: emaye kupalarda kupa modelinden önce renk adımı)
    /* sepetten düzenleme (18.10.2026 kullanıcı: "kişi sepete geldiğinde üründe bir kişiselleştirmeyi değiştirmek isterse değiştiremiyor"):
       sepetteki "Kişiselleştirmeyi düzenle" → ürün sayfası ?duzenle=<satır anahtarı>. Sihirbaz satırın özelliklerinden dolar, ÖZET'te açılır;
       düğme "SEPETİ GÜNCELLE": önce yeni set eklenir, sonra eski set (aynı _set_id'li satırlar) sepetten çıkarılır. */
    _cartRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    _maybeEdit() {
      var key = null;
      try { key = new URLSearchParams(window.location.search).get('duzenle'); } catch (e) { key = null; }
      if (!key || this._editTried === key) return;
      this._editTried = key;
      var self = this;
      fetch(this._cartRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var it = (cart.items || []).filter(function (x) { return x.key === key; })[0];
          if (!it || hnorm(it.handle) !== hnorm(self.rt.handle)) return;
          self._edit = { key: key, setId: (it.properties || {})._set_id || null };
          // bağlı ürün satırlarının (ör. 2. orta deri) özellikleri: aynı setin diğer satırlarından
          var lp = {};
          if (self._edit.setId) (cart.items || []).forEach(function (x) {
            var p = x.properties || {};
            if (x.key === key || p._set_id !== self._edit.setId) return;
            Object.keys(p).forEach(function (k) { if (!(k in lp)) lp[k] = p[k]; });
          });
          self._restoreFromProps(it.properties || {}, lp);
          var v = (self.rt.variants || []).filter(function (x) { return x.id === it.variant_id; })[0];
          if (v && v.options) self.state.optSel = v.options.slice();
          self._syncVarField();
          self.state.qty = it.quantity || 1;
          self.goStep(self.lastStep);
        })
        .catch(function () {});
    }
    _restoreFromProps(p, lp) {
      var s = this.state; lp = lp || {};
      this.fieldsFlat.forEach(function (f) {
        if (f.nav || f.linkOnly) return;
        var src = f.forLink ? lp : p; // bağlı ürün alanları kendi satırına yazılmıştı (_linkProps)
        if (f.kind === 'choice') {
          var k = f.forLink ? (f.linkName || f.prop) : (isYesNo(f) ? ((f.prop.charAt(0) === '_' ? '' : '_') + f.prop) : (f.propAlias || f.prop));
          var v = src[k];
          if (v == null || v === '') return;
          if (isYesNo(f) || (f.values || []).some(function (x) { return tv(x.v) === tv(v); })) s.vals[f.prop] = v;
        } else {
          if (f.gate) {
            var g = src['_' + (f.forLink ? (f.gate.linkName || f.gate.prop) : f.gate.prop)];
            if (g != null) { var off = tv(g) === tv(f.gate.no || 'Hayır'); s.skips[f.gate.prop] = off; s.vals[f.gate.prop] = off ? 'Hayır' : 'Evet'; }
          }
          var tk = f.forLink ? (f.linkName || f.prop) : f.prop;
          if (src[tk] != null) s.txts[f.prop] = src[tk];
        }
      });
    }
    // yeni set eklendikten sonra eski seti sepetten çıkarır; çekmece için güncel bölümleri döndürür
    _removeEditLines() {
      var ed = this._edit, root = this._cartRoot();
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var up = {};
          (cart.items || []).forEach(function (x) {
            var p = x.properties || {};
            if (x.key === ed.key || (ed.setId && p._set_id === ed.setId)) up[x.key] = 0;
          });
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: up, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
          }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Sepet güncellenemedi.'); return d; }); });
        });
    }
    _restoreCarry() {
      var c = null;
      try { c = JSON.parse(sessionStorage.getItem('atlcCarry') || 'null'); } catch (e) { c = null; }
      if (!c || c.to !== hnorm(this.rt.handle) || Date.now() - (c.t || 0) > 600000) return;
      try { sessionStorage.removeItem('atlcCarry'); } catch (e) {}
      var s = this.state;
      this.fieldsFlat.forEach(function (f) {
        if (f.nav) return;
        if (f.kind === 'choice') {
          var v = c.vals && c.vals[f.prop];
          if (v != null && (isYesNo(f) || (f.values || []).some(function (x) { return tv(x.v) === tv(v); }))) s.vals[f.prop] = v;
        } else {
          if (c.txts && c.txts[f.prop] != null) s.txts[f.prop] = c.txts[f.prop];
          if (f.gate && c.skips && c.skips[f.gate.prop] != null) s.skips[f.gate.prop] = c.skips[f.gate.prop];
        }
      });
      s.step = Math.max(0, Math.min(c.step || 0, this.lastStep));
      s.qty = c.qty || 1;
    }
    /* renk geçişi (14.10.2026 kullanıcı: "renk geçişinde sayfa geçişi uzun sürüyor, önce aşağısı görünüp sonra yukarı atıyor"):
       sayfa yeniden yüklenmez — hedef rengin ürün bölümleri (Section Rendering API, ?sections=) yerinde değiştirilir,
       adres replaceState ile güncellenir (geri tuşu renkler arasında gezmez). Renk adımı açılınca diğer renkler arka planda
       önceden alınır (bölümler + sihirbaz verisi) → tıklayınca anında. Bir şey ters giderse eski yol: tam sayfa geçişi. */
    _mainSectionIds() {
      return Array.prototype.map.call(document.querySelectorAll('main [id^="shopify-section-"]'), function (s) { return s.id.replace(/^shopify-section-/, ''); }).slice(0, 5);
    }
    _prefetchColor(h) {
      var key = hnorm(h);
      if (SWAP.sec[key]) return SWAP.sec[key];
      var ids = this._mainSectionIds();
      if (!ids.length || !window.fetch || !window.Promise) return null;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var p = fetch(root + 'products/' + encodeURIComponent(h) + '?sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var html = '';
          Object.keys(j || {}).forEach(function (k) { if (j[k] && j[k].indexOf('<atlanticus-customizer') > -1) html = j[k]; });
          if (!html) throw new Error('sihirbaz bölümü yok');
          var tp = document.createElement('template'); tp.innerHTML = html;
          var sEl = tp.content.querySelector('script.atlc-structure'), rEl = tp.content.querySelector('script.atlc-runtime'), st = null;
          try { st = JSON.parse(sEl.textContent); } catch (e) {}
          try { SWAP.rt[key] = JSON.parse(rEl.textContent); } catch (e) {}
          if (st && st.src && !SWAP.struct[st.src]) {
            return fetch(st.src).then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (tx) { if (tx) SWAP.struct[st.src] = tx; return j; }, function () { return j; });
          }
          return j;
        });
      SWAP.sec[key] = p;
      p.catch(function () { if (SWAP.sec[key] === p) delete SWAP.sec[key]; });
      return p;
    }
    // renk alanı ekrandaysa (kupa adımı) diğer renkleri boşta önceden al; bir kez
    _prefetchColors() {
      if (this._pfDone || !this.state) return;
      var self = this, nf = this._ctopNav || this.stepFields(this.state.step).filter(function (f) { return f.nav; })[0];
      if (!nf || !this.closest('[id^="shopify-section-"]')) return;
      this._pfDone = true;
      var run = function () {
        self._prefetchColor(self.rt.handle); // şimdiki ürün de: aynı kalan bölümlere dokunulmasın
        (nf.values || []).forEach(function (v) { if (v.h && hnorm(v.h) !== hnorm(self.rt.handle)) self._prefetchColor(v.h); });
      };
      if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 2000 }); else setTimeout(run, 800);
    }
    // hedef rengin ilk görseli yüklensin (en çok ms) → yeni galeri boş görünmez
    _imgReady(rt, ms) {
      var u = rt && rt.images && rt.images[0];
      if (!u) return Promise.resolve();
      return new Promise(function (res) {
        var im = new Image(), tm = setTimeout(res, ms);
        im.onload = im.onerror = function () { clearTimeout(tm); res(); };
        im.src = u;
      });
    }
    // 20.10.2026 kullanıcı: telefonda renk seçince galerinin üstü, sabit header'ın hemen altına gelir (window.scrollTo — README kuralı)
    _scrollToGallery(smooth) {
      var g = this.querySelector('[data-gallery]');
      if (!g) return;
      var off = 8, hdr = document.getElementById('AtlHeader');
      if (hdr) { var hr = hdr.getBoundingClientRect(); if (hr.bottom > 0 && hr.top <= 0 + 1) off += hr.bottom; }
      var y = Math.max(0, g.getBoundingClientRect().top + window.pageYOffset - off);
      if (Math.abs(window.pageYOffset - y) < 4) return;
      try { window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { window.scrollTo(0, y); }
    }
    _swapColor(h) {
      var self = this, key = hnorm(h);
      var sec = this.closest('[id^="shopify-section-"]');
      if (!sec || !window.history || !history.replaceState) return false;
      var p = this._prefetchColor(h);
      if (!p) return false;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = root + 'products/' + encodeURIComponent(h);
      var settled = false;
      var bail = function () { if (settled) return; settled = true; location.href = url; };
      var guard = setTimeout(bail, 6000);
      this.classList.add('is-swapping');
      var cur = (SWAP.sec[hnorm(this.rt.handle)] || Promise.resolve(null)).catch(function () { return null; });
      Promise.all([p, cur]).then(function (res) {
        return self._imgReady(SWAP.rt[key], 700).then(function () { return res; });
      }).then(function (res) {
        if (settled) return;
        var j = res[0] || {}, old = res[1] || {};
        var sid = sec.id.replace(/^shopify-section-/, '');
        if (!j[sid] || j[sid].indexOf('<atlanticus-customizer') < 0) { bail(); return; }
        settled = true; clearTimeout(guard);
        var y = window.pageYOffset;
        sec.style.minHeight = sec.offsetHeight + 'px'; // yeni sihirbaz kurulurken yükseklik oynamasın
        swapSection(sec, j[sid]);
        // ürüne özel diğer bölümler (hikâye, yorumlar…): yalnız içeriği değiştiyse
        Object.keys(j).forEach(function (id) {
          if (id === sid || !j[id] || (old[id] && old[id] === j[id])) return;
          var el = document.getElementById('shopify-section-' + id);
          if (el) swapSection(el, j[id]);
        });
        try { history.replaceState(history.state, '', url); } catch (e) {}
        var nt = SWAP.rt[key] && SWAP.rt[key].title;
        if (nt) { var parts = document.title.split(' – '); document.title = nt + (parts.length > 1 ? ' – ' + parts[parts.length - 1] : ''); }
        var ncz = sec.querySelector('atlanticus-customizer');
        if (SWAP.galWant && Date.now() - SWAP.galWant < 8000 && ncz && ncz._scrollToGallery) { SWAP.galWant = 0; ncz._scrollToGallery(false); }
        else if (Math.abs(window.pageYOffset - y) > 1) window.scrollTo(0, y);
        var nim = sec.querySelector('.atlc-gallery__main'), freed = false;
        var free = function () { if (freed) return; freed = true; sec.style.minHeight = ''; };
        if (nim && !(nim.complete && nim.naturalWidth)) { nim.addEventListener('load', free, { once: true }); nim.addEventListener('error', free, { once: true }); setTimeout(free, 1500); }
        else requestAnimationFrame(function () { requestAnimationFrame(free); });
      }).catch(bail);
      return true;
    }
    setVal(prop, val) {
      // 17.10.2026 kullanıcı: "birlikte al ürünlerini üzerine bir daha basınca seçimi iptal etsin" — EKSTRA adımında bir eklentiye bağlı
      // seçili kutucuğa (krem, Basis, Clavis rengi, çakmak rengi) yeniden basılırsa eklenti kapanır
      var ex = this.steps.find(function (st) { return st.kind === 'extra'; });
      var df = ex && (ex.fields || []).find(function (f) { return f.prop === prop; });
      var gc = df && (df.showIf || []).find(function (c) { return tv(c.eq) === 'Evet'; });
      if (gc && this._gateOn(gc.p) && tv(this.state.vals[prop]) === tv(val)) {
        this.state.vals[gc.p] = 'Hayır'; this.state.added = false; this.update(); return;
      }
      var nf = this.fieldsFlat.filter(function (f) { return f.prop === prop && f.nav; })[0];
      if (nf) {
        var tgt = (nf.values || []).filter(function (v) { return tv(v.v) === tv(val); })[0];
        if (tgt && tgt.h && hnorm(tgt.h) !== hnorm(this.rt.handle)) {
          var s = this.state;
          try { sessionStorage.setItem('atlcCarry', JSON.stringify({ to: hnorm(tgt.h), t: Date.now(), step: s.step, vals: s.vals, txts: s.txts, skips: s.skips, qty: s.qty })); } catch (e) {}
          s.vals[prop] = val; this.update();
          if (this._swapColor(tgt.h)) return;
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          location.href = root + 'products/' + encodeURIComponent(tgt.h);
          return;
        }
      }
      this.state.vals[prop] = val; this.state.added = false;
      if (prop === this.struct.variantFromField) {
        var pv = this.currentVariant(), p0 = pv && pv.price;
        this._syncVarField();
        var nv = this.currentVariant();
        if (nv && p0 != null && nv.price !== p0) this._priceToast(val, p0, nv.price);
      }
      if (this._galPick(prop) != null) this.state.galIdx = null; // görselli seçim: elle seçilmiş küçük resmi bırak, seçimin fotoğrafına geç
      this._hideModelPop();
      this.update();
    }
    toggleGate(prop) {
      var on = this._gateOn(prop);
      this.state.vals[prop] = on ? 'Hayır' : 'Evet';
      this.state.added = false;
      this.update();
      if (!on) {
        // açıldıysa ilk bağlı metne odaklan
        var dep = this.fieldsFlat.find(function (f) {
          return f.kind === 'text' && (f.showIf || []).some(function (c) { return c.p === prop && tv(c.eq) === 'Evet'; });
        });
        if (dep) this._focusField(dep);
      }
    }
    // kutucuklu eklenti (pick:true, ör. KESE): renge basınca eklenir, seçili renge yeniden basınca çıkar
    addonPick(gate, dep, val) {
      var s = this.state;
      if (this._gateOn(gate) && tv(s.vals[dep]) === tv(val)) s.vals[gate] = 'Hayır';
      else { s.vals[gate] = 'Evet'; s.vals[dep] = val; }
      s.added = false;
      this._hideModelPop();
      this.update();
    }
    // "Baskısız devam et": adımdaki eksik (isteğe bağlı) baskıları atla, sonraki adıma geç
    /* 18.10.2026 kullanıcı (B seçeneği): müşteri baskısız geçmek isteyince bir kez sor — "Hediyeni isme özel yapmak ister misin? / İsim baskısı ücretsiz."
       ÜCRETSİZ EKLE → pencere kapanır, isim alanına odak; Baskısız devam et → işlem sürer ve bu sayfada bir daha sorulmaz. */
    // adımda "…Baskı… İsteği" türü seçim "Hayır"da mı (bağlı harf alanı olan; Birlikte Al eklentileri hariç)
    _noPrintPick(si) {
      var sd = this.steps[si], self = this;
      if (!sd || sd.kind === 'extra' || sd.kind === 'summary' || sd.kind === 'variant' || sd.kind === 'box') return null;
      return (sd.fields || []).filter(function (f) { return tv(self.state.vals[f.prop]) === 'Hayır' && self._isPrintChoice(f); })[0] || null;
    }
    // baskı isteği seçimi mi: "…Baskı…" adlı, Hayır dışı bir değeri harf alanı açan seçim (Birlikte Al / kutu adımları hariç)
    _isPrintChoice(f) {
      var self = this, sd = this.steps[f._step];
      if (sd && (sd.kind === 'extra' || sd.kind === 'box' || sd.kind === 'summary' || sd.kind === 'variant')) return false;
      if (f.kind !== 'choice' || f.nav || f.forLink || !this.visible(f) || !/bask/i.test(f.prop)) return false;
      return this.fieldsFlat.some(function (t) { return t.kind === 'text' && (t.showIf || []).some(function (c) { return c.p === f.prop && tv(c.eq) !== 'Hayır'; }); });
    }
    // "ÜCRETSİZ EKLE": seçimi ilk baskı seçeneğine al (ör. Ön Yüze İstiyorum / Evet), açılan harf alanına odaklan
    _addPrint(f) {
      var v = (f.values || []).map(function (x) { return x.v; }).filter(function (x) { return tv(x) !== 'Hayır'; })[0];
      if (!v) return;
      this.setVal(f.prop, v);
      var t = this.fieldsFlat.filter(function (x) { return x.kind === 'text' && (x.showIf || []).some(function (c) { return c.p === f.prop && tv(c.eq) === tv(v); }); })[0];
      if (t) this._focusField(t);
    }
    _skipConfirm(onSkip, focusF, onAdd) {
      this._funnel('personalization_skip_prompt_view');
      if (this._skipAsked) return onSkip();
      var self = this, old = document.querySelector('.atlc-skipask'); if (old) old.remove();
      var m = document.createElement('div');
      m.className = 'atlc-skipask';
      m.innerHTML = '<div class="atlc-skipask__card" role="dialog" aria-modal="true" aria-labelledby="atlcSkipAskT">' +
        '<div class="atlc-skipask__t" id="atlcSkipAskT">Hediyenizi isme özel yapmak ister misiniz?</div>' +
        '<p class="atlc-skipask__p">İsim baskısı ücretsiz.</p>' +
        '<button type="button" class="atlc-skipask__add" data-k="add">ÜCRETSİZ EKLEYİN</button>' +
        '<button type="button" class="atlc-skipask__skip" data-k="skip">Baskısız devam et</button></div>';
      var close = function () { m.remove(); document.removeEventListener('keydown', onKey); };
      var add = function () { close(); self._track('engrave_skip_prompt', { choice: 'add' }); if (onAdd) onAdd(); else if (focusF) self._focusField(focusF); };
      var onKey = function (e) { if (e.key === 'Escape') add(); };
      m.addEventListener('click', function (e) {
        var k = e.target.closest('[data-k]');
        if (k && k.getAttribute('data-k') === 'skip') { close(); self._skipAsked = true; self._track('engrave_skip_prompt', { choice: 'skip' }); onSkip(); return; }
        if ((k && k.getAttribute('data-k') === 'add') || e.target === m) add();
      });
      document.addEventListener('keydown', onKey);
      document.body.appendChild(m);
      var b = m.querySelector('.atlc-skipask__add'); if (b) { try { b.focus({ preventScroll: true }); } catch (e) {} }
    }
    skipAndNext() {
      var gm = this.missingIn(this.state.step).filter(function (f) { return f.gate; });
      if (gm.length && !this._skipAsked) return this._skipConfirm(this._skipAndNext.bind(this), gm[0]);
      return this._skipAndNext();
    }
    _skipAndNext() {
      var st = this.state, self = this;
      this.missingIn(st.step).forEach(function (f) {
        if (!f.gate) return;
        st.skips[f.gate.prop] = true; st.vals[f.gate.prop] = 'Hayır';
        self._track('engrave_skipped', { field: f.gate.prop, via: 'skipnext' });
      });
      st.added = false;
      this.update();
      if (!this.missingIn(st.step).length) this.goNext();
    }
    toggleSkip(gateProp) {
      if (!this.state.skips[gateProp] && !this._skipAsked) {
        var ff = this.fieldsFlat.filter(function (f) { return f.gate && f.gate.prop === gateProp; })[0];
        return this._skipConfirm(this._toggleSkip.bind(this, gateProp), ff);
      }
      return this._toggleSkip(gateProp);
    }
    _toggleSkip(gateProp) {
      var s = !this.state.skips[gateProp];
      this.state.skips[gateProp] = s;
      this._track(s ? 'engrave_skipped' : 'engrave_unskipped', { field: gateProp });
      this.state.vals[gateProp] = s ? 'Hayır' : 'Evet';
      this.state.added = false;
      this.update();
    }
    // seçim alanı → Shopify varyantı (ilk seçenek boyutu, değer adı aynı)
    _syncVarField() {
      var vp = this.struct && this.struct.variantFromField;
      if (!vp || !this.rt.hasVariants) return;
      var v = this.state.vals[vp], sel = (this.state.optSel || []).slice();
      if (v) { sel[0] = v; this.state.optSel = sel; }
    }
    // 17.10.2026 kullanıcı: "ürünü seçerken fiyat değişimi yap ve bunu pop up ile bildir" — seçime bağlı varyant fiyatı değişince kısa bildirim
    _priceToast(name, from, to) {
      var t = document.querySelector('.atlc-pricetoast');
      if (!t) { t = document.createElement('div'); t.className = 'atlc-pricetoast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
      var short = function (c) { return this.money(c).replace(',00 TL', ' TL'); }.bind(this);
      t.innerHTML = '<div class="atlc-pricetoast__t">' + esc(name) + ' seçildi</div>' +
        '<div class="atlc-pricetoast__p">Set fiyatı <s>' + short(from) + '</s> → <strong>' + short(to) + '</strong></div>';
      t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
      clearTimeout(this._ptT); this._ptT = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
    }
    setVariantOpt(dim, val) {
      var sel = (this.state.optSel || []).slice();
      sel[dim] = val;
      this.state.optSel = sel; this.state.added = false;
      // seçenek değişti: önceki "tükendi / eklenemedi" uyarısı artık geçersiz
      if (this.$ && this.$.err && this.$.err.classList.contains('is-bad')) { this.$.err.textContent = ''; this.$.err.className = 'atlc-err'; }
      this.update();
    }
    // "1. kupayla aynı yap": '(1. Kupa)' değerlerini '(2. Kupa)' karşılıklarına kopyala
    copyKupa() {
      var st = this.state, self = this;
      this.fieldsFlat.forEach(function (f) {
        if (f.prop.indexOf('(2. Kupa)') === -1) return;
        var src = f.prop.split('(2. Kupa)').join('(1. Kupa)');
        if (f.kind === 'choice' && st.vals[src] != null) st.vals[f.prop] = st.vals[src];
        if (f.kind === 'text' && st.txts[src] != null) {
          st.txts[f.prop] = st.txts[src];
          if (f.gate) {
            var sg = f.gate.prop.split('(2. Kupa)').join('(1. Kupa)');
            if (st.skips[sg] != null) { st.skips[f.gate.prop] = st.skips[sg]; st.vals[f.gate.prop] = st.vals[sg]; }
          }
        }
      });
      st.added = false; this.update();
    }
    setGallery(i) { this.state.galIdx = i; this._renderGallery(); }
    // yakından inceleme (14.10.2026 kullanıcı: "üzerine basınca sayfanın ortasında yakından inceleme çıkmalı"):
    // tam ekran açık zemin, büyük görsel; görsele tıkla/dokun → 2,5x yakınlaşır, imleç/parmakla gezilir; oklar + klavye (← → Esc);
    // telefonda yana kaydırınca görsel değişir; boş alana tıklayınca kapanır, kapanınca galeri son bakılan görsele geçer.
    openLightbox(i) {
      var imgs = this.rt.images || [], self = this;
      if (!imgs.length || document.querySelector('.atlc-lb')) return;
      var big = function (u) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=2400') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=2400'; };
      var arrow = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
      var lb = document.createElement('div');
      lb.className = 'atlc-lb';
      lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Ürün görseli, yakından');
      lb.innerHTML = '<div class="atlc-lb__stage"><img class="atlc-lb__img" alt="" draggable="false"></div>' +
        '<button type="button" class="atlc-lb__x" aria-label="Kapat">' + arrow('M6 6l12 12M18 6L6 18') + '</button>' +
        (imgs.length > 1 ? '<button type="button" class="atlc-lb__nav atlc-lb__nav--prev" aria-label="Önceki görsel">' + arrow('M15 5l-7 7 7 7') + '</button>' +
          '<button type="button" class="atlc-lb__nav atlc-lb__nav--next" aria-label="Sonraki görsel">' + arrow('M9 5l7 7-7 7') + '</button>' +
          '<div class="atlc-lb__n"></div>' : '') +
        '<div class="atlc-lb__hint">Yakınlaştırmak için görsele dokunun</div>';
      document.body.appendChild(lb);
      document.documentElement.classList.add('atlc-lb-open');
      var stage = lb.querySelector('.atlc-lb__stage'), img = lb.querySelector('.atlc-lb__img'), num = lb.querySelector('.atlc-lb__n'), cur = i;
      // hız (14.10.2026 kullanıcı: "çok yavaş açılıyor"): normalde galerinin zaten indirdiği görsel (önbellekten, anında) gösterilir,
      // komşular önden yüklenir; 2400 px'lik büyük görsel yalnız yakınlaştırınca indirilir ve hazır olunca yerine geçer.
      var pre = function (u) { var im = new Image(); im.decoding = 'async'; im.src = u; return im; };
      var hiFor = function (k) {
        var u = big(imgs[k]), h = pre(u);
        var swap = function () { if (k === cur && img.classList.contains('is-zoom')) img.src = u; };
        if (h.complete) swap(); else h.onload = swap;
      };
      var show = function (k) {
        cur = (k + imgs.length) % imgs.length;
        img.classList.remove('is-zoom'); img.style.transformOrigin = '';
        img.src = imgs[cur]; img.alt = self.rt.title || '';
        if (num) num.textContent = (cur + 1) + ' / ' + imgs.length;
        if (imgs.length > 1) { pre(imgs[(cur + 1) % imgs.length]); pre(imgs[(cur - 1 + imgs.length) % imgs.length]); }
      };
      var origin = function (x, y) {
        var r = stage.getBoundingClientRect();
        img.style.transformOrigin = Math.max(0, Math.min(100, (x - r.left) / r.width * 100)) + '% ' + Math.max(0, Math.min(100, (y - r.top) / r.height * 100)) + '%';
      };
      var key = function (e) {
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowLeft') show(cur - 1);
        else if (e.key === 'ArrowRight') show(cur + 1);
      };
      var close = function () {
        document.removeEventListener('keydown', key);
        lb.remove();
        document.documentElement.classList.remove('atlc-lb-open');
        if (cur !== (self._galCur || 0)) self.setGallery(cur);
      };
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.atlc-lb__x')) return close();
        if (e.target.closest('.atlc-lb__nav--prev')) return show(cur - 1);
        if (e.target.closest('.atlc-lb__nav--next')) return show(cur + 1);
        if (e.target === img) { if (lb._sw) return; origin(e.clientX, e.clientY); img.classList.toggle('is-zoom'); lb.classList.add('is-used'); if (img.classList.contains('is-zoom')) hiFor(cur); return; }
        close();
      });
      img.addEventListener('mousemove', function (e) { if (img.classList.contains('is-zoom')) origin(e.clientX, e.clientY); });
      var t0 = null;
      stage.addEventListener('touchstart', function (e) { lb._sw = false; t0 = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null; }, { passive: true });
      stage.addEventListener('touchmove', function (e) {
        if (!t0 || e.touches.length !== 1) return;
        if (img.classList.contains('is-zoom')) { e.preventDefault(); origin(e.touches[0].clientX, e.touches[0].clientY); }
      }, { passive: false });
      stage.addEventListener('touchend', function (e) {
        if (!t0 || img.classList.contains('is-zoom') || imgs.length < 2) { t0 = null; return; }
        var dx = e.changedTouches[0].clientX - t0.x, dy = e.changedTouches[0].clientY - t0.y; t0 = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { lb._sw = true; show(cur + (dx < 0 ? 1 : -1)); setTimeout(function () { lb._sw = false; }, 400); }
      });
      document.addEventListener('keydown', key);
      show(i);
      lb.querySelector('.atlc-lb__x').focus({ preventScroll: true });
    }
    galStep(d) { var n = (this.rt.images || []).length; if (n > 1) this.setGallery(((this._galCur || 0) + d + n) % n); }
    // galeri rayı: hedef slayta translateX ile kayar (CSS geçişi yumuşatır); komşu görseller önden yüklenir
    _galLoad(i) {
      var tr = this.$.galTrack, sl = tr && tr.children[i], im = sl && sl.firstChild;
      if (im && !im.getAttribute('src')) im.src = im.getAttribute('data-src');
    }
    _galGo(idx) {
      var tr = this.$.galTrack; if (!tr) return;
      var n = tr.children.length; if (!n) return;
      idx = Math.max(0, Math.min(n - 1, idx));
      this._galCur = idx;
      this._galLoad(idx); this._galLoad(idx - 1); this._galLoad(idx + 1);
      tr.classList.remove('is-dragging');
      tr.style.transform = 'translate3d(' + (-idx * 100) + '%,0,0)';
    }
    setQty(d) { this.state.qty = Math.max(1, Math.min(9, (this.state.qty || 1) + d)); this.state.added = false; this.update(); }
    setTab(i) { this.state.infoTab = i; this._renderInfo(); }
    scrollReviews() {
      var el = document.getElementById('atlc-yorumlar') || document.querySelector('[data-arv]'); if (!el) return; // [data-arv]: kendi yorum bölümümüz (13.10.2026)
      var y = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
    _focusField(f) {
      var self = this;
      setTimeout(function () {
        var el = self.querySelector('[data-text][data-prop="' + (window.CSS && CSS.escape ? CSS.escape(f.prop) : f.prop) + '"]');
        if (el) { try { el.focus({ preventScroll: false }); } catch (e) { try { el.focus(); } catch (e2) {} } }
      }, 120);
    }

    /* ---------- render ---------- */
    update() {
      // 20.10.2026: varyant değişince sayfadaki diğer bölümlere haber ver (ör. boyut karşılaştırmasında rengin görseli)
      var evV = this.rt.hasVariants ? this.currentVariant() : null, evK = evV ? (evV.id || (evV.options || []).join('|')) : '';
      if (evK !== this._evVarKey) { this._evVarKey = evK; try { document.dispatchEvent(new CustomEvent('atl:variant', { detail: { variant: evV, handle: this.rt.handle } })); } catch (e) {} }
      this._renderColorTop();
      this._renderGallery();
      this._renderPrice();
      this._renderStepper();
      this._renderBody();
      this._renderTotals();
      this._renderIncentive();
      this._renderNav();
      this._renderCart();
      this._prefetchColors();
    }

    /* galeri: adıma duyarlı otomatik görsel + elle seçim (galIdx) */
    _galKeywords(label) {
      var L = trUpper(label || '');
      if (L.indexOf('ALTLI') > -1) return ['altlik', 'altligi', 'altlığı', 'coaster'];
      if (L.indexOf('MATARA') > -1) return ['matara', 'flask'];
      if (L.indexOf('BARDA') > -1 || L.indexOf('VİSKİ') > -1) return ['bardak', 'viski', 'whiskey', 'glass']; // 17.10.2026: adım adı "VİSKİ BARDAĞI"
      if (L.indexOf('KUTU') > -1) return ['kutu', 'box', 'ahsap', 'ahşap'];
      if (L.indexOf('KUPA') > -1) return ['kupa', 'mug', 'emaye'];
      if (L.indexOf('CÜZDAN') > -1 || L.indexOf('CUZDAN') > -1) return ['cuzdan', 'wallet'];
      if (L.indexOf('ÇAKMAK') > -1 || L.indexOf('CAKMAK') > -1) return ['cakmak', 'lighter'];
      if (L.indexOf('KEMER') > -1) return ['kemer', 'belt'];
      if (L.indexOf('PUSULA') > -1) return ['pusula', 'compass'];
      if (L.indexOf('DEFTER') > -1) return ['defter', 'notebook'];
      if (L.indexOf('KALEM') > -1) return ['kalem', 'pen'];
      if (L.indexOf('MÜHÜR') > -1 || L.indexOf('İSİM') > -1) return ['kutu', 'muhur'];
      return null;
    }
    _autoGalIdx() {
      var imgs = this.rt.images || [];
      if (!imgs.length) return 0;
      var sd = this.steps[this.state.step];
      if (!sd) return 0;
      // 20.10.2026 kullanıcı (Passenger): seçeneğe özel büyük görsel — adımdaki seçili değerin galFile'ı (Küçük/Büyük isimlik)
      var vgf = this._valGalFile(this.state.step);
      if (vgf) { var vgi = imgs.findIndex(function (u) { return String(u).indexOf(vgf) > -1; }); if (vgi > -1) return vgi; }
      // 20.10.2026 kullanıcı (Duffle): adıma özel büyük görsel — sihirbaz verisinde galFile (dosya adının parçası)
      if (sd.galFile) { var gfi = imgs.findIndex(function (u) { return String(u).indexOf(sd.galFile) > -1; }); if (gfi > -1) return gfi; }
      // KUTU adımında ahşap seçiliyse kutu fotoğrafı
      var kws = null;
      if (sd.kind === 'box') { kws = this.boxWoodenSelected() ? ['kutu', 'box', 'ahsap', 'ahşap'] : null; }
      else if (sd.kind === 'part') kws = this._galKeywords(sd._rawLabel || sd.label);
      var norm = function (u) { return String(u || '').toLowerCase(); };
      // 17.10.2026 kullanıcı: "müşteri minimal cüzdanı seçince ürün görselindeki minimal görsel gelsin" — seçeneğin "gal" alanı
      // (sihirbaz verisi, 0'dan başlayan fotoğraf sırası) seçiliyse büyük görsel o fotoğraf (kutu adımında ahşap kutu fotoğrafı önce gelir)
      if (!(sd.kind === 'box' && kws)) {
        var gp = this._galPick();
        // 20.10.2026 kullanıcı: "gal" sırası yazıldıktan sonra setlere 2. görsel olarak ortak kutu fotoğrafı eklendi → sayarken atla
        if (gp != null) {
          var gsrc = this._galAll || imgs, galts = this.rt.imageAlts || [], gpure = [];
          for (var gi = 0; gi < gsrc.length; gi++) { if (!/hediye kutusu \(ortak\)/i.test(galts[gi] || '')) gpure.push(gi); }
          if (gpure.length < gsrc.length && gp < gpure.length) gp = gpure[gp];
        }
        // "gal" tam galeri sırasıdır; renk süzgeci açıkken aynı görselin süzülmüş listedeki yeri (19.10.2026)
        if (gp != null && this._galAll && this._galAll[gp] && imgs !== this._galAll) gp = imgs.indexOf(this._galAll[gp]);
        if (gp != null && gp >= 0 && gp < imgs.length) return gp;
      }
      // 21.10.2026 kullanıcı: "mobilde sürekli bu görsele atıyor, isme özel modele atsın" — tekil kupada KUPA (Model & İsim) adımında
      // anahtar kelime araması yok: büyük görsel seçili rengin fotoğrafı / kapak (İsme Özel kupa). Setlerde aramada doğa/ortam
      // fotoğrafları (alt'ta "doğada", dosya adında "ortam", kupa2/KT-2) atlanır — "emaye-kupa-ortam-1.jpg" adı yüzünden hep o seçiliyordu.
      if (sd.kind === 'part' && !this.rt.isSet && (sd._rawLabel || sd.label) === 'KUPA') kws = null;
      if (kws) {
        var galt = this.rt.imageAlts || [], gallSrc = this._galAll || imgs;
        var isScene = function (u) {
          var ai = gallSrc.indexOf(u), alt = ai > -1 ? String(galt[ai] || '') : '', f = String(u).split('?')[0].split('/').pop();
          return /doğada|ortam/i.test(alt) || /ortam|^(kupa2|kt-2)/i.test(f);
        };
        for (var i = 0; i < imgs.length; i++) {
          if (isScene(imgs[i])) continue;
          var u = norm(imgs[i]);
          for (var k = 0; k < kws.length; k++) { if (u.indexOf(kws[k]) > -1) return i; }
        }
      }
      // seçili varyantın fotoğrafı (13.10.2026: Orta Derisiz Emaye Kupa — renk seçilince büyük görsel o renge geçer)
      var cv = this.rt.hasVariants ? this.currentVariant() : null;
      if (cv && cv.image && !(sd.kind === 'box' && kws)) {
        var base = function (u) { return String(u || '').split('?')[0]; }, vb = base(cv.image);
        for (var j = 0; j < imgs.length; j++) { if (base(imgs[j]) === vb) return j; }
      }
      return 0;
    }
    // adımdaki seçili seçeneğin galFile'ı (sihirbaz verisinde değer başına "galFile": dosya adının parçası)
    _valGalFile(si) {
      var vals = this.state.vals, hit = null;
      (this.stepFields(si) || []).some(function (f) {
        if (f.kind !== 'choice') return false;
        var v = (f.values || []).filter(function (x) { return x.galFile && tv(x.v) === tv(vals[f.prop]); })[0];
        if (v) { hit = v.galFile; return true; }
        return false;
      });
      return hit;
    }
    _galUrl(part) {
      var all = this._galAll || this.rt.images || [];
      for (var i = 0; i < all.length; i++) if (String(all[i]).indexOf(part) > -1) return all[i];
      return null;
    }
    _galPick(onlyProp) {
      var vals = this.state.vals, hit = null;
      (this.fieldsFlat || []).some(function (f) {
        if (f.kind !== 'choice' || (onlyProp && f.prop !== onlyProp)) return false;
        if (!(f.values || []).some(function (v) { return v.gal != null; })) return false;
        if (onlyProp) { hit = 0; return true; }
        var v = (f.values || []).filter(function (x) { return tv(x.v) === tv(vals[f.prop]); })[0];
        if (v && v.gal != null) { hit = +v.gal; return true; }
        return false;
      });
      return hit;
    }
    boxWoodenSelected() {
      var f = this._boxField(), pv = this.paidBoxValue();
      return !!(f && pv && tv(this.state.vals[f.prop]) === tv(pv));
    }
    // 19.10.2026 kullanıcı: "renk seçeneklerinde renge bastığında rengin görselleri sola gelsin; tüm tekil ürünlerde" →
    // galeri yalnız seçili rengin fotoğraflarını gösterir. Fotoğrafın rengi: açıklamasında (alt) geçen renk adı (uzun ad önce:
    // "Antik Taba" > "Taba"); yoksa bir rengin varyant fotoğrafıysa o renk; yoksa kendinden önceki fotoğrafın rengi (galeri renk
    // renk sıralı). İlk renkten önceki renksiz fotoğraflar, "__ortak__" (ölçü görseli) ve açıklamasında "ortak"/kutu geçenler her
    // renkte görünür. En az iki renk grubu çıkmazsa ya da seçili rengin fotoğrafı yoksa tüm galeri (setler: varyant yok → değişmez).
    _colorOptIdx() {
      var os = this.rt.options || [];
      if (!this.rt.hasVariants || !os.length) return -1;
      for (var i = 0; i < os.length; i++) if (/renk|colou?r/i.test(os[i].name || '')) return i;
      return os.length === 1 ? 0 : -1;
    }
    _galGroups() {
      if (this._galGrp !== undefined) return this._galGrp;
      this._galGrp = null;
      var all = this._galAll || [], alts = this.rt.imageAlts || [], oi = this._colorOptIdx();
      if (oi < 0 || all.length < 2 || alts.length !== all.length) return null;
      var low = function (x) { return String(x || '').toLocaleLowerCase('tr-TR'); };
      var names = (((this.rt.options || [])[oi] || {}).values || []).slice().sort(function (a, b) { return b.length - a.length; });
      var res = names.map(function (n) { return new RegExp('(^|[^a-zçğıöşü])' + low(n).replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^a-zçğıöşü])'); });
      var base = function (u) { return String(u || '').split('?')[0]; };
      var slug = function (x) { return low(x).replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i').replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u').replace(/[^a-z0-9]/g, ''); };
      var slugs = names.map(slug), hs = slug(this.rt.handle || '') || '\u0000';
      var vimg = {};
      (this.rt.variants || []).forEach(function (v) { if (v.image && v.options && !vimg[base(v.image)]) vimg[base(v.image)] = v.options[oi]; });
      // son varyant fotoğrafından sonraki renksiz fotoğraflar (yaşam, detay, ölçü) ortak sayılır — son renge yığılmasın
      var lastV = -1;
      for (var q = 0; q < all.length; q++) if (vimg[base(all[q])]) lastV = q;
      var col = [], prev = null;
      // adıma bağlı görsel (galFile, 20.10.2026 Duffle) her renkte gösterilir
      var stepFiles = (this.steps || []).map(function (sd) { return sd.galFile; }).filter(Boolean);
      (this.steps || []).forEach(function (sd) { (sd.fields || []).forEach(function (f) { (f.values || []).forEach(function (v) { if (v.galFile) stepFiles.push(v.galFile); }); }); });
      for (var i = 0; i < all.length; i++) {
        var a = alts[i] || '', la = low(a), c = null;
        if (stepFiles.some(function (sf) { return String(all[i]).indexOf(sf) > -1; })) { col.push('*'); continue; }
        if (a === '__ortak__' || /(^|[^a-zçğıöşü])(ortak|kutu|ambalaj)/.test(la)) { col.push('*'); continue; }
        for (var k = 0; k < names.length; k++) if (res[k].test(la)) { c = names[k]; break; }
        // açıklama yoksa dosya adında renk (ör. "antiktaba3.jpg", "klasiksiyah-on.jpg"); ürün adresi (handle) önce çıkarılır
        if (!c) { var fn = slug(base(all[i]).split('/').pop().replace(/\.[a-z0-9]+$/i, '')).replace(hs, ''); for (var k2 = 0; k2 < names.length; k2++) if (slugs[k2].length > 2 && fn.indexOf(slugs[k2]) > -1) { c = names[k2]; break; } }
        if (!c) c = vimg[base(all[i])] || (i > lastV ? null : prev);
        col.push(c || '*');
        if (c) prev = c;
      }
      var groups = {};
      col.forEach(function (c, i) { if (c !== '*') (groups[c] = groups[c] || []).push(i); });
      if (Object.keys(groups).length < 2) return null;
      this._galGrp = { col: col, groups: groups };
      return this._galGrp;
    }
    _galApplyColor() {
      var g = this._galGroups();
      if (!g || !this.$.galTrack) return;
      var cv = this.currentVariant(), oi = this._colorOptIdx(), c = cv && cv.options ? cv.options[oi] : null;
      var key = g.groups[c] ? c : '';
      if (key === this._galKey) return;
      var first = this._galKey === undefined;
      this._galKey = key;
      var all = this._galAll, list = key ? all.filter(function (u, i) { return g.col[i] === key || g.col[i] === '*'; }) : all.slice();
      this.rt.images = list;
      var t = this.rt.title || '';
      this.$.galTrack.innerHTML = list.map(function (src, i) {
        return '<div class="atlc-gallery__slide"><img class="atlc-gallery__main" data-src="' + esc(src) + '"' + (i === 0 ? ' src="' + esc(src) + '"' : '') + ' alt="' + esc(t) + '" draggable="false"></div>';
      }).join('');
      this.$.galThumbs.innerHTML = '';
      if (!first) this.state.galIdx = null;
      this._galCur = 0;
    }
    _renderGallery() {
      this._galApplyColor();
      var s = this.state, imgs = this.rt.images || [];
      var idx = (s.galIdx != null && s.galIdx < imgs.length) ? s.galIdx : this._autoGalIdx();
      this._galGo(idx);
      // aktif seçim etiketi (sol alt beyaz chip). Görsel elle seçildiyse (küçük resim / swipe → galIdx dolu)
      // chip o görseli anlatmayabilir → gizlenir; adım değişince (goStep galIdx'i sıfırlar) geri gelir (M005).
      var manual = s.galIdx != null && s.galIdx < imgs.length;
      var sd = this.steps[s.step], cap = '';
      if (sd && !manual) {
        // kartonda görsel ürünün kendisi → ürün adı; ahşapta kutu görseli → 'KUTU — AHŞAP'
        if (sd.kind === 'box') cap = this.boxWoodenSelected() ? 'KUTU — AHŞAP' : trUpper(this.rt.title || '');
        else if (sd.kind === 'part') {
          var col = this.stepFields(s.step).find(function (f) { return f.ui === 'swatch'; });
          cap = trUpper(sd.label) + (col ? ' — ' + trUpper(this.state.vals[col.prop]) : '');
        }
        else if (sd.kind === 'extra') cap = trUpper(sd.label);
        else if (sd.kind === 'summary') cap = trUpper(this.rt.title || '');
        else cap = trUpper(this.rt.title || '');
      }
      this.$.galCap.textContent = cap;
      this.$.galCap.style.display = cap ? '' : 'none';
      // şerit BİR KEZ kurulur (60px thumb için 200px CDN varyantı), sonra yalnız is-sel değişir
      if (this.$.galThumbs.children.length !== imgs.length) {
        this.$.galThumbs.innerHTML = imgs.map(function (src, i) {
          var th = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=200') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
          return '<button type="button" class="atlc-gallery__thumb" ' +
            'aria-label="Görsel ' + (i + 1) + ' / ' + imgs.length + '" data-action="thumb" data-idx="' + i + '"><img src="' + esc(th) + '" alt="" loading="' + (i < 6 ? 'eager' : 'lazy') + '"></button>';
        }).join('');
      }
      Array.prototype.forEach.call(this.$.galThumbs.children, function (b, i) { b.classList.toggle('is-sel', i === idx); });
      // aktif thumb'ı şeritte görünür kıl (yatay=mobil, dikey=masaüstü) — scrollIntoView DEĞİL (sayfayı kaydırmaz)
      var at = this.$.galThumbs.children[idx];
      if (at) {
        var st = this.$.galThumbs;
        if (st.scrollWidth > st.clientWidth + 4) st.scrollLeft = Math.max(0, at.offsetLeft - (st.clientWidth - at.offsetWidth) / 2);
        if (st.scrollHeight > st.clientHeight + 4) st.scrollTop = Math.max(0, at.offsetTop - (st.clientHeight - at.offsetHeight) / 2);
      }
      this._syncRail();
      var stage = this.querySelector('.atlc-gallery__stage');
      if (stage && !this._railRO && window.ResizeObserver) {
        this._railRO = new ResizeObserver(this._syncRail.bind(this));
        this._railRO.observe(stage);
      }
    }
    // masaüstü: küçük fotoğraf sütunu ana görselin BOYU kadar uzanır, sığmayanlar sütun içinde kayar
    // (mobilde şerit yatay; sınır kaldırılır)
    _syncRail() {
      var th = this.$.galThumbs, stage = this.querySelector('.atlc-gallery__stage');
      if (!th || !stage) return;
      var vertical = getComputedStyle(th).flexDirection === 'column';
      var h = Math.round(stage.getBoundingClientRect().height);
      th.style.maxHeight = (vertical && h > 120) ? h + 'px' : '';
    }

    _renderPrice() {
      this.$.now.textContent = this.money(this.total());
      var old = this.compareAtTotal();
      var showOld = this.rt.showBadge !== false && old && old > this.total();
      this.$.old.textContent = showOld ? this.money(old) : '';
      this.$.old.style.display = showOld ? '' : 'none';
      // 11.10.2026: indirimde "X TL kazancın" (tam TL'ye yuvarlı)
      if (this.$.save) {
        this.$.save.textContent = showOld ? this.money(Math.round((old - this.total()) / 100) * 100).replace(/,00(?=\D|$)/, '') + ' kazancın' : '';
        this.$.save.style.display = showOld ? '' : 'none';
      }
    }

    /* v2 stepper: "+ -> ×" marka işareti; ray soldan sağa brick dolar.
       DOM BİR KEZ kurulur, sonra yalnız class değişir — böylece × dönüşü
       (.5s bounce) ve ray dolması (.8s) GERÇEKTEN animasyonlanır
       (innerHTML ile yeniden kurulsaydı geçişler hiç tetiklenmezdi). */
    _buildStepperDom() {
      var isSet = /^set-/.test((this.rt && this.rt.handle) || '');
      this.$.stepper.innerHTML = this.steps.map(function (sd, i) {
        // 15.10.2026 kullanıcı: stepper'da "KUPA" adımı "RENK & MODEL" yazsın (iç ad KUPA kalır: başlık "Kupanı tasarla", galeri eşleşmesi)
        // 17.10.2026 kullanıcı: setlerde (set-*) kupa adımı "KUPA" yazar
        // 21.10.2026: renk üste alındıysa (kupalar) adımda renk yok → "MODEL & İSİM"
        var shown = (sd.label === 'KUPA' && !isSet) ? (sd._navMoved ? 'MODEL & İSİM' : 'RENK & MODEL') : sd.label;
        return '<button type="button" class="atlc-step" data-action="step" data-step="' + i + '" title="' + esc(shown) + '">' +
          (i !== 0 ? '<span class="atlc-step__line"><span></span></span>' : '') +
          '<span class="atlc-step__mark"><span class="h"></span><span class="v"></span></span>' +
          // "1. KUPA" gibi numaralı etiket mobilde (min-content) "1." / "KUPA" diye bölünmesin
          '<span class="atlc-step__label">' + esc(shown).replace(/^(\d+\.)\s+/, '$1&nbsp;') + '</span>' +
          '</button>';
      }).join('');
      // mobil: adım genişlikleri etikete göre değişebilir + stepper yatay kayabilir (CSS). Font yüklenince
      // / ekran dönünce genişlik değişir -> ResizeObserver ile ray ve kaydırma yeniden hesaplanır.
      var st = this.$.stepper, self = this;
      st.addEventListener('scroll', function () { self._stepperFade(); }, { passive: true });
      if (window.ResizeObserver) {
        this._stepRO = new ResizeObserver(function () { self._stepperLayout(false); });
        this._stepRO.observe(st);
        st.querySelectorAll('.atlc-step').forEach(function (b) { self._stepRO.observe(b); });
      }
    }
    // ray solu = önceki adımın merkezi (--atlc-pw: önceki adımın genişliği; eşit adımlarda eski calc ile aynı).
    // Stepper taşıyorsa aktif adım ortalanır — yalnız stepper kayar (window/scrollIntoView DEĞİL).
    _stepperLayout(smooth) {
      var st = this.$ && this.$.stepper; if (!st) return;
      var btns = st.querySelectorAll('.atlc-step'), prev = 0;
      // sığma kararı etiketlerin DOĞAL genişliğinden (moddan bağımsız -> ResizeObserver döngüsü olmaz):
      // her adım max(işaret [offsetWidth: aktif/tamam dönüşümünden etkilenmez], etiket) + 2×4px; sığmıyorsa kaydırmalı mod (.is-scroll, yalnız mobil CSS'te etkili)
      var cs = getComputedStyle(st), need = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      btns.forEach(function (b) {
        var l = b.querySelector('.atlc-step__label'), m = b.querySelector('.atlc-step__mark');
        need += Math.max(l ? l.getBoundingClientRect().width : 0, m ? m.offsetWidth : 0) + 8;
      });
      st.classList.toggle('is-scroll', need > st.clientWidth + 0.5);
      btns.forEach(function (b, i) {
        var w = b.offsetWidth;
        if (i) b.style.setProperty('--atlc-pw', prev + 'px');
        prev = w;
      });
      var act = btns[(this.state && this.state.step) || 0];
      if (act && st.scrollWidth > st.clientWidth + 1) {
        var sr = st.getBoundingClientRect(), ar = act.getBoundingClientRect();
        var x = st.scrollLeft + (ar.left - sr.left) - (st.clientWidth - ar.width) / 2;
        x = Math.round(Math.max(0, Math.min(st.scrollWidth - st.clientWidth, x)));
        if (Math.abs(x - st.scrollLeft) > 1) {
          // gizli sekmede yumuşak kaydırma ilerlemez (animasyon karesi yok) -> o durumda anında
          try { st.scrollTo({ left: x, behavior: (smooth && !document.hidden) ? 'smooth' : 'auto' }); } catch (e) { st.scrollLeft = x; }
        }
      }
      this._stepperFade();
    }
    // taşan kenar solar (kaydırılabilir olduğu görünsün)
    _stepperFade() {
      var st = this.$ && this.$.stepper; if (!st) return;
      var max = st.scrollWidth - st.clientWidth;
      st.classList.toggle('is-fade-l', max > 1 && st.scrollLeft > 2);
      st.classList.toggle('is-fade-r', max > 1 && st.scrollLeft < max - 2);
    }
    _renderStepper() {
      var s = this.state, step = s.step || 0, self = this;
      var fin = s.added;
      if (!this.$.stepper.firstChild) this._buildStepperDom();
      if (this.$.stepcount) this.$.stepcount.textContent = fin ? 'TAMAMLANDI ✓' : 'ADIM ' + (step + 1) + ' / ' + this.steps.length;
      this.$.stepper.querySelectorAll('.atlc-step').forEach(function (btn, i) {
        var done = i < step || (fin && i === self.lastStep);
        var act = i === step && !done;
        btn.classList.toggle('is-done', done);
        btn.classList.toggle('is-active', act);
        var line = btn.querySelector('.atlc-step__line');
        if (line) line.classList.toggle('is-fill', i <= step);
      });
      // 14.10.2026 kullanıcı: sayfaya girince ilk adımdan ikinciye (KUTU → RENK) kırmızı "yükleniyor" ipucu; bütün ürünlerde.
      // Yalnız ilk adımdayken; adım bir kez değişince (ya da sepete eklenince) bir daha oynamaz.
      if (step !== 0 || fin) this._hintOff = true;
      var hb = this.$.stepper.querySelectorAll('.atlc-step')[1];
      if (hb) hb.classList.toggle('is-hint', !this._hintOff);
      this._stepperLayout(true);
    }

    _renderBody() {
      var sd = this.steps[this.state.step || 0], html = '';
      if (!sd) html = '';
      else if (sd.kind === 'variant') html = this._bodyVariant();
      else if (sd.kind === 'summary') html = this._bodySummary();
      else if (sd.kind === 'extra') html = this._bodyExtra(sd);
      else html = this._bodyGeneric(sd); // box + part aynı motorla
      if (this._lastBodyStep !== this.state.step || !this.$.body.firstChild) {
        // adım değişti: gövde sıfırdan kurulur + reveal animasyonu (YALNIZ adım değişince —
        // aynı adımda her seçimde oynasaydı sayfa "tak tak" titriyordu)
        this._lastBodyStep = this.state.step;
        this.$.body.innerHTML = html;
        this.$.body.classList.remove('is-in');
        void this.$.body.offsetWidth;
        this.$.body.classList.add('is-in');
      } else {
        // aynı adımda seçim (renk, kutu, chip…): DOM YERİNDE eşitlenir (morph). innerHTML ile
        // yeniden kurmak odaklı input'u siliyor -> mobilde klavye kapanıp sayfa aşağı-yukarı zıplıyordu.
        var tpl = document.createElement('div'); tpl.innerHTML = html;
        this._morphChildren(this.$.body, tpl);
        this.$.body.classList.add('is-in');
      }
      this._fitAllStraps();
    }
    // ---- küçük DOM morph: yeni ağacı mevcut ağaca indeks-eşlemeli uygular (odak/klavye/scroll korunur) ----
    _morphChildren(a, b) {
      var bs = Array.prototype.slice.call(b.childNodes), k;
      for (k = 0; k < bs.length; k++) {
        var an = a.childNodes[k];
        if (!an) { a.appendChild(bs[k]); continue; }
        this._morphNode(an, bs[k]);
      }
      while (a.childNodes.length > bs.length) a.removeChild(a.lastChild);
    }
    _morphNode(a, b) {
      if (a.nodeType !== b.nodeType || a.nodeName !== b.nodeName) { a.parentNode.replaceChild(b, a); return; }
      if (a.nodeType === 3) { if (a.nodeValue !== b.nodeValue) a.nodeValue = b.nodeValue; return; }
      if (a.nodeType !== 1) return;
      var i, at, keep = {};
      for (i = 0; i < b.attributes.length; i++) { at = b.attributes[i]; keep[at.name] = 1; if (a.getAttribute(at.name) !== at.value) a.setAttribute(at.name, at.value); }
      for (i = a.attributes.length - 1; i >= 0; i--) { at = a.attributes[i].name; if (!keep[at]) a.removeAttribute(at); }
      if (a.nodeName === 'INPUT' || a.nodeName === 'TEXTAREA') {
        if (document.activeElement !== a && a.value !== b.value) a.value = b.value;
        if (a.type === 'checkbox' || a.type === 'radio') a.checked = b.checked;
        return;
      }
      this._morphChildren(a, b);
      if (a.nodeName === 'SELECT' && a.value !== b.value) a.value = b.value;
    }

    _stepHead(sd) {
      var i = this.state.step;
      var titles = {
        box: ['Hediye kutunuzu seçin', 'Sunum, kişiselleştirmeden önce gelir.'],
        extra: ['Birlikte alın', 'Bu ürünle birlikte alınca daha avantajlı.'],
        summary: ['Özet', 'Seçimlerinizi kontrol edin; düzenlemek için adıma dönün.'],
        variant: [sd.label === 'RENK' ? 'Rengini seçin' : 'Ürününüzü seçin', sd.label === 'RENK' ? 'Deri rengini belirleyin.' : 'Seçeneğini belirleyin.']
      };
      var t = sd.title || (titles[sd.kind] ? titles[sd.kind][0] : (sd.label.charAt(0) + sd.label.slice(1).toLocaleLowerCase('tr-TR')));
      var sub = sd.sub || (titles[sd.kind] ? titles[sd.kind][1] : 'Seçeneklerini belirleyin.');
      // 21.10.2026: renk üste alındıysa verideki "Renk, model…" alt satırı yerine alanlardan üretilen metin
      if (sd.kind === 'part') { t = sd.title || this._partTitle(sd); sub = (!sd._navMoved && sd.sub) || this._partSub(sd); }
      // adım başlığında her kelimenin baş harfi büyük (11.10.2026): "Bardak Altlığı", "Hediye Kutunu Seç"
      t = String(t).split(' ').map(function (w) { return w ? w.charAt(0).toLocaleUpperCase('tr-TR') + w.slice(1) : w; }).join(' ');
      return '<div class="atlc-step-head">' +
        '<span class="atlc-step-ord">' + String(i + 1).padStart(2, '0') + '</span>' +
        '<div class="atlc-step-head__txt">' +
          '<div class="atlc-step-title">' + esc(t) + '</div>' +
          '<div class="atlc-step-sub">' + esc(sub) + '</div>' +
        '</div></div>' +
        '<div class="atlc-step-tick"></div>';
    }
    _partTitle(sd) {
      var L = sd.label;
      if (/^\d+\.\s*KUPA$/.test(L)) return L.charAt(0) + '. kupayı tasarlayın';
      if (L === 'KUPA') return 'Kupanızı tasarlayın';
      if (L === 'KİŞİSELLEŞTİRME') return 'İsim baskınızı ekleyin';
      var low = L.toLocaleLowerCase('tr-TR');
      return low.charAt(0).toLocaleUpperCase('tr-TR') + low.slice(1); // 11.10.2026: "— kişiselleştirin" kaldırıldı (panel başlığı zaten söylüyor)
    }
    _partSub(sd) {
      var f = (sd.fields || []);
      var hasC = f.some(function (x) { return x.ui === 'swatch'; });
      var hasM = f.some(function (x) { return x.ui === 'tiles'; });
      var hasT = f.some(function (x) { return x.kind === 'text'; });
      if (hasC && hasM && hasT) return 'Renk, model ve isim baskısı — hepsi bu adımda.';
      if (hasC && hasT) return 'Renk ve harf baskısı birlikte.';
      if (hasM && hasT) return 'Model ve isim baskısı birlikte.';
      if (hasT) return 'Harf baskısını girin.'; // 13.10.2026: "— ücretsiz" kaldırıldı (yalnız başlıkta)
      if (hasC && hasM) return 'Renk ve modeli seçin.';
      return 'Seçiminizi yapın.';
    }

    /* alan çizimleri */
    _fieldLabel(f, extra) {
      var lbl = cleanLbl(f.label && f.label !== f.prop ? f.label : f.prop);
      // veri etiketleri 'siz' kipli yönerge olabiliyor ("MATARA RENGİNİ SEÇİNİZ."): görüntüde kısa ad — "MATARA RENGİ"
      var shown = trUpper(lbl).replace(/\s*Nİ\s+SEÇİNİZ\.?$/, '').replace(/\s*SEÇİNİZ\.?$/, '').replace(/\.$/, '');
      return '<div class="atlc-field-label">' + esc(shown) + (extra || '') + '</div>';
    }
    /* renk kutucukları (11.10.2026): parçanın mağazadaki kendi ürününden o rengin fotoğrafı (deri dokusu yerine).
       Yalnız alanın TÜM renkleri ürün fotoğrafıyla eşleşirse kullanılır; biri eksikse doku görselleri kalır (karışık görünmesin). */
    _swPart(f) {
      var p = trUpper(tv(f.prop)).replace(/\s*\(.*\)\s*$/, '').replace(/\s+RENG[İI]$/, '');
      return ({ 'MATARA': 'deri-kapli-matara', 'ÇAKMAK': 'taba-cakmak', 'KLASİK CÜZDAN': 'klasik-cuzdan', 'CLUTCH CÜZDAN': 'clutch-cuzdan',
        'MİNİMAL CÜZDAN': 'minimal-cuzdan', 'PASAPORT CÜZDANI': 'pasaport-cuzdani', 'BARDAK ALTLIĞI': 'deri-dikisli-bardak-altligi' })[p] || null;
    }
    _swProductImgs(f) {
      if (f.noPhoto) return null; // 17.10.2026 kullanıcı: bu alanda ürün fotoğrafı değil, sihirbaz verisindeki kare görsel (BAKIR-KALSK/MULTİ/SLİM/MİNİMAL-PUSULA)
      var h = this._swPart(f); if (!h) return null;
      var c = (this._swCache = this._swCache || {});
      if (c[h] === undefined) {
        c[h] = null; var self = this;
        fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
          var m = {};
          (p && p.variants || []).forEach(function (v) { if (v.featured_image && v.option1) m[String(v.option1).trim().toLocaleLowerCase('tr')] = v.featured_image.src; });
          c[h] = m; self._swPatch();
        }).catch(function () { c[h] = {}; });
      }
      var m = c[h]; if (!m) return null;
      var out = {}, all = (f.values || []).every(function (v) { var u = m[tv(v.v).toLocaleLowerCase('tr')]; if (u) out[tv(v.v)] = u; return !!u; });
      return all ? out : null;
    }
    _swPatch() { // fotoğraflar gelince açık adımın renk kutucuklarını yerinde günceller
      var self = this;
      (this.fieldsFlat || []).forEach(function (f) {
        if (f.ui !== 'swatch') return;
        var pi = self._swProductImgs(f); if (!pi) return;
        self.querySelectorAll('.atlc-sw[data-prop="' + (window.CSS && CSS.escape ? CSS.escape(f.prop) : f.prop) + '"]').forEach(function (b) {
          var u = pi[tv(b.getAttribute('data-val'))]; if (!u) return;
          var im = b.querySelector('.atlc-sw__img'); if (im) im.setAttribute('style', bgImg(cdnSize(u, imgW(120))));
          b.classList.add('is-photo'); b.setAttribute('data-pop', cdnSize(u, imgW(320)));
        });
      });
    }
    _swatchField(f) {
      var sel = tv(this.state.vals[f.prop]);
      var pi = this._swProductImgs(f);
      // 17.10.2026 kullanıcı: setlerde emaye rengi kutusunda renk kartı yerine o rengin dekupe (derilenmiş) kupası
      var em = (!pi && /emaye\s*reng/i.test(f.prop || '')) ? (this.rt.emayeImgs || null) : null;
      var emKey = function (s) { return tv(s).toLocaleLowerCase('tr').replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ö/g, 'o').replace(/ü/g, 'u'); };
      var btns = (f.values || []).map(function (v) {
        var on = tv(v.v) === sel;
        var cut = em && em[emKey(v.v)];
        var src = pi ? pi[tv(v.v)] : (cut || v.img);
        var pop = src ? ' data-pop="' + esc(cdnSize(src, imgW(320))) + '" data-pop-name="' + esc(v.v) + '"' : '';
        var fill = src ? '<span class="atlc-sw__img" style="' + bgImg(cdnSize(src, imgW(pi || cut ? 120 : 64))) + '"></span>' : '';
        return '<button type="button" class="atlc-sw' + (on ? ' is-sel' : '') + (pi ? ' is-photo' : '') + (cut ? ' is-cut' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" title="' + esc(v.v) + '" data-action="pick" data-prop="' + esc(f.prop) + '" data-val="' + esc(v.v) + '"' + pop + '>' +
          '<span class="atlc-sw__box">' + fill + '<span class="atlc-sw__check">✓</span></span>' +
          '<span class="atlc-sw__name">' + esc(tv(v.v)) + '</span></button>';
      }).join('');
      return '<div class="atlc-field">' + this._fieldLabel(f) + '<div class="atlc-swgrid">' + btns + '</div></div>';
    }
    // 15.10.2026 kullanıcı: çantalarda isim, çantanın rengindeki deri isimliğe basılır (veride alan "charm": true,
    // görsel "asset:isimlik-{c}-kucuk.webp"). {c} = seçili çanta renginin isimlik rengi.
    charmColor() {
      var opts = this.rt.options || [], sel = this.state.optSel || [], val = '';
      opts.forEach(function (o, i) { if (!val && /renk/i.test(o.name || '')) val = sel[i] || ''; });
      var k = tv(val).toLocaleLowerCase('tr');
      if (/siyah/.test(k)) return 'siyah';
      if (/kırmızı|kirmizi|bordo/.test(k)) return 'kirmizi';
      if (/yeşil|yesil|haki/.test(k)) return 'yesil';
      if (/antik|kahve/.test(k)) return 'kahve';
      return 'taba';
    }
    _tilesField(f, noLabel) {
      var self = this, sel = tv(this.state.vals[f.prop]);
      var isCol = !!f.nav; // renk kutucukları (13.10.2026 kullanıcı): isim yok, dekupe görsel, çok ince çizgili kutu
      var cc = f.charm ? this.charmColor() : '';
      var btnArr = (f.values || []).map(function (v) {
        var on = tv(v.v) === sel;
        var vimg = (f.charm && v.img) ? v.img.replace('{c}', cc) : v.img;
        var img = vimg ? '<span class="atlc-tile__img" style="' + bgImg(cdnSize(vimg, imgW(220))) + '"></span>' : '<span class="atlc-tile__img atlc-tile__img--empty"></span>';
        // 17.10.2026 kullanıcı: "sihirbazdaki ürünlerin üzerine gelince her zaman büyüt" → renk kutucuklarında da büyütme (önce kapalıydı)
        // 20.10.2026 kullanıcı (Passenger): değerin galFile'ı varsa üzerine gelince o ürün fotoğrafı büyür
        var gfu = v.galFile ? self._galUrl(v.galFile) : null;
        var gfw = gfu ? (/[?&]width=\d+/.test(gfu) ? gfu.replace(/([?&])width=\d+/, '$1width=' + imgW(480)) : gfu + (gfu.indexOf('?') > -1 ? '&' : '?') + 'width=' + imgW(480)) : null;
        var pop = gfu ? ' data-pop="' + esc(gfw) + '" data-pop-name="' + esc(v.v) + '"'
          : (vimg ? ' data-pop="' + esc(cdnSize(vimg, imgW(320))) + '" data-pop-name="' + esc(v.v) + '"' : '');
        return '<button type="button" class="atlc-tile' + (isCol ? ' atlc-tile--color' : '') + (on ? ' is-sel' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '"' + (isCol ? ' aria-label="' + esc(tv(v.v)) + '" title="' + esc(tv(v.v)) + '"' : '') + ' data-action="pick" data-prop="' + esc(f.prop) + '" data-val="' + esc(v.v) + '"' + pop + '>' +
          img + (isCol ? '' : '<span class="atlc-tile__name">' + esc(tv(v.v)) + '</span>') +
          (v.link && !v.noTilePrice && self.linkPrice(v) ? '<span class="atlc-tile__price">' + ((v.disc || v.disc2) ? '<s>' + esc(self.money(self.linkPrice(v, true))) + '</s> ' : '+') + esc(self.money(self.linkPrice(v))) + '</span>' : '') +
          '<span class="atlc-tile__check">✓</span></button>';
      });
      var btns = btnArr.join('');
      // renk grupları (16.10.2026 kullanıcı: clutch'ta önce "Saffiano baskı", altında "Düz deri"): değerlerde g = grup adı
      if (isCol && (f.values || []).some(function (v) { return v.g; })) {
        var grps = [];
        (f.values || []).forEach(function (v, i) {
          var g = v.g || '', last = grps[grps.length - 1];
          if (!last || last.g !== g) grps.push(last = { g: g, html: '' });
          last.html += btnArr[i];
        });
        return '<div class="atlc-field">' + (noLabel ? '' : this._fieldLabel(f)) + grps.map(function (gr) {
          return '<div class="atlc-cgrp">' + (gr.g ? '<div class="atlc-cgrp__h">' + esc(gr.g) + '</div>' : '') + '<div class="atlc-tiles atlc-tiles--colors">' + gr.html + '</div></div>';
        }).join('') + '</div>';
      }
      return '<div class="atlc-field">' + (noLabel ? '' : this._fieldLabel(f)) + '<div class="atlc-tiles' + (isCol ? ' atlc-tiles--colors' : '') + (f.charm ? ' atlc-tiles--charm' : '') + '">' + btns + '</div>' +
        (f.charm && f.note ? '<p class="atlc-charm-note">' + esc(f.note) + '</p>' : '') + '</div>';
    }
    _chipsField(f) {
      var sel = tv(this.state.vals[f.prop]);
      var btns = (f.values || []).map(function (v) {
        var on = tv(v.v) === sel;
        return '<button type="button" class="atlc-chip' + (on ? ' is-sel' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-action="pick" data-prop="' + esc(f.prop) + '" data-val="' + esc(v.v) + '">' + esc(tv(v.v)) + '</button>';
      }).join('');
      return '<div class="atlc-field">' + this._fieldLabel(f) + '<div class="atlc-chips">' + btns + '</div></div>';
    }
    _textField(f) {
      var st = this.state;
      var val = st.txts[f.prop] || '';
      var skip = f.gate ? !!st.skips[f.gate.prop] : false;
      var max = f.max || 20;
      // 17.10.2026: aynı alan seçime göre farklı sınırla gelebilir (çantada Küçük isimlik 3 / Büyük 8) → fazlası kırpılır
      if (val.length > max) { val = val.slice(0, max); st.txts[f.prop] = val; }
      var lbl = cleanLbl(f.label && f.label !== f.prop ? f.label : f.prop); // görünen alan etiketi = input'un erişilebilir adı (M089)
      var ph = f.ph ? ('ör. ' + trUpper(f.ph)) : ('ör. ' + (max >= 6 ? 'MEHMET' : 'ELİF'));
      var skipBtn = f.gate
        ? '<button type="button" class="atlc-skip' + (skip ? ' is-on' : '') + '" aria-pressed="' + (skip ? 'true' : 'false') + '" data-action="skip" data-gate="' + esc(f.gate.prop) + '"><span class="atlc-skip__dot">' + (skip ? '✓' : '') + '</span>Baskı istemiyorum</button>'
        : '';
      return '<div class="atlc-eng" data-eng="' + esc(f.prop) + '">' +
        '<div class="atlc-eng__head"><span class="atlc-field-label nomargin">' + esc(trUpper(lbl)) + '</span></div>' + // 13.10.2026 kullanıcı: ÜCRETSİZ yalnız başlıkta (alanlarda yok)
        (f.note ? '<p class="atlc-charm-note atlc-eng__note">' + esc(f.note) + '</p>' : '') + // 20.10.2026 (Saffiano Clutch): alan açıklaması
        '<div class="atlc-eng__wrap' + (skip ? ' is-skip' : '') + '">' +
          '<input type="text" class="atlc-eng__input" data-text data-prop="' + esc(f.prop) + '" aria-label="' + esc(trUpper(lbl)) + '" maxlength="' + max + '" value="' + esc(val) + '" placeholder="' + esc(ph) + '" spellcheck="false"' + (skip ? ' disabled' : '') + '>' +
          '<div class="atlc-eng__meta"><span>' + esc(this.rt.printRules || 'Harfler (Türkçe karakterler dahil) ve rakamlar büyük harfle basılır. Kullanabileceğiniz semboller: ! , . # + & / ( ) = ? _ - * " ♥ ∞') + '</span>' +
          '<span class="atlc-eng__count' + (val.length >= max - 1 ? ' is-over' : '') + '">' + trUpper(val).length + ' / ' + max + '</span></div>' +
        '</div>' +
        skipBtn +
        '</div>';
    }
    _strapPreview(id, rawVal, skip) {
      var st = this._strapText(rawVal, skip);
      var bg = this.rt.leatherStripImg ? " style=\"background-image:url('" + this.rt.leatherStripImg + "')\"" : '';
      return '<div class="atlc-strap-wrap" data-strap="' + esc(id) + '">' +
        '<div class="atlc-strap"' + bg + '><div class="atlc-strap__text ' + st.cls + '">' + esc(st.text) + '</div></div>' +
        '</div>';
    }
    _strapText(rawVal, skip) {
      if (skip) return { text: 'Baskısız', cls: 'is-skip' };
      if (tv(rawVal) === '') return { text: 'İSMİNİZ', cls: 'is-empty' };
      return { text: trUpper(rawVal), cls: 'is-filled' };
    }
    _updateStrap(id, rawVal, skip) {
      var wrap = this.querySelector('[data-strap="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
      if (!wrap) return;
      var el = wrap.querySelector('.atlc-strap__text');
      if (!el) return;
      var st = this._strapText(rawVal, skip);
      el.textContent = st.text;
      el.className = 'atlc-strap__text ' + st.cls;
      this._fitStrap(el);
    }
    _fitStrap(el) {
      if (!el) return;
      el.style.fontSize = '';
      var size = parseFloat(getComputedStyle(el).fontSize) || 19;
      var guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && size > 11 && guard < 24) {
        size -= 1; el.style.fontSize = size + 'px'; guard++;
      }
    }
    _fitAllStraps() {
      var self = this;
      (this.$.body ? this.$.body.querySelectorAll('.atlc-strap__text') : []).forEach(function (el) { self._fitStrap(el); });
    }

    /* KUTU kartları — v2: beyaz kalır, brick çerçeve + iç ring */
    _boxCards(f) {
      var self = this, sel = tv(this.state.vals[f.prop]);
      var paid = this.paidBoxValue();
      var cards = (f.values || []).map(function (v) {
        var on = tv(v.v) === sel;
        var isPaid = paid && tv(v.v) === tv(paid);
        var priceHtml;
        if (isPaid && self.rt.boxUp && self.rt.boxUp.id && self.rt.boxUp.price > 0) {
          // 17.10.2026: kutunun üstü çizili fiyatı varsa (emaye kutu 714,99 → 549,99) eski fiyat da görünür
          var bxc = +self.rt.boxUp.compare || 0;
          priceHtml = '<span class="atlc-box__price is-plus">' + (bxc > self.rt.boxUp.price ? '<s class="atlc-box__was">' + self.money(bxc) + '</s> ' : '') + '+ ' + self.money(self.rt.boxUp.price) + '</span>';
          // 17.10.2026 kullanıcı: ürünle birlikte alınan kutu Hediye Kutuları'ndaki tek başına fiyatından ucuz ("ekstra indirim uygula, belirt") —
          // ek ücret ürününün üstü çizili fiyatı = kutunun tek başına fiyatı
          // 20.10.2026 kullanıcı: setlerde üstü çizili = Hediye Kutuları'ndaki kutu fiyatı, indirim yüzdesi yazar
          if (bxc > self.rt.boxUp.price) priceHtml += '<span class="atlc-box__deal">' + (self.rt.boxUp.pct
            ? (self.rt.boxUp.pctLabel || 'Setle') + ' birlikte %' + Math.round((1 - self.rt.boxUp.price / bxc) * 100) + ' indirim' : 'Ürünle birlikte özel fiyat') + '</span>';
        } else {
          priceHtml = '<span class="atlc-box__price is-free">Dahil</span>';
        }
        // 17.10.2026 kullanıcı: siyah (Black Edition) kutuda mühür yok → açıklamada "ve mühür" yazmaz (tüm setler)
        var desc = isPaid ? (/black edition|siyah/i.test(boxName(v.v)) ? 'İsme özel kapak. QR\'ı okutunca standart yapım videosu açılır.' : 'İsme özel kapak ve mühür. QR\'ı okutunca standart yapım videosu açılır.') : 'Koruyucu, sade sunum';
        // standart (ücretsiz) kutu: tüm ürünlerde Kolektif'in kırmızı e-ticaret kutusu (10.10.2026, tema asset'i)
        var std = !isPaid && /karton/i.test(tv(v.v)) && self.rt.stdBoxImg;
        var img = std ? '<span class="atlc-box__img" style="' + bgImg(self.rt.stdBoxImg + '&width=' + imgW(160)) + '"></span>'
          : (v.img ? '<span class="atlc-box__img" style="' + bgImg(cdnSize(v.img, imgW(160))) + '"></span>' : '<span class="atlc-box__img"></span>');
        var pop = std ? ' data-pop="' + esc(self.rt.stdBoxImg + '&width=' + imgW(320)) + '" data-pop-name="' + esc(boxName(v.v)) + '"'
          : (v.img ? ' data-pop="' + esc(cdnSize(v.img, imgW(320))) + '" data-pop-name="' + esc(v.v) + '"' : '');
        return '<button type="button" class="atlc-box' + (on ? ' is-sel' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-action="pick" data-prop="' + esc(f.prop) + '" data-val="' + esc(v.v) + '"' + pop + '>' +
          img + '<span class="atlc-box__txt"><span class="atlc-box__name">' + esc(boxName(v.v)) + '</span>' +
          '<span class="atlc-box__desc">' + esc(desc) + '</span>' + priceHtml + '</span>' +
          '<span class="atlc-box__check">✓</span></button>';
      }).join('');
      return '<div class="atlc-boxes">' + cards + '</div>';
    }

    /* genel adım gövdesi: görünür alanları sırayla çiz (box + part) */
    _bodyGeneric(sd) {
      var self = this;
      var out = [this._stepHead(sd)];
      var fields = this.stepFields(this.state.step);
      var rendered = {}, lastText = -1, sideDone = false;
      fields.forEach(function (f, i) { if (f.kind === 'text') lastText = i; });
      fields.forEach(function (f, i) {
        if (rendered[f.prop]) return;
        if (sd.kind === 'box' && i === 0 && f.kind === 'choice') { out.push(self._boxCards(f)); return; }
        // isim alanı olan adımda: iade yok / kusur bizden notu (son isim alanının hemen altında)
        if (f.kind === 'text') {
          // 20.10.2026 kullanıcı (Duffle): isim kutusunun sağında örnek görsel (adım verisinde sideImg)
          if (sd.sideImg && !sideDone) { sideDone = true; out.push('<div class="atlc-tfside"><div class="atlc-tfside__f">' + self._textField(f) + '</div><img class="atlc-tfside__img" src="' + esc(sd.sideImg) + '" alt="İsim baskısı örneği" loading="lazy" decoding="async"></div>'); }
          else out.push(self._textField(f));
          if (i === lastText) out.push(self._noticeHtml()); return;
        }
        if (f.addon && f.pick && isYesNo(f)) { out.push(self._addonPickField(f, sd.fields || [], rendered)); return; }
        if (f.addon && isYesNo(f)) { out.push('<div class="atlc-field"><div class="atlc-addons">' + self._addonRow(f, sd.fields || [], rendered) + '</div></div>'); return; }
        if (isYesNo(f)) { out.push(self._chipsField(f)); return; }
        if (f.ui === 'swatch') { out.push(self._swatchField(f)); return; }
        if (f.ui === 'tiles') { out.push(self._tilesField(f)); return; }
        out.push(self._chipsField(f));
      });
      // '2. KUPA' adımında kopyala butonu
      if (/^2\.\s*KUPA$/.test(sd.label) && this.steps.some(function (x) { return /^1\.\s*KUPA$/.test(x.label); })) {
        out.push('<button type="button" class="atlc-copy" data-action="copy">' + ICON_COPY + '1. kupayla aynı yapın</button>');
      }
      // ahşap kutu seçiliyken alttaki 'QR kod kapağın iç yüzüne işlenir' notu kaldırıldı: kutu kartındaki açıklama yeterli (12.10.2026, kullanıcı isteği)
      return out.join('');
    }

    _bodyVariant() {
      var s = this.state, opts = this.rt.options || [], self = this;
      var single = opts.length === 1;
      var groups = opts.map(function (opt, dim) {
        // renk üstte: sihirbaz adımında renk boyutu yok, üstteki alanda yalnız renk boyutu
        if (self._colorTop && (self._ctopRender ? dim !== self._colorTopDim : dim === self._colorTopDim)) return '';
        var btns = (opt.values || []).map(function (val) {
          var on = s.optSel[dim] === val;
          // tükendi: bu değer, DİĞER seçili opsiyonlarla birlikte oluşan varyantta available:false (ya da
          // o birleşim hiç yok). Tıklanabilir kalır; seçilirse DEVAM / SEPETE EKLE kapanır.
          var cand = (s.optSel || []).slice(); cand[dim] = val;
          var cv = self.exactVariant(cand);
          var so = !cv || cv.available === false;
          var soCls = so ? ' is-soldout' : '';
          var soTitle = so ? ' title="' + esc(val) + ' — tükendi"' : '';
          // tek seçenekli üründe her değerin kendi varyant fotoğrafı varsa kartla göster
          var vimg = null;
          if (single || (self._colorTop && dim === self._colorTopDim)) {
            var mv = (self.rt.variants || []).find(function (v) { return v.options && v.options[dim] === val && v.image; }) || (self.rt.variants || []).find(function (v) { return v.options && v.options[dim] === val; });
            vimg = (mv && mv.image) || null;
          }
          // renk kutusu (14.10.2026 kullanıcı): o rengin dekupe görseli, şeffaf ince çizgili kutu, altında küçük ad
          var cimg = (self.rt.colorImgs || {})[val];
          if (cimg) {
            // 14.10.2026 kullanıcı: renk kutusunun üzerine gelince büyük görelim — o rengin varyant fotoğrafı (yoksa dekupe)
            var vpop = ' data-pop="' + esc(vimg || cimg) + '" data-pop-name="' + esc(val) + '"';
            return '<button type="button" class="atlc-tile atlc-tile--vcolor' + (on ? ' is-sel' : '') + soCls + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-action="vopt" data-dim="' + dim + '" data-val="' + esc(val) + '"' + soTitle + vpop + '>' +
              '<span class="atlc-tile__img" style="' + bgImg(cimg) + '"></span>' +
              // panel adındaki parantez boşlukları ("Siyah ( Beyaz Dikiş )") yalnız görünümde toplanır; sepet değeri aynen kalır
              '<span class="atlc-tile__name">' + esc(String(val).replace(/\(\s+/g, '(').replace(/\s+\)/g, ')')) + '</span>' +
              (so ? '<span class="atlc-tile__so">Tükendi</span>' : '') +
              '<span class="atlc-tile__check">✓</span></button>';
          }
          if (vimg) {
            return '<button type="button" class="atlc-tile' + (on ? ' is-sel' : '') + soCls + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-action="vopt" data-dim="' + dim + '" data-val="' + esc(val) + '"' + soTitle + '>' +
              '<span class="atlc-tile__img" style="' + bgImg(vimg) + '"></span>' +
              '<span class="atlc-tile__name">' + esc(val) + '</span>' +
              (so ? '<span class="atlc-tile__so">Tükendi</span>' : '') +
              '<span class="atlc-tile__check">✓</span></button>';
          }
          return '<button type="button" class="atlc-chip' + (on ? ' is-sel' : '') + soCls + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-action="vopt" data-dim="' + dim + '" data-val="' + esc(val) + '"' + soTitle + '>' +
            (so ? '<span class="atlc-chip__v">' + esc(val) + '</span><span class="atlc-chip__so">Tükendi</span>' : esc(val)) + '</button>';
        });
        var hasTiles = btns.some(function (b) { return b.indexOf('atlc-tile') > -1; });
        var hasV = btns.some(function (b) { return b.indexOf('atlc-tile--vcolor') > -1; });
        return '<div class="atlc-field"><div class="atlc-field-label">' + esc(trUpper(opt.name)) + '</div>' +
          '<div class="' + (hasTiles ? 'atlc-tiles' + (hasV ? ' atlc-tiles--vcolors' : '') : 'atlc-chips') + '">' + btns.join('') + '</div></div>';
      }).join('');
      if (this._ctopRender) return groups;
      var sd = this.steps[this.state.step] || { kind: 'variant', label: 'SEÇENEK' };
      return this._stepHead(sd) + groups;
    }
    // renk sihirbazın üstünde (colorTop): aynı kutucuklar, başlıkta seçili renk; tıklama aynı (vopt), sayfa kaymaz (kullanıcı 19.10)
    // 21.10.2026 kullanıcı: "mobilde biraz yavaşlık var" → her dokunuşta fotoğraflı kutucuklar sıfırdan çizilmesin:
    // HTML aynıysa hiç dokunulmaz, farklıysa yerinde eşitlenir (morph; görseller yeniden yüklenmez/çözülmez)
    _setHtml(el, html) {
      if (el._atlHtml === html) return;
      el._atlHtml = html;
      if (!el.firstChild) { el.innerHTML = html; return; }
      var tpl = document.createElement('div'); tpl.innerHTML = html;
      this._morphChildren(el, tpl);
    }
    _renderColorTop() {
      var el = this.querySelector('[data-ctop]');
      if (el && this._ctopNav) { this._setHtml(el, this._ctopNavHtml(this._ctopNav)); el.hidden = false; return; }
      if (!el || !this._colorTop) return;
      this._ctopRender = true;
      var html = this._bodyVariant();
      this._ctopRender = false;
      var cur = (this.state.optSel || [])[this._colorTopDim] || '';
      // 19.10.2026 kullanıcı: taksit satırından ince çizgiyle ayrılır, başlık "Renk seç" + seçili renk
      // (genel .atlc-field-label kuralı !important ile küçük büyük harf yaptığı için başlık kendi sınıfında)
      this._setHtml(el, html.replace(/<div class="atlc-field-label">[^<]*<\/div>/, '<div class="atlc-ctop__h">Renk seçin <span class="atlc-ctop__val">' + esc(cur) + '</span></div>'));
      el.hidden = false;
    }

    // nav renkleri üstte: varyant renkleriyle aynı görünüm (dekupe + küçük ad), gruplar (Saffiano baskı / Düz deri) korunur
    _ctopNavHtml(f) {
      var sel = tv(this.state.vals[f.prop]), grps = [];
      (f.values || []).forEach(function (v) {
        var on = tv(v.v) === sel, g = v.g || '', last = grps[grps.length - 1];
        if (!last || last.g !== g) grps.push(last = { g: g, html: '' });
        var img = v.img ? cdnSize(v.img, imgW(220)) : '';
        last.html += '<button type="button" class="atlc-tile atlc-tile--vcolor' + (on ? ' is-sel' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" data-action="pick" data-prop="' + esc(f.prop) + '" data-val="' + esc(v.v) + '"' +
          (img ? ' data-pop="' + esc(cdnSize(v.img, imgW(320))) + '" data-pop-name="' + esc(tv(v.v)) + '"' : '') + '>' +
          '<span class="atlc-tile__img"' + (img ? ' style="' + bgImg(img) + '"' : '') + '></span>' +
          '<span class="atlc-tile__name">' + esc(tv(v.v)) + '</span><span class="atlc-tile__check">✓</span></button>';
      });
      return '<div class="atlc-field"><div class="atlc-ctop__h">Renk seçin <span class="atlc-ctop__val">' + esc(sel) + '</span></div>' + grps.map(function (gr) {
        return '<div class="atlc-cgrp">' + (gr.g ? '<div class="atlc-cgrp__h">' + esc(gr.g) + '</div>' : '') + '<div class="atlc-tiles atlc-tiles--vcolors">' + gr.html + '</div></div>';
      }).join('') + '</div>';
    }

    /* kutucuklu eklenti (14.10.2026 kullanıcı: "kese kısmı da kutucuklu olsun, istediği rengi seçip devam etsin"):
       Evet/Hayır kartı yerine bağlı renk alanının kutucukları; seçili kutucuk = eklenti açık + o renk. Seçmeyen eklemeden geçer. */
    _addonPickField(f, fields, rendered) {
      var self = this;
      var dep = fields.filter(function (d) {
        return d !== f && d.kind === 'choice' && (d.showIf || []).some(function (c) { return c.p === f.prop && tv(c.eq) === 'Evet'; });
      })[0];
      rendered[f.prop] = true;
      if (!dep) return '';
      rendered[dep.prop] = true;
      var on = self._gateOn(f.prop), cur = tv(self.state.vals[dep.prop]);
      // 17.10.2026 kullanıcı (kahve kupaları, Süet Taba kese 800 TL, indirimli): kese renklerinin fiyatları farklıysa fiyat her kutucuğun
      // altında yazar (eski fiyat üstü çizili); hepsi aynıysa eskisi gibi başlıkta "(+350 TL)"
      var kuV = (/kese/i.test(f.prop) && this.rt.keseUp && this.rt.keseUp.variants) || [];
      var vOf = function (val) { return kuV.find(function (x) { return tv(x.title) === tv(val); }) || null; };
      var tp = {}; (dep.values || []).forEach(function (v) { var x = vOf(v.v); if (x) tp[x.price] = 1; });
      var perTile = Object.keys(tp).length > 1;
      var short = function (c) { return self.money(c).replace(',00 TL', ' TL'); };
      var btns = (dep.values || []).map(function (v) {
        var sel = on && tv(v.v) === cur;
        var img = v.img ? '<span class="atlc-tile__img" style="' + bgImg(cdnSize(v.img, imgW(220))) + '"></span>' : '<span class="atlc-tile__img atlc-tile__img--empty"></span>';
        // 14.10.2026 kullanıcı: renk adı altında yazsın, üzerine gelince büyüsün (model kutularındaki büyük görsel)
        var pop = v.img ? ' data-pop="' + esc(cdnSize(v.img, imgW(320))) + '" data-pop-name="' + esc(v.v) + '"' : '';
        return '<button type="button" class="atlc-tile atlc-tile--color' + (sel ? ' is-sel' : '') + '" aria-pressed="' + (sel ? 'true' : 'false') + '" data-action="addonpick" data-prop="' + esc(f.prop) + '" data-dep="' + esc(dep.prop) + '" data-val="' + esc(v.v) + '"' + pop + '>' +
          img + '<span class="atlc-tile__name">' + esc(tv(v.v)) + '</span>' + (function () {
            var x = perTile && vOf(v.v); if (!x) return '';
            return '<span class="atlc-tile__price">' + (x.compare > x.price ? '<s>' + short(x.compare).replace(' TL', '') + '</s> ' : '') + '+' + short(x.price) + '</span>';
          })() + '<span class="atlc-tile__check">✓</span></button>';
      }).join('');
      var ku = /kese/i.test(f.prop) && this.rt.keseUp, kp = ku ? ((ku.variants || [])[0] || {}).price : 0;
      var extra = (kp && !perTile) ? ' (+' + this.money(kp).replace(',00 TL', ' TL') + ')' : '';
      return '<div class="atlc-field">' + this._fieldLabel(dep, extra) + '<div class="atlc-tiles atlc-tiles--colors">' + btns + '</div></div>';
    }
    /* EKSTRA — v2 addon satırları: gate satır + açılınca bağlı alanlar */
    // aç/kapa eklenti satırı ("Birlikte al" kartı); bağlı alanlar kart açıkken kartın içinde çizilir.
    // _bodyExtra ve addon: true işaretli alanlar için _bodyGeneric kullanır (13.10.2026: emaye kupalarda kupadan sonraki KESE adımı)
    _addonRow(f, fields, rendered) {
      var self = this;
      var on = self._gateOn(f.prop);
      // bağlı görünür alanlar (bu gate'e koşullu)
      var deps = fields.filter(function (d) {
        return d !== f && (d.showIf || []).some(function (c) { return c.p === f.prop && tv(c.eq) === 'Evet'; });
      });
      deps.forEach(function (d) { rendered[d.prop] = true; });
      var isCream = /bak.m\s*krem/i.test(f.prop);
      var isCakmak = /%\s*\d+\s*[İIiı]ndirimli\s*[çÇcC]akmak|indirimli\s*[çc]akmak/i.test(f.prop);
      var price = '';
      if (isCream && self.rt.krem && self.rt.krem.id) price = '<span class="atlc-addon__price is-plus">+ ' + self.money(self.rt.krem.price) + '</span>';
      else if (isCakmak && self.rt.cakmak && self.rt.cakmak.id) price = '<span class="atlc-addon__price is-plus"><s class="atlc-addon__was">' + self.money(self.cakmakPrice(true)) + '</s> + ' + self.money(self.cakmakPrice()) + '</span>';
      else if (self._gateLinkVal(f, deps)) {
        var lkv = self._gateLinkVal(f, deps), lnow = self.linkPrice(lkv), lwas = self._linkWas(lkv);
        price = '<span class="atlc-addon__price is-plus">' + (lwas > lnow ? '<s class="atlc-addon__was">' + self.money(lwas) + '</s> ' : '') + '+ ' + self.money(lnow) + '</span>';
      }
      else price = '<span class="atlc-addon__price is-free">Ücretsiz</span>';
      var title = tv(f.prop.replace(/^_/, '').replace(/\s*İsteği$/i, '').replace(/\s*EKLE$/i, ''));
      var addonImg = (isCream && self.rt.krem && self.rt.krem.image) ? self.rt.krem.image : (isCakmak && self.rt.cakmak && self.rt.cakmak.image) ? self.rt.cakmak.image : '';
      // 14.10.2026 kullanıcı: "Birlikte al" satırında görsel hep olsun (harf yerine) — veride f.img, yoksa bağlı seçimin ilk görseli;
      // üzerine gelince büyük görsel (dekupe görsel beyaz zeminde)
      var popSrc = addonImg ? (/[?&]width=\d+/.test(addonImg) ? addonImg.replace(/([?&])width=\d+/, '$1width=' + imgW(320)) : addonImg) : '';
      var raw = (!addonImg && f.img) ? f.img : '';
      if (!addonImg && !raw) deps.some(function (d) { var v = (d.values || []).find(function (x) { return x.img; }); if (v) raw = v.img; return !!raw; });
      if (raw) { addonImg = cdnSize(raw, imgW(120)); popSrc = cdnSize(raw, imgW(320)); }
      var cut = /\.png(\?|$)|renk-|dekupe/i.test(addonImg);
      var img = addonImg
        ? '<span class="atlc-addon__ico atlc-addon__ico--img' + (cut ? ' is-cut' : '') + '" style="' + bgImg(addonImg) + '"></span>'
        : '<span class="atlc-addon__ico">' + esc(trUpper(title).charAt(0)) + '</span>';
      var open = '';
      if (on && deps.length) {
        var inner = deps.filter(function (d) { return self.visible(d); }).map(function (d) {
          if (d.kind === 'text') return self._textField(d);
          // tek değerli bağlı seçim (örn. krem): etiketi gizle — kuzenin fiyat bandı
          // gibi yanıltıcı metinler bizim fiyatlandırmayla çelişmesin
          // 17.10.2026 kullanıcı: çakmak (ve Clavis) renk kutucukları %30 küçük; üzerine gelince büyük görsel açılır
          if (d.ui === 'tiles') return (d.values || []).length > 1 ? '<div class="atlc-addon__many">' + self._tilesField(d, false) + '</div>' : self._tilesField(d, true);
          if (d.ui === 'swatch') return self._swatchField(d);
          return self._chipsField(d);
        }).join('');
        open = '<div class="atlc-addon__open">' + inner + '</div>';
      }
      rendered[f.prop] = true;
      return '<div class="atlc-addon' + (on ? ' is-on' : '') + '">' +
        '<button type="button" class="atlc-addon__row" data-action="gate" data-prop="' + esc(f.prop) + '"' + (popSrc ? ' data-pop="' + esc(popSrc) + '" data-pop-name="' + esc(title) + '"' : '') + '>' +
          img +
          '<span class="atlc-addon__body"><span class="atlc-addon__name">' + esc(title) + '</span>' +
          '<span class="atlc-addon__desc">İsteğe bağlı</span></span>' +
          '<span class="atlc-addon__right">' + price +
          '<span class="atlc-addon__pill">' + (on ? 'Eklendi ✓' : 'Ekleyin') + '</span></span>' +
        '</button>' + open + '</div>';
    }
    _bodyExtra(sd) {
      var self = this, s = this.state;
      var out = [this._stepHead(sd)];
      var fields = (sd.fields || []);
      var rendered = {};
      var rows = [];
      fields.forEach(function (f) {
        if (rendered[f.prop]) return;
        if (isYesNo(f)) {
          rows.push(self._addonRow(f, fields, rendered));
        } else if (!rendered[f.prop] && self.visible(f)) {
          // gate'siz düz alan (nadiren)
          if (f.kind === 'text') rows.push(self._textField(f));
          else if (f.ui === 'tiles') rows.push(self._tilesField(f));
          else if (f.ui === 'swatch') rows.push(self._swatchField(f));
          else rows.push(self._chipsField(f));
          rendered[f.prop] = true;
        }
      });
      out.push('<div class="atlc-addons">' + rows.join('') + '</div>');
      return out.join('');
    }

    // kişiselleştirmesiz üründe "Kişiselleştirmek ister misin?" kartı (veride "pers"): seçili rengin kişiselleştirmeli ürününe gider
    // (13.10.2026 kullanıcı: Orta Derisiz Emaye Kupa — sepete ekle'nin üstünde öneri)
    _persCardHtml() {
      var P = this.struct && this.struct.pers; if (!P) return '';
      var val = hnorm((this.state.optSel || [])[0] || ''), h = '';
      Object.keys(P.map || {}).forEach(function (k) { if (hnorm(k) === val) h = P.map[k]; });
      h = h || P.def; if (!h) return '';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return '<a class="atlc-pers" href="' + esc(root + 'products/' + encodeURIComponent(h)) + '">' +
        '<span class="atlc-pers__ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20h4L19 9l-4-4L4 16v4z"/><path d="M13.5 6.5l4 4"/></svg></span>' +
        '<span class="atlc-pers__t"><b>' + esc(P.title || 'Kişiselleştirmek ister misiniz?') + '</b><small>' + esc(P.text || '') + '</small></span>' +
        '<span class="atlc-pers__go">' + esc(P.cta || 'Kişiselleştirin') + ' →</span></a>';
    }

    /* ÖZET — v2 */
    _bodySummary() {
      var self = this, s = this.state, rows = [];
      if (this.rt.hasVariants && (this.rt.options || []).length && !this.struct.variantFromField) {
        var vsi = this.steps.findIndex(function (x) { return x.kind === 'variant'; });
        var vso = this.soldOut();
        rows.push({ label: this.rt.options.map(function (o) { return o.name; }).join(' / '), value: (s.optSel || []).join(' / ') + (vso ? ' — tükendi' : ''), step: Math.max(0, vsi), bad: vso, edit: vso ? 'DEĞİŞTİRİN' : null });
      }
      this.steps.forEach(function (sd, si) {
        if (sd.kind === 'summary' || sd.kind === 'variant') return;
        var bits = [], bad = false;
        var addonOf = {}; // addon kartına bağlı alanlar: değerleri kartın adıyla birlikte yazılır
        (sd.fields || []).forEach(function (g) {
          if (g.addon && isYesNo(g)) (sd.fields || []).forEach(function (d) { if ((d.showIf || []).some(function (c) { return c.p === g.prop; })) addonOf[d.prop] = true; });
        });
        self.stepFields(si).forEach(function (f) {
          if (addonOf[f.prop]) return;
          if (f.kind === 'choice') {
            if (isYesNo(f)) {
              if (f.addon && self._gateOn(f.prop)) {
                var dv = (sd.fields || []).filter(function (d) { return addonOf[d.prop] && d.kind === 'choice' && self.visible(d); }).map(function (d) { return tv(s.vals[d.prop]); }).filter(Boolean);
                var kAdd = (self._keseGate() === f && self.keseOn()) ? ' (+' + self.money(self.kesePrice() * (s.qty || 1)) + ')' : '';
                bits.push(tv(f.prop.replace(/^_/, '').replace(/\s*İsteği$/i, '')) + (dv.length ? ' (' + dv.join(', ') + ')' : '') + kAdd);
              }
              return; // gate satırları değer olarak yazılmaz
            }
            var v = tv(s.vals[f.prop]);
            var lk = (f.values || []).find(function (x) { return x.link && tv(x.v) === v; });
            if (v) bits.push(v + (lk && self.visible(f) ? ' (+' + self.money(self.linkPrice(lk) * (s.qty || 1)) + ')' : ''));
          } else {
            if (f.gate && s.skips[f.gate.prop]) { bits.push('Baskısız'); return; }
            var t = tv(s.txts[f.prop]);
            if (t) bits.push('"' + trUpper(t) + '"');
            else { bad = true; }
          }
        });
        if (sd.kind === 'extra') {
          var chosen = [];
          (sd.fields || []).forEach(function (f) {
            if (!isYesNo(f)) return;
            if (self._gateOn(f.prop)) {
              var title = tv(f.prop.replace(/^_/, '').replace(/\s*İsteği$/i, '').replace(/\s*EKLE$/i, ''));
              // ek tutarı (M020): total()'ın kullandığı fiyatlarla aynı
              var add = '';
              if (/bak.m\s*krem/i.test(f.prop) && self.rt.krem && self.rt.krem.id) add = ' (+' + self.money(self.rt.krem.price) + ')';
              else if (/%\s*\d+\s*[İIiı]ndirimli\s*[çÇcC]akmak|indirimli\s*[çc]akmak/i.test(f.prop) && self.rt.cakmak && self.rt.cakmak.id) add = ' (+' + self.money(self.cakmakPrice()) + ')';
              else { var lkv2 = self._gateLinkVal(f, (sd.fields || []).filter(function (d) { return (d.showIf || []).some(function (c) { return c.p === f.prop; }); })); if (lkv2) add = ' (+' + self.money(self.linkPrice(lkv2)) + ')'; }
              chosen.push(title + add);
            }
          });
          rows.push({ label: sd.label, value: chosen.length ? chosen.join(' · ') : 'Eklenmedi', muted: !chosen.length, step: si });
          return;
        }
        // ahşap kutu ek ücreti (M020): total() ile aynı hesap (kutu fiyatı × adet)
        if (sd.kind === 'box' && self.boxUpActive()) bits.push('+' + self.money((self.rt.boxUp.price || 0) * (s.qty || 1)));
        if (sd._strap) {
          bits = [];
          var cot = tv(s.vals[sd._strapCotton] || '');
          if (cot) bits.push('Pamuk askı: ' + cot + ' (hediye)');
          if (self.strapOn()) { var sv2 = self.strapVariant(); bits.push('Deri askı: ' + (sv2 ? sv2.title : tv(s.vals[sd._strapColor] || '')) + ' (+' + self.money(self.strapPrice() * (s.qty || 1)) + ')'); }
        }
        // yalnız eklenti kartından oluşan adım (ör. KESE) seçilmediyse 'Eklenmedi'
        var onlyAddon = (sd.fields || []).length && (sd.fields || []).every(function (g) { return (g.addon && isYesNo(g)) || addonOf[g.prop]; });
        if (onlyAddon && !bits.length) { rows.push({ label: sd.label, value: 'Eklenmedi', muted: true, step: si }); return; }
        rows.push({ label: sd.label, value: bad ? (bits.join(' · ') + (bits.length ? ' — ' : '') + 'isim girilmedi') : bits.join(' · '), step: si, bad: bad });
      });
      var thr = (this.rt.freeShipThreshold || 0) * 100;
      var shipRow = thr && this.total() >= thr;
      var rowsHtml = rows.map(function (r, i) {
        var lastCls = (i === rows.length - 1 && !shipRow) ? ' is-last' : '';
        return '<div class="atlc-summary__row' + (r.bad ? ' is-error' : '') + lastCls + '">' +
          '<div class="atlc-summary__main"><div class="atlc-summary__label">' + esc(r.label) + '</div>' +
          '<div class="atlc-summary__value' + (r.muted ? ' is-muted' : '') + '">' + esc(boxName(r.value)) + '</div></div>' +
          '<button type="button" class="atlc-summary__edit" data-action="step" data-step="' + r.step + '">' + (r.edit || (r.bad ? self._fillCta(self.missingIn(r.step), false) : 'Düzenle')) + '</button></div>';
      }).join('');
      if (shipRow) {
        rowsHtml += '<div class="atlc-summary__row is-last"><div class="atlc-summary__main"><div class="atlc-summary__label">KARGO</div>' +
          '<div class="atlc-summary__value is-ship">Ücretsiz kargo — ' + this.fmtNum.format(thr / 100) + ' TL üzeri</div></div>' +
          '<span class="atlc-summary__incl">✓</span></div>';
      }
      return this._stepHead({ kind: 'summary', label: 'ÖZET' }) +
        '<div class="atlc-summary">' + rowsHtml + '</div>' +
        /* 13.10.2026 kullanıcı: "Böyle basılacak" kutusu kaldırıldı — özet yeterli (fonksiyon duruyor): this._printCheckHtml() */
        // iade notu yalnız kişiselleştirilebilen üründe (en az bir metin alanı) — kişiselleştirilmemiş üründe iade VAR (M022)
        (this.fieldsFlat.some(function (f) { return f.kind === 'text'; }) ? this._noticeHtml() : '') +
        this._persCardHtml() +
        '<div class="atlc-addrow">' +
          '<div class="atlc-addrow__total"><div class="lbl">TOPLAM</div><div class="val">' + this.money(this.total()) + '</div></div>' +
          '<div class="atlc-qty">' +
            '<button type="button" class="atlc-qty__btn" data-action="qtyminus" aria-label="azalt">−</button>' +
            '<span class="atlc-qty__val">' + (s.qty || 1) + '</span>' +
            '<button type="button" class="atlc-qty__btn" data-action="qtyplus" aria-label="arttır">+</button>' +
          '</div>' +
          '<button type="button" class="atlc-add' + this._cartBtn().cls + '" data-action="cart"' + (this._cartBtn().dis ? ' disabled' : '') + '>' + this._cartBtn().txt + '</button>' +
        '</div>';
    }

    _renderTotals() {
      var t = this.total(), txt = this.money(t);
      this.$.totalM.textContent = txt;
      var v = this.querySelector('.atlc-addrow .val');
      if (v) v.textContent = txt;
      var sum = this.$.next && this.$.next.querySelector('.atlc-next__sum');
      if (sum) sum.textContent = '· ' + txt;
      // tutar değişti (krem/kutu/çakmak/adet): müşteri fark etsin diye fiyatlar kısa bir vurguyla "zıplar"
      if (this._lastTotal != null && this._lastTotal !== t) {
        [this.$.now, this.$.totalM, sum, v].forEach(function (el) {
          if (!el) return;
          el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
        });
      }
      this._lastTotal = t;
    }

    // eksik metin alanının CTA'sı TEK yerden (M024): kısa alan (en çok 5 harf — baş harf) 'HARFLERİ GİR', diğerleri 'İSMİNİ GİR'
    _fillCta(miss, arrow) {
      var f = miss && miss[0], max = f ? (f.max || 20) : 20;
      return (max <= 5 ? 'HARFLERİ GİRİN' : 'İSMİNİZİ GİRİN') + (arrow ? ' →' : '');
    }
    /* GERİ/DEVAM — eksik isimde "İSMİNİ GİR →" / "HARFLERİ GİR →" (brick) */
    _renderNav() {
      var s = this.state, isSummary = this.steps[s.step] && this.steps[s.step].kind === 'summary';
      var st = this.$.stickyBtn;
      if (this._failed) { // veri yüklenemedi: adım/sepet yok; sticky CTA "Yeniden deneyin" olur
        this.$.nav.style.display = 'none';
        if (st) { st.textContent = 'YENİDEN DENEYİN'; st.disabled = false; st.classList.remove('is-nudge', 'is-added', 'is-soldout'); }
        return;
      }
      this.$.nav.style.display = isSummary ? 'none' : 'flex';
      this.$.back.style.display = s.step > 0 ? 'inline-flex' : 'none';
      var miss = this.missingIn(s.step);
      // tükenmiş varyant seçiliyken varyant adımında DEVAM yerine uyarı (buton kapalı)
      var soStep = !isSummary && this.steps[s.step] && this.steps[s.step].kind === 'variant' && this.soldOut();
      var soMsg = trUpper(this._soldOutMsg());
      // DEVAM toplamı da gösterir (masaüstünde başlıktaki fiyat kaydırınca görünmeyebiliyor)
      if (soStep) this.$.next.textContent = soMsg;
      else if (miss.length) this.$.next.textContent = this._fillCta(miss, true);
      else if (!this.$.next.querySelector('.atlc-next__sum')) this.$.next.innerHTML = 'DEVAM <span class="atlc-next__sum">· ' + this.money(this.total()) + '</span>';
      // etiket zaten varsa tutarı _renderTotals günceller (vurgu sınıfı silinmesin)
      this.$.next.disabled = !!soStep;
      if (this.$.skipNext) this.$.skipNext.hidden = isSummary || !!soStep || !miss.length || !miss.every(function (f) { return !!f.gate; });
      this.$.next.classList.toggle('is-soldout', !!soStep);
      this.$.next.classList.toggle('is-nudge', !soStep && miss.length > 0);
      this._renderNotify();
      var nOn = this._notifyOn(); // tükendi + STOQ: mobil sabit düğme "GELİNCE HABER VERİN" olur, formu açar
      // sticky (mobil): adımlarda DEVAM, özette CTA
      if (st) {
        if (isSummary) {
          var can = this.canAdd(), so = this.soldOut() && !s.added;
          st.textContent = s.added ? (this._editDone ? 'SEPET GÜNCELLENDİ ✓' : 'SEPETE EKLENDİ ✓') : (so ? (nOn ? 'GELİNCE HABER VERİN' : soMsg) : (can ? (this._edit ? 'SEPETİ GÜNCELLE' : 'SEPETE EKLEYİN') : this._fillCta(this.missingAll(), true)));
          st.disabled = so && !nOn;
          st.classList.toggle('is-soldout', so && !nOn);
          st.classList.toggle('is-nudge', !so && !can && !s.added);
          st.classList.toggle('is-added', !!s.added);
        } else {
          st.textContent = this._wizOff ? '✎ KİŞİSELLEŞTİRİN' : (soStep ? (nOn ? 'GELİNCE HABER VERİN' : soMsg) : (miss.length ? this._fillCta(miss, true) : 'DEVAM →'));
          st.disabled = !!soStep && !nOn;
          st.classList.toggle('is-soldout', !!soStep && !nOn);
          st.classList.toggle('is-nudge', !this._wizOff && !soStep && miss.length > 0);
          st.classList.remove('is-added');
          if (this._wizOff) { st.disabled = false; st.classList.remove('is-soldout'); }
        }
      }
    }
    stickyCta() {
      if (this._failed) return this.retryLoad();
      var isSummary = this.steps[this.state.step] && this.steps[this.state.step].kind === 'summary';
      if (this._wizOff && !isSummary && this.$.wizard) {
        window.scrollTo({ top: this.$.wizard.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
        return;
      }
      if (this._notifyOn() && (isSummary ? !this.state.added : this.steps[this.state.step].kind === 'variant')) return this.openNotify(true);
      if (isSummary) return this.addToCart();
      return this.goNext();
    }

    // özet butonunun etiketi tek yerden: şablon (_bodySummary) ve canlı güncelleme (_renderCart) aynı sonucu verir
    _cartBtn() {
      if (this._failed) return { txt: 'SEPETE EKLENEMİYOR', cls: ' is-soldout', dis: true };
      if (this.state.added) return { txt: this._editDone ? 'SEPET GÜNCELLENDİ ✓' : 'SEPETE EKLENDİ ✓', cls: ' is-added' };
      if (this.soldOut()) return { txt: trUpper(this._soldOutMsg()), cls: ' is-soldout', dis: true };
      return this.canAdd() ? { txt: this._edit ? 'SEPETİ GÜNCELLE' : 'SEPETE EKLEYİN', cls: '' } : { txt: this._fillCta(this.missingAll(), true), cls: ' is-nudge' };
    }
    _renderCart() {
      var st = this._cartBtn(), busy = this._adding;
      this.querySelectorAll('.atlc-addrow [data-action="cart"]').forEach(function (b) {
        b.classList.remove('is-added', 'is-nudge', 'is-soldout');
        b.textContent = st.txt;
        if (st.cls) b.classList.add(st.cls.trim());
        if (st.dis) b.disabled = true;
        else if (!busy) b.disabled = false;
      });
    }

    /* ---------- teşvikler ---------- */
    _etaDate(businessDays) {
      var MONTHS = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
      var d = new Date(), added = 0, guard = 0;
      while (added < businessDays && guard < 30) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; guard++; }
      return d.getDate() + ' ' + MONTHS[d.getMonth()];
    }
    // teslim aralığı tek kaynak: tema ayarları → Atlanticus · Teslimat & politika (eta_*)
    _eta() {
      var e = this.rt.eta || {};
      var n = function (v, d) { return v != null ? Number(v) : d; };
      return { sMin: n(e.shipMin, 2), sMax: n(e.shipMax, 3), dMin: n(e.delMin, 2), dMax: n(e.delMax, 3) };
    }
    _shipTabHtml() { return this._shipWhenHtml() + this._returnHtml(); }
    _shipWhenHtml() {
      var e = this._eta(), thr = this.rt.freeShipThreshold || 0;
      var when = (e.sMin === e.dMin && e.sMax === e.dMax)
        ? 'Siparişiniz <strong>' + e.dMin + '–' + e.dMax + ' iş günü</strong> içinde kapınızda.'
        : 'Siparişiniz ' + e.sMin + '–' + e.sMax + ' iş gününde <strong>DHL Kargo</strong>\'ya verilir, <strong>' + e.dMin + '–' + e.dMax + ' iş günü</strong> içinde kapınızda.';
      // 20.10.2026 kullanıcı (sabit site metinler.pdf → Kargo Süreci): DHL + hesaptan takip paragrafı
      return '<p>' + when + (thr ? ' ' + Number(thr).toLocaleString('tr-TR') + ' TL üzeri kargo ücretsizdir.' : '') + '</p>' +
        // 20.10.2026 kullanıcı: Süper Hızlı Kargo (ücretli ek seçenek) — 21.10.2026: ödeme sayfasındaki yöntem kapatıldı, seçim SEPETTE (+200 TL ürün)
        '<p>Acele mi? Sepette <strong>Süper Hızlı Kargo</strong>\'yu (+200 TL) seçerseniz üretiminiz öne alınır; gün içinde verilen siparişiniz <strong>ertesi iş günü kargoya teslim</strong> edilir.</p>' +
        '<p>Siparişiniz kargoya verildikten sonra <strong>Kolektif Tasarım üyeliğinizle hesabınıza giriş yaparak</strong> kargo sürecini ve güncel gönderi durumunu takip edebilir, kargonun nerede olduğunu görebilirsiniz.</p>';
    }
    _returnHtml() {
      // 20.10.2026 kullanıcı (sabit site metinler.pdf → Değişim ve İade + Değişim & İade), sen diline çevrildi
      return '<p>Kişiselleştirilmemiş ürünlerde teslimden itibaren <strong>14 gün</strong> içinde iade ve değişim kabul edilir.</p>' +
        // 20.10.2026 kullanıcı: "hesaptan iade formu" cümlesi şimdilik kaldırıldı (canlıya alınca konuşulacak; Shopify iade talebi ayarı)
        '<p><strong>İade ve değişimlerde kargo ücreti alıcıya aittir.</strong> Ürün bizden kaynaklanan bir hata nedeniyle iade ediliyorsa, size ileteceğimiz <strong>Kolektif Tasarım anlaşmalı kargo kodu</strong> ile ücretsiz gönderebilirsiniz.</p>' +
        '<p>İade ya da değişim yapılacak ürün <strong>kullanılmamış ve hasarsız</strong> olmalıdır. Ürünü size gönderildiği <strong>korumalı paketle</strong>, taşıma sırasında zarar görmeyecek şekilde paketleyip gönderin; uygun paketlenmediği için oluşan hasarlardan Kolektif Tasarım sorumlu değildir.</p>' +
        '<p><strong>Kişiselleştirilmiş ürünlerde iade ve değişim yapılmaz.</strong> Kişiye ya da kuruma özel hazırlanan ürünler, kişiselleştirme tamamlandıktan sonra başka birine sunulamayacağı için iade kapsamı dışındadır. Kusurlu gelen ya da yanlış hazırlanan ürünü ücretsiz yeniden üretiriz.</p>';
    }
    _timelineHtml() {
      // hareketli çizgi ikonlar (11.10.2026): dikiş + iğne / kargo aracı / eve gelen paket. CSS: .tla-*
      var A_MAKE = '<svg viewBox="0 0 48 48" aria-hidden="true" class="tla-c"><g transform="translate(0 3)"><rect x="3" y="36" width="42" height="5" rx="1" fill="none" stroke="currentColor" stroke-width=".9"/><path d="M5 37.5h38M5 39.5h38" stroke="currentColor" stroke-width=".35"/><circle cx="9" cy="38.5" r=".9" fill="currentColor"/><circle cx="13" cy="38.5" r=".9" fill="currentColor"/><circle cx="17" cy="38.5" r=".9" fill="currentColor"/><g class="tla-punch"><rect x="20.5" y="24" width="4" height="12" rx=".6" fill="none" stroke="currentColor" stroke-width=".9"/><path d="M21.6 25v10M23.4 25v10" stroke="currentColor" stroke-width=".35"/><rect x="19" y="21.5" width="7" height="2.6" rx=".8" fill="none" stroke="currentColor" stroke-width=".9"/></g><g class="tla-hit"><path d="M16 21l-3-1.5M29 21l3-1.5M22.5 19.5v-3" stroke="currentColor" stroke-width=".8" stroke-linecap="round"/></g><g class="tla-ham"><rect x="15" y="14" width="14" height="7.5" rx="1.6" fill="#fff" stroke="currentColor" stroke-width=".9"/><path d="M16.5 15.8h11M16.5 17.7h11M16.5 19.6h11" stroke="currentColor" stroke-width=".35"/><path d="M29 16.7h7M29 18.7h7" stroke="currentColor" stroke-width=".8"/><path d="M35 13.5h4.5a3.5 3.5 0 0 1 3.5 3.5v1.5a3.5 3.5 0 0 1-3.5 3.5H35z" fill="#fff" stroke="currentColor" stroke-width=".9"/><path d="M37.4 13.6v8.4M39.6 13.8v8M41.6 14.6v6.8" stroke="currentColor" stroke-width=".5"/><path d="M43 19l3.5 6" stroke="currentColor" stroke-width=".9" stroke-linecap="round"/></g></g></svg>';
      var A_TRUCK = '<svg viewBox="0 0 48 48" aria-hidden="true" class="tla-c"><path class="tla-wind" d="M2 18h9M4 24h7" fill="none" stroke="currentColor" stroke-width=".8" stroke-linecap="round"/><g class="tla-truck"><rect x="12" y="14" width="18" height="16" fill="#fff" stroke="currentColor" stroke-width=".9"/><path d="M14 17h14M14 20h14M14 23h14M14 26h14" stroke="currentColor" stroke-width=".35"/><path d="M30 19h7l5 6v5H30z" fill="#fff" stroke="currentColor" stroke-width=".9" stroke-linejoin="round"/><path d="M33 19.5v5.5h8.3" fill="none" stroke="currentColor" stroke-width=".6"/><path d="M31.5 27.5h9" stroke="currentColor" stroke-width=".35"/><circle cx="18" cy="31" r="3" fill="#fff" stroke="currentColor" stroke-width=".9"/><circle cx="18" cy="31" r="1.1" fill="none" stroke="currentColor" stroke-width=".5"/><circle cx="36" cy="31" r="3" fill="#fff" stroke="currentColor" stroke-width=".9"/><circle cx="36" cy="31" r="1.1" fill="none" stroke="currentColor" stroke-width=".5"/></g><path class="tla-road" d="M2 37h44" fill="none" stroke="currentColor" stroke-width=".8" stroke-linecap="round"/></svg>';
      var A_HOME = '<svg viewBox="0 0 48 48" aria-hidden="true" class="tla-c"><path d="M22 22l11-9 11 9" fill="none" stroke="currentColor" stroke-width=".9" stroke-linecap="round" stroke-linejoin="round"/><path d="M25.5 19.5l7.5-6.2 7.5 6.2" fill="none" stroke="currentColor" stroke-width=".35"/><path d="M26 19.6v-.9M28.5 19.6v-2.9M31 19.6v-5M33 19.6v-6.4M35.5 19.6v-4.6M38 19.6v-2.5M40.5 19.6v-.5" stroke="currentColor" stroke-width=".35"/><path d="M25 20v17h16V20" fill="none" stroke="currentColor" stroke-width=".9" stroke-linejoin="round"/><path d="M30 37v-7h6v7" fill="#fff" stroke="currentColor" stroke-width=".9"/><g class="tla-pkg"><rect x="3" y="29" width="9" height="8" rx="1" fill="#fff" stroke="currentColor" stroke-width=".9"/><path d="M3 32h9" stroke="currentColor" stroke-width=".6"/><path d="M4.5 34h6M4.5 35.5h6" stroke="currentColor" stroke-width=".35"/></g><path class="tla-ok" d="M37 9l2.5 2.5L44 7" fill="none" stroke="currentColor" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var today = new Date();
      var MONTHS = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
      var todayTxt = today.getDate() + ' ' + MONTHS[today.getMonth()];
      var node = function (ico, lbl, date, line, sub) {
        return '<div class="atlc-tl__step">' + (line ? '<span class="atlc-tl__line"></span>' : '') +
          '<span class="atlc-tl__circle">' + ico + '</span>' +
          '<span class="atlc-tl__lbl">' + esc(lbl) + '</span>' +
          (sub ? '<span class="atlc-tl__sub">' + esc(sub) + '</span>' : '') +
          '<span class="atlc-tl__date">' + esc(date) + '</span></div>';
      };
      // aralık tema ayarından (tek kaynak); 20.10.2026 kullanıcı: altta "Süper Hızlı Kargo / Ertesi iş günü kargoya teslim" notu (ücretli seçenek, ödeme sayfasında)
      var e = this._eta();
      // kargoya veriliş ve kapıya teslim aynı aralıksa tek süre gösterilir (aynı tarihi iki kez yazma)
      var single = e.sMin === e.dMin && e.sMax === e.dMax;
      return '<div class="atlc-tl' + (single ? ' is-single' : '') + '">' +
        '<div class="atlc-tl__steps">' +
          node(A_MAKE, 'Siparişiniz Verildi', todayTxt, false, 'Üretime başladık') +
          (single ? '' : node(A_TRUCK, 'Kargoya Verildi', this._etaDate(e.sMin) + ' – ' + this._etaDate(e.sMax), true, 'Çok az kaldı')) +
          node(A_HOME, 'Siparişiniz Kapınızda', this._etaDate(e.dMin) + ' – ' + this._etaDate(e.dMax), true, 'İyi günlerde kullanın') +
        '</div>' +
        // 13.10.2026 kullanıcı: büyükşehirlere hızlı teslim notu (tema ayarı eta_note)
        (this.rt.etaNote ? '<p class="atlc-tl__note atlc-tl__note--city">' + esc(this.rt.etaNote) + '</p>' : '') +
        '<p class="atlc-tl__note atlc-tl__note--fast"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 2 4 14h7l-1 8 9-12h-7z" fill="currentColor"/></svg><strong>Süper Hızlı Kargo</strong> / Ertesi iş günü kargoya teslim</p>' +
      '</div>';
    }
    _contentsHtml() {
      var items = [];
      if (this.rt.contentsRaw) {
        items = String(this.rt.contentsRaw).split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
      }
      if (!items.length) return '';
      return '<div class="atlc-contents">' +
        '<div class="atlc-contents__label">PAKETİNİZİN İÇİNDEKİLER</div>' +
        '<div class="atlc-contents__row">' + items.map(function (t) {
          return '<span class="atlc-contents__item">' + esc(t) + '</span>';
        }).join('') + '</div>' +
      '</div>';
    }
    _renderIncentive() {
      var ship = this.$.ship;
      if (ship) {
        var thr = (this.rt.freeShipThreshold || 0) * 100;
        if (!thr) { ship.style.display = 'none'; }
        else {
          var t = this.total();
          if (t >= thr) {
            ship.className = 'atlc-ship is-met';
            ship.style.display = 'flex';
            ship.innerHTML = '<span class="atlc-ship__ok">✓</span><span><strong>Ücretsiz kargo</strong> — siparişiniz ' + this.fmtNum.format(thr / 100) + ' TL üzeri.</span>';
          } else {
            var pct = Math.max(6, Math.min(96, Math.round(t / thr * 100)));
            var fill = ship.querySelector('.atlc-ship__fill');
            if (fill && ship.className === 'atlc-ship') {
              // yapı korunur -> width geçişi (.35s) animasyonlanır
              fill.style.width = pct + '%';
              var rem = ship.querySelector('.atlc-ship__rem');
              if (rem) rem.textContent = this.money(thr - t);
            } else {
              ship.className = 'atlc-ship';
              ship.style.display = 'block';
              ship.innerHTML =
                // kargo ücreti + kalan tek satırda (12.10.2026, kullanıcı: C seçeneği); ücret tema ayarından (shipFee, TL)
                '<div class="atlc-ship__row">' + ICON_TRUCK + '<span>' + (this.rt.shipFee ? 'Kargo <strong>' + Number(this.rt.shipFee).toLocaleString('tr-TR') + ' TL</strong> · ' : '') +
                'Ücretsiz kargoya <strong class="atlc-ship__rem">' + this.money(thr - t) + '</strong> kaldı</span></div>' +
                '<div class="atlc-ship__track"><div class="atlc-ship__fill" style="width:' + pct + '%"></div></div>';
            }
          }
        }
      }
      // set önerisi (12.10.2026): bu ürünü içeren setler (en çok 3; fazlası "Tüm setleri gör").
      // Ücretsiz kargo eşiği aşılmışsa da gösterilir ama kargo yazısı/etiketi olmaz. Ürün hiçbir sette yoksa: "Bununla iyi gider"
      // (Shopify öneri API'si, 3 ürün) + ek ürün adımına götüren bağlantı.
      var srEl = this.querySelector('[data-setrecs]'), SR = this.rt.setRecs || {}, self2 = this;
      // 12.10.2026: ÖZET adımında öneriler gizleniyordu; 17.10.2026 kullanıcı ("birlikte al setlerini de ekle", Pasaport özet ekranı) → özette de görünür
      if (srEl) srEl.classList.remove('is-off');
      // 17.10.2026 kullanıcı: "hediye kutu koleksiyonundaki tekli kutulara bununla iyi gider ekleme, o alan kalksın" → kutularda öneri yok
      if (srEl && /^hediye-kutusu-/.test(this.rt.handle || '')) srEl.hidden = true;
      else if (srEl) {
        var thr2 = (this.rt.freeShipThreshold || 0) * 100, met = !!(thr2 && this.total() >= thr2), key = met ? 'met' : 'open';
        var nameOf = function (h, t) { return (self2.rt.adMap && self2.rt.adMap[h]) || t; };
        var card = function (u, img, t, p, c, free, cta) {
          return '<a class="atlc-setrec" href="' + esc(u) + '"><span class="atlc-setrec__img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(t) + '" loading="lazy">' : '') + (free ? '<span class="atlc-setrec__free">Ücretsiz kargo</span>' : '') + '</span>' +
            '<span class="atlc-setrec__n">' + esc(t) + '</span>' + (p > 0 ? '<span class="atlc-setrec__p">' + self2.money(p) + (c ? ' <s>' + self2.money(c) + '</s>' : '') + '</span>' : '') + // 17.10.2026: fiyatı girilmemiş (0) sette fiyat yazmaz
            (cta ? '<span class="atlc-setrec__cta">Sete geç →</span>' : '') + '</a>';
        };
        var BR = this.rt.blackRecs || [];
        if (BR.length) {
          // 21.10.2026 kullanıcı: Black Edition'da set yerine siyah çanta / cüzdan / aksesuar; her açılışta rastgele 3
          // (önce her gruptan birer, eksik kalırsa kalanlardan). data-k ile sayfa içinde bir kez seçilir.
          if (srEl.getAttribute('data-k') !== 'black') {
            srEl.setAttribute('data-k', 'black');
            var shuf = function (a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; };
            var pick = [];
            ['canta', 'cuzdan', 'aksesuar'].forEach(function (g) { var x = shuf(BR.filter(function (it) { return it.g === g; }))[0]; if (x) pick.push(x); });
            shuf(BR).forEach(function (it) { if (pick.length < 3 && pick.indexOf(it) < 0) pick.push(it); });
            pick = shuf(pick).slice(0, 3);
            srEl.classList.remove('is-push', 'is-rel'); srEl.classList.add('is-sets');
            srEl.innerHTML = '<div class="atlc-setrecs__head"><span class="atlc-setrecs__t">' + esc(this.rt.blackRecsTitle || 'Siyah renkte keşfedin') + '</span></div>' +
              '<div class="atlc-setrecs__row">' + pick.map(function (it) { return card(it.u, it.i, it.t, it.p, it.c, false, false); }).join('') + '</div>';
          }
          srEl.hidden = false;
        } else if ((SR.items || []).length) {
          if (srEl.getAttribute('data-k') !== key) {
            srEl.setAttribute('data-k', key);
            // kargo sınırının altındaysa: sete yönlendir — ücretsiz kargoya giren setler öne, başlık "Seti al, kargo bizden", her kartta "Sete geç"
            var items = SR.items.slice();
            var push = SR.push || (!met && thr2 && items.some(function (it) { return it.p >= thr2; })); // 17.10.2026: cüzdanlarda (SR.push) her zaman
            if (push) items.sort(function (a, b) { return (b.p >= thr2) - (a.p >= thr2); });
            items = items.slice(0, 3); // setlerde 3 kart (tam genişlik)
            srEl.classList.toggle('is-push', !!push); srEl.classList.add('is-sets'); srEl.classList.remove('is-rel');
            // 17.10.2026: ürün hiçbir sette yoksa (SR.fb) İmza setleri önerilir — başlık/metin buna göre
            srEl.innerHTML = '<div class="atlc-setrecs__head"><span class="atlc-setrecs__t">' + (push ? 'Seti alın, kargo bizden' : (SR.fb ? 'İmza setlerimiz' : 'Bu ürün setlerimizde de var')) + '</span>' +
              (push ? '<span class="atlc-setrecs__s">' + (SR.fb ? 'İmza setlerimize göz atın.' : 'Bu ürün aşağıdaki setlerde de var.') + ' Seti seçerseniz kargo ücretsiz, hediyeniz tek kutuda daha anlamlı.</span>' : '') + '</div>' +
              '<div class="atlc-setrecs__row">' + items.map(function (it) { return card(it.u, it.i, it.t, it.p, it.c, push && it.p >= thr2, push); }).join('') + '</div>' +
              (SR.count > 3 ? '<a class="atlc-setrecs__all" href="' + esc(SR.all) + '">Tüm setleri gör (' + SR.count + ') →</a>' : '');
          }
          srEl.hidden = false;
        } else if (!this._relAsked && this.rt.routes && this.rt.routes.recommendations && this.rt.productId) {
          this._relAsked = true;
          var exIdx = this.steps.findIndex(function (st) { return st.kind === 'extra'; });
          // öneri sırası: 1) "complementary" (Shopify Search & Discovery'de tamamlayıcı ürünler / birlikte satın alınanlar tanımlıysa),
          // 2) "related" (Shopify satış verisi biriktikçe birlikte alınanlara göre öğrenir). Her ikisinde de aynı kategorideki ürünler
          // (çantaya çanta) ve setler elenir.
          var recBase = this.rt.routes.recommendations.replace(/\.json$/, '') + '.json?product_id=' + this.rt.productId;
          var cat = this.rt.catMap || {}, myCat = cat[this.rt.handle];
          var okRec = function (p) { return p.available && p.handle !== self2.rt.handle && cat[p.handle] !== 'hediye-setleri' && !(myCat && cat[p.handle] === myCat); };
          var getRecs = function (intent) { return fetch(recBase + '&limit=10&intent=' + intent).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) { return ((d && d.products) || []).filter(okRec); }).catch(function () { return []; }); };
          // 16.10.2026: fbRandom (Silhouette clutch) → yalnız yedek liste, her açılışta karışık sırayla
          var fbList = (self2.rt.fbRecs || []).slice();
          if (self2.rt.fbRandom) for (var fi = fbList.length - 1; fi > 0; fi--) { var fj = Math.floor(Math.random() * (fi + 1)), ft = fbList[fi]; fbList[fi] = fbList[fj]; fbList[fj] = ft; }
          // 17.10.2026: çantalarda (fbMix) cüzdan (g:w) ve aksesuar (g:a) sırayla — ilk 4 kart 2 cüzdan + 2 aksesuar
          if (self2.rt.fbMix) {
            var mw = fbList.filter(function (p) { return p.g !== 'a'; }), ma = fbList.filter(function (p) { return p.g === 'a'; });
            fbList = [];
            for (var mi = 0; mi < Math.max(mw.length, ma.length); mi++) { if (mw[mi]) fbList.push(mw[mi]); if (ma[mi]) fbList.push(ma[mi]); }
          }
          (self2.rt.fbRandom || self2.rt.fbFixed ? Promise.resolve([]) : getRecs('complementary')).then(function (a) { return (self2.rt.fbRandom || self2.rt.fbFixed || a.length >= 3) ? a : getRecs('related').then(function (b) { var seen = {}; return a.concat(b).filter(function (p) { if (seen[p.handle]) return false; seen[p.handle] = 1; return true; }); }); })
            .then(function (all) {
              var seen2 = {}; all.forEach(function (p) { seen2[p.handle] = 1; });
              var ps = all.concat(fbList.filter(function (p) { return !seen2[p.handle]; })).slice(0, 4); // satış verisi yokken yedek liste
              if (!ps.length && exIdx < 0) return;
              srEl.classList.add('is-rel'); srEl.classList.remove('is-sets');
              srEl.innerHTML = '<div class="atlc-setrecs__head"><span class="atlc-setrecs__t">' + esc(self2.rt.relTitle || 'Bununla iyi gider') + '</span></div>' + // 17.10.2026: çantalarda "Birlikte alın"
                (ps.length ? '<div class="atlc-setrecs__row">' + ps.map(function (p) { return card(p.url, p.featured_image, nameOf(p.handle, p.title), p.price, (p.compare_at_price > p.price ? p.compare_at_price : null), false); }).join('') + '</div>' : '') +
                (exIdx >= 0 ? '<button type="button" class="atlc-setrecs__all atlc-setrecs__btn" data-action="step" data-step="' + exIdx + '">Birlikte al fırsatlarını görün →</button>' : '');
              srEl.hidden = false;
            });
        }
      }
      if (this.$.eta && !this.$.eta.firstChild) {
        this.$.eta.innerHTML = this._timelineHtml();
      }
    }

    /* v2: bilgi sekmelerinin altındaki güven ikonları satırı — eski siteyle birebir 4 ikon
       (brand-ico-*.png, section'dan asset_url ile geçirilir; ikon yoksa o kart atlanır) */
    /* Kurumsal sipariş bandı (10.10.2026): toplu sipariş / iş birliği teklifine yönlendirir. Dil 'siz' (firma sahibine). */
    // 17.10.2026 kullanıcı: hediye kutularında toplu ahşap kutu üretimi bölümü (tasarım B: görselli kart, yalnız "Teklif al")
    _boxMakeHtml() {
      var bm = this.rt.boxMake; if (!bm) return '';
      var url = this.rt.b2bUrl || '/pages/kurumsal';
      var I = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' + d + '</svg>'; };
      return '<div class="atlc-boxmake">' +
        (bm.img ? '<div class="atlc-boxmake__img"><img src="' + esc(bm.img) + '" alt="Ahşap hediye kutusu" loading="lazy" width="400" height="400"></div>' : '') +
        '<div class="atlc-boxmake__txt">' +
          '<div class="atlc-b2b__k">Toplu ahşap kutu üretimi</div>' +
          '<p class="atlc-boxmake__h">Ölçüsü de tasarımı da size göre.</p>' +
          '<p class="atlc-boxmake__p">Kutularımız kendi atölyemizde üretiliyor. Toplu siparişlerde istediğiniz ölçüde kutu yapabilir, kapak ve iç tasarımını değiştirebiliriz.</p>' +
          '<div class="atlc-boxmake__row">' +
            '<span>' + I('<rect x="2.5" y="8" width="19" height="8" rx="1"/><path d="M6 8v3M9.5 8v4M13 8v3M16.5 8v4M20 8v3"/>') + 'Ölçü</span>' +
            '<span>' + I('<path d="M3 9l9-4 9 4-9 4z"/><path d="M3 9v8l9 4 9-4V9"/>') + 'Kapak</span>' +
            '<span>' + I('<rect x="3" y="4" width="18" height="16" rx="1"/><path d="M12 4v16M3 12h9"/>') + 'İç tasarım</span>' +
          '</div>' +
          '<a class="atlc-b2b__btn" href="' + esc(url) + '">Teklif alın</a>' +
        '</div>' +
      '</div>';
    }

    // 17.10.2026 kullanıcı: Devam / Sepete Ekle altında "Satış danışmanıyla görüş" (telefonla arama; numara bölüm ayarında)
    _advisorHtml() {
      var t = String(this.rt.advisorTel || '').trim();
      if (!t) return '';
      var d = t.replace(/[^\d+]/g, '');
      if (d.charAt(0) === '0') d = '+90' + d.slice(1);
      // 21.10.2026 kullanıcı: arama yerine WhatsApp; firmaya hazır mesaj "X ürünü ile ilgili sizlere ulaşıyorum" + ürün bağlantısı
      var msg = String(this.rt.title || document.title || '').trim() + ' ürünü ile ilgili sizlere ulaşıyorum.\n' +
        location.origin + '/products/' + (this.rt.handle || '');
      var wa = 'https://wa.me/' + d.replace(/\D/g, '') + '?text=' + encodeURIComponent(msg);
      return '<a class="atlc-advisor" href="' + esc(wa) + '" target="_blank" rel="noopener" aria-label="Satış danışmanıyla WhatsApp\'tan görüşün">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8.5 8.5 0 0 1-12.6 7.4L3 21l1.6-5.2A8.5 8.5 0 1 1 21 12z"/></svg>' +
        'Satış danışmanıyla görüş</a>';
    }
    // 17.10.2026 kullanıcı: "Stok yoksa Gelince haber ver" — seçili varyant tükendiyse e-posta + izin kutusu; kayıt STOQ'a
    // (panel → Uygulamalar → STOQ → Back in stock alerts). Görünürlük _renderNotify'da (varyant adımı ve özet).
    _notifyHtml() {
      return '<div class="atlc-notify" data-notify hidden>' +
        '<button type="button" class="atlc-notify__btn" data-action="notifyopen" aria-expanded="false">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>' +
          'Gelince haber verin</button>' +
        '<form class="atlc-notify__box" data-notify-form novalidate hidden>' +
          '<p class="atlc-notify__t" data-notify-t></p>' +
          '<p class="atlc-notify__s">E-posta adresinizi bırakın; stoğa girdiği an size yazalım.</p>' +
          '<div class="atlc-notify__row">' +
            '<input type="email" name="email" autocomplete="email" inputmode="email" placeholder="E-posta adresiniz" aria-label="E-posta adresiniz">' +
            '<button type="submit">Haber verin</button>' +
          '</div>' +
          '<label class="atlc-notify__ok"><input type="checkbox" name="ok">Ürün gelince haber verilmesine ve kampanya e-postalarına izin veriyorum.</label>' +
          '<p class="atlc-notify__msg" data-notify-msg role="status" aria-live="polite"></p>' +
        '</form>' +
      '</div>';
    }
    // düğme yalnız: STOQ sayfada + seçili birleşim gerçekten var ama tükenmiş + (varyant adımı ya da özet; varyantsız üründe her adım)
    _notifyOn() {
      if (this._failed || !stoqCfg() || !this.soldOut() || !this.exactVariant()) return false;
      var sd = this.steps && this.steps[this.state.step];
      return !this.rt.hasVariants || !sd || sd.kind === 'variant' || sd.kind === 'summary';
    }
    _notifyName() { return this.rt.hasVariants ? (this.state.optSel || []).join(' / ') : ''; }
    _renderNotify() {
      var w = this.querySelector('[data-notify]');
      if (!w) return;
      var on = this._notifyOn();
      w.hidden = !on;
      if (!on) return;
      var v = this.exactVariant(), nm = this._notifyName();
      w.querySelector('[data-notify-t]').textContent = (nm || 'Bu ürün') + ' gelince haber verelim';
      var f = w.querySelector('[data-notify-form]'), done = (this._notifyDone || {})[v.id];
      if (this._notifyKey !== v.id) { // varyant değişti: önceki iletiyi temizle (kayıtlı varyantta "tamam" iletisi kalır)
        this._notifyKey = v.id;
        var m = f.querySelector('[data-notify-msg]');
        m.textContent = done || '';
        m.className = 'atlc-notify__msg' + (done ? ' is-ok' : '');
      }
      f.classList.toggle('is-done', !!done);
    }
    openNotify(focus) {
      var w = this.querySelector('[data-notify]');
      if (!w || w.hidden) return;
      var f = w.querySelector('[data-notify-form]'), b = w.querySelector('[data-action="notifyopen"]');
      f.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      var r = f.getBoundingClientRect(), vh = window.innerHeight || 700;
      if (r.top < 70 || r.bottom > vh - 90) window.scrollTo({ top: window.pageYOffset + r.top - Math.max(90, (vh - r.height) / 2), behavior: 'smooth' });
      if (focus && !f.classList.contains('is-done')) setTimeout(function () { f.email.focus({ preventScroll: true }); }, 250);
    }
    sendNotify(f) {
      var self = this, v = this.exactVariant(), m = f.querySelector('[data-notify-msg]'), btn = f.querySelector('button[type="submit"]');
      var say = function (t, c) { m.textContent = t; m.className = 'atlc-notify__msg' + (c ? ' ' + c : ''); };
      var em = String(f.email.value || '').trim();
      if (!v || this._notifyBusy) return;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { say('Geçerli bir e-posta adresi yazın.', 'is-bad'); f.email.focus(); return; }
      if (!f.ok.checked) { say('Kaydolmak için izin kutusunu işaretleyin.', 'is-bad'); return; }
      this._notifyBusy = true; btn.disabled = true; say('Kaydediliyor…');
      var nm = this._notifyName();
      stockSignup({ email: em, consent: true, variantId: v.id, productId: this.rt.productId, title: this.rt.title || '', variantTitle: v.title || nm })
        .then(function (r) {
          if (r === 'ok' || r === 'dup') {
            var t = r === 'ok' ? 'Tamam! ' + (nm || 'Ürün') + ' gelince size e-posta göndereceğiz.' : 'Bu e-postayla zaten kayıtlısınız; gelince size haber vereceğiz.';
            (self._notifyDone = self._notifyDone || {})[v.id] = t;
            say(t, 'is-ok'); f.classList.add('is-done');
            self._track && self._track('stock_notify', { variant: v.id, dup: r === 'dup' });
          } else if (r === 'bad-email') { say('Bu e-posta adresi kabul edilmedi; başka bir adres deneyin.', 'is-bad'); }
          else say('Şu an kaydedemedik. Biraz sonra tekrar deneyin.', 'is-bad');
        })
        .catch(function () { say('Şu an kaydedemedik. Biraz sonra tekrar deneyin.', 'is-bad'); })
        .then(function () { self._notifyBusy = false; btn.disabled = false; });
    }
    _b2bHtml() {
      var url = this.rt.b2bUrl || '/pages/kurumsal';
      // referans logoları (12.10.2026): ayrı ayrı, gri; üzerine gelince kırmızı. Başlık logoların üstünde.
      var LL = this.rt.b2bLogoList || [];
      // örnek marka baskıları (17.10.2026 kullanıcı: emaye kupalarda marka baskılı kupa görselleri)
      var EX = this.rt.b2bExamples || [];
      var exs = EX.length ? '<p class="atlc-b2b__ref">Örnek marka baskıları</p><div class="atlc-b2b__ex">' + EX.map(function (e) { return '<figure><img src="' + esc(e.src) + '" alt="' + esc(e.n) + ' baskılı emaye kupa" loading="lazy" width="500" height="500"></figure>'; }).join('') + '</div>' : '';
      var logos = LL.length ? '<p class="atlc-b2b__ref">Bizi tercih eden değerli firmalar</p><div class="atlc-b2b__logos">' + LL.map(function (l) { return '<img src="' + esc(l.src) + '" alt="' + esc(l.n) + '" title="' + esc(l.n) + '" loading="lazy" style="height:' + (l.h || 34) + 'px">'; }).join('') + '</div>' : '';
      return '<div class="atlc-b2b">' +
        '<div class="atlc-b2b__k">Kurumsal sipariş</div>' + // ikon kaldırıldı, yazı başlıkla aynı hizada (kullanıcı, 12.10.2026)
        '<p class="atlc-b2b__h">Bu ürün kurumsal hediye ve toplu siparişe uygundur.</p>' +
        '<p class="atlc-b2b__p">Markanızın logosu ya da çalışanlarınızın isimleriyle, adet bazlı özel fiyatlandırmayla üretiyoruz. Bugüne kadar pek çok markanın kurumsal hediyesini hazırladık.</p>' +
        '<ul class="atlc-b2b__list"><li>Markanıza özel hazırlama</li><li>Adet bazlı özel fiyat</li><li>Yeni ürün AR-GE\'si</li><li>Özel tasarım ahşap kutu</li></ul>' +
        exs + logos +
        '<div class="atlc-b2b__cta"><a class="atlc-b2b__btn" href="' + esc(url) + '">Teklif alın</a><a class="atlc-b2b__link" href="' + esc(url) + '">İş birliklerimizi inceleyin →</a></div>' +
      '</div>';
    }

    _trustHtml() {
      var t = this.rt.trustIcons || {};
      var items = [
        { key: 'payment', label: 'Güvenli Ödeme' },
        { key: 'personalization', label: 'Ücretsiz Kişiselleştirme' },
        { key: 'nature', label: 'Doğaya Saygılı' },
        { key: 'gift', label: 'Eşsiz Hediye Deneyimi' }
      ];
      // Grams28 tarzı denemede (rt.infoStyle === 'acc'): iki satırlık açıklama metinleri, koyu ve büyük ikon (CSS: .atlc-trust--x)
      var x = this.rt.infoStyle === 'acc';
      var xText = { payment: 'PayTR güvencesiyle güvenli ödeme', personalization: 'Her üründe ücretsiz isim baskısı', nature: 'Gerçek deri, doğaya saygılı üretim', gift: 'Ömür boyu garanti' }; // 12.10.2026 kullanıcı: ödeme altyapısı PayTR; her sipariş hediye kutusunda gitmiyor → son madde ömür boyu garanti
      var cards = items.map(function (it) {
        if (!t[it.key]) return '';
        if (x && it.key === 'gift') return '<a class="atlc-trust__item" href="/pages/omur-boyu-garanti"><svg class="atlc-trust__ico" viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M24 5l15 5.5v11.5c0 9.5-6.4 16.8-15 20.5C15.4 38.8 9 31.5 9 22V10.5z"/><path d="M17.5 24c0-2 1.6-3.4 3.3-3.4 2.7 0 4.5 6.8 7.2 6.8 1.7 0 3.3-1.4 3.3-3.4s-1.6-3.4-3.3-3.4c-2.7 0-4.5 6.8-7.2 6.8-1.7 0-3.3-1.4-3.3-3.4z"/></svg><span>' + esc(xText.gift) + '</span></a>';
        return '<div class="atlc-trust__item"><img class="atlc-trust__ico" src="' + esc(t[it.key]) + '" alt="" loading="lazy" width="30" height="30"><span>' + esc(x ? xText[it.key] : it.label) + '</span></div>';
      }).join('');
      if (!cards) return '';
      return '<div class="atlc-trust' + (x ? ' atlc-trust--x' : '') + '">' + cards + '</div>';
    }

    /* v2: "Bunları da beğenebilirsin" — Shopify öneri API'sinden 4 kart */
    _loadRecs() {
      return; // 12.10.2026: "Bunları da beğenebilirsiniz" bölümü kullanıcı isteğiyle kaldırıldı (öneriler kargo çubuğunun altında: set / Bununla iyi gider)
      var self = this, rt = this.rt;
      var base = rt.routes && rt.routes.recommendations;
      if (!base || !rt.productId) return;
      fetch(base.replace(/\.json$/, '') + '.json?product_id=' + rt.productId + '&limit=4&intent=related') // .json olmadan HTML döner (12.10.2026 düzeltme)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var ps = (d && d.products) || [];
          if (!ps.length) return;
          var row = self.querySelector('[data-recs-row]');
          var wrap = self.querySelector('[data-recs]');
          if (!row || !wrap) return;
          row.innerHTML = ps.map(function (p) {
            var img = p.featured_image ? '<img src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '';
            var pct = (p.compare_at_price && p.compare_at_price > p.price) ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
            var badge = pct > 0 ? '<span class="atlc-recs__badge">%' + pct + ' İNDİRİM</span>' : '';
            var old = pct > 0 ? '<span class="atlc-recs__old">' + self.money(p.compare_at_price) + '</span>' : '';
            return '<a class="atlc-recs__card" href="' + esc(p.url) + '">' +
              '<span class="atlc-recs__media">' + img + badge + '</span>' +
              '<span class="atlc-recs__name">' + esc(p.title) + '</span>' +
              '<span class="atlc-recs__prices"><span class="atlc-recs__price">' + self.money(p.price) + '</span>' + old + '</span>' +
              '</a>';
          }).join('');
          wrap.style.display = '';
        })
        .catch(function () {});
    }

    /* v2: "Kişiselleştirme & Bakım" sekmesindeki canlı baskı önizleme widget'ı —
       deri şerit önizlemesinin TEK evi (sihirbaz adımlarından kaldırıldı, v2 kararı) */
    _persDemoHtml() {
      var t = (this.state && this.state.persText) || '';
      return '<div class="atlc-persdemo">' +
        '<div class="atlc-persdemo__head"><span class="atlc-field-label nomargin">KİŞİSELLEŞTİRME ÖNİZLEME</span><span class="atlc-pill-free sm">ÜCRETSİZ</span></div>' +
        '<input type="text" class="atlc-eng__input" data-persdemo maxlength="12" value="' + esc(t) + '" placeholder="Yazınızı ekleyin" spellcheck="false">' +
        '<div class="atlc-eng__meta"><span>Sıcak baskı · büyük harf</span>' +
        '<span class="atlc-eng__count">' + trUpper(t).length + ' / 12</span></div>' +
        this._strapPreview('persdemo', t, false) +
        '</div>';
    }

    /* v2 bilgi sekmeleri: ikon kartları, aktif etiket kayarak açılır.
       Bar BİR KEZ kurulur; sekme değişince yalnız class + panel içeriği değişir —
       etiket kayması (.75s max-width) böylece gerçekten animasyonlanır. */
    _infoTabsData() {
      return [
        { ico: ICON_TAB_DESC, title: 'Ürün Bilgisi', body: this.rt.descriptionHtml || '<p>El yapımı, kişiye özel hediye.</p>' },
        { ico: ICON_TAB_PERS, title: 'Kişiselleştirme & Bakım', body: '<p>İsim baskısı büyük harflerle, ürüne sıcak baskı (emboss) tekniğiyle uygulanır — boya değil, kalıcı bir iz.</p>' + /* canlı önizleme kaldırıldı 13.10.2026, geliştirme listesinde: this._persDemoHtml() */ '<p style="margin-top:13px;">Derinizi düzenli olarak doğal bakım kremiyle besleyin; doğrudan güneş ve sudan uzak tutun.</p>' },
        { ico: ICON_TAB_SHIP, title: 'Kargo & İade', body: this._shipTabHtml() },
        { ico: ICON_TAB_PAY, title: 'Güvenli Ödeme', body: '<p>Kredi ya da banka kartıyla PayTR güvencesinde veya Havale/EFT ile ödeyebilirsiniz; kart bilgileriniz bizde saklanmaz.</p><p>2.500 TL üzeri siparişlerde kredi kartına <strong>peşin fiyatına 3 taksit</strong> yapabilirsiniz.</p>' },
        { ico: ICON_TAB_FREE, title: 'Ücretsiz İsim Baskısı', body: '<p>İsim ve harf baskısı <strong>tamamen ücretsizdir</strong>. Siparişinizde dilediğiniz metni ekleyin; pres makinemizle sıcak baskıyla işlenir.</p>' +
          // "Baskı istemiyorum" düğmesi yalnız gate'li alanda var → cümle de yalnız orada (M023)
          ((this.fieldsFlat || []).some(function (f) { return f.gate; }) ? '<p>İsim istemiyorsanız ilgili adımda "Baskı istemiyorum"u işaretlemeniz yeterli.</p>' : '') },
        { ico: ICON_TAB_HAND, title: 'El Yapımı', body: '<p>Ürünlerimiz el işçiliğiyle hazırlanır; deri parçalarda gerçek deri kullanılır. Kusurlu gelen ya da yanlış hazırlanan ürünü ücretsiz yeniden üretiriz.</p>' }
      ];
    }
    // Grams28 tarzı açılır satırlar (12.10.2026, deneme: yalnız rt.infoStyle === 'acc' olan üründe — şimdilik Mini Passenger).
    // Satırlar bir kez kurulur; içerik baştan yazılır (kişiselleştirme önizlemesi odak kaybetmesin diye yeniden çizilmez).
    // 6 başlık (13.10.2026 kullanıcı; önce 4): Ürün Hakkında · Ölçüler & Uyumluluk · Materyal & Form · Paketleme · Kargo & Ödeme ·
    // Değişim & İade. Ürün açıklaması AÇIKLAMA / ÖLÇÜLER / PAKET İÇERİĞİ başlıklarına göre bölünür; deri/astar/kanvas geçen satırlar
    // "Materyal & Form"a, paket içeriği "Paketleme"ye taşınır. rt.dims varsa ölçüler tablodan (açıklamadaki ölçü yerine).
    _accData() {
      var rt = this.rt, wrap = document.createElement('div');
      wrap.innerHTML = rt.descriptionHtml || '';
      wrap.querySelectorAll('[style]').forEach(function (e) { e.removeAttribute('style'); });
      var B = { intro: [], feat: [], dims: [], pack: [] }, cur = 'intro', mat = [];
      // 20.10.2026 kullanıcı: çantalarda (rt.noMatSplit) açıklama satırları Materyal & Form'a taşınmaz, Ürün Hakkında'da kalır
      // 20.10.2026 kullanıcı: Materyal & Bakım tüm ürünlerde aynı sabit metin → açıklama satırları hiçbir üründe oraya taşınmaz
      var MAT = /(?!)/;
      // 20.10.2026 (kupa açıklamaları, kullanıcının PDF'i): <div class="atl-metin"> içindeki yazı bölünmeden "Ürün Hakkında"ya gider
      // (deri geçen paragraflar Materyal'e taşınmaz, kalın satır atlanmaz); dışındaki ÖLÇÜLER vb. eskisi gibi ayrılır
      wrap.querySelectorAll('.atl-metin').forEach(function (m) { B.intro.push(m.innerHTML); });
      wrap.querySelectorAll('p, ul, ol, h2, h3, h4').forEach(function (b) {
        if (b.parentElement && b.parentElement.closest('ul, ol')) return;
        if (b.closest('.atl-metin')) return;
        var t = b.textContent.replace(/\s+/g, ' ').trim(), up = t.toLocaleUpperCase('tr-TR');
        if (!t) return;
        if (/^AÇIKLAMA\b/.test(up)) { cur = 'feat'; return; }
        if (/^ÖLÇÜLER\b/.test(up)) { cur = 'dims'; return; }
        if (/^PAKET İÇERİĞİ\b/.test(up)) { cur = 'pack'; return; }
        // ürün adı satırı (yalnız kalın, büyük harf) atlanır
        if (cur === 'intro' && b.tagName === 'P' && b.querySelector('strong') && b.textContent.trim() === (b.querySelector('strong').textContent || '').trim()) return;
        if (b.tagName === 'UL' || b.tagName === 'OL') {
          b.querySelectorAll('li').forEach(function (li) { if (MAT.test(li.textContent)) { mat.push(li.textContent.trim()); li.remove(); } });
          if (!b.querySelector('li')) return;
        } else if (MAT.test(t) && cur !== 'pack') { mat.push(t.charAt(0) + t.slice(1).toLocaleLowerCase('tr-TR')); return; }
        B[cur].push(b.outerHTML);
      });
      if (!B.feat.length && !B.dims.length && !B.pack.length) { B.feat = B.intro; B.intro = []; }
      var d = rt.dims, dimsHtml;
      if (d && (d.w || d.h || d.d)) {
        var row = function (k, v) { return v ? '<tr><th>' + k + '</th><td>' + esc(v) + '</td></tr>' : ''; };
        dimsHtml = '<table class="atlc-xacc__dims">' + row('Genişlik', d.w) + row('Yükseklik', d.h) + row('Derinlik', d.d) + row('İç göz', d.inner) + '</table>';
      } else {
        // 20.10.2026 kullanıcı (site kuralı): Ölçüler & Uyumluluk her üründe tablo (Genişlik/Yükseklik/Derinlik/İç göz…); açıklamadaki
        // ÖLÇÜLER bölümü (yoksa 'Ölçüler: …' satırı) okunup otomatik tabloya çevrilir — yeni gelen metinler de böyle görünür
        var dsrc = B.dims;
        if (!dsrc.length) dsrc = [].concat(B.intro, B.feat).filter(function (h) { return /ölçü(ler)?\s*:/i.test(h.replace(/<[^>]+>/g, '')); });
        dimsHtml = this._dimsTable(dsrc) || B.dims.join(''); // ölçü yoksa satır kalır, içi boş
      }
      var gate = (this.fieldsFlat || []).some(function (f) { return f.gate; });
      // 20.10.2026 kullanıcı ("kişiselleştirme olmayanlardan kaldır"): yalnız ürünün kendisine isim yazılabiliyorsa — KUTU adımındaki kapak ismi
      // ve Birlikte Al eklentilerinin isimleri sayılmaz (Hediye Kutuları'nın KAPAK adımı sayılır)
      var persOn = (this.steps || []).some(function (st) { return st.kind !== 'box' && st.kind !== 'extra' && st.kind !== 'summary' && (st.fields || []).some(function (f) { return f.kind === 'text' && !f.forLink; }); });
      var paidBox = this.paidBoxValue();
      // 13.10.2026 kullanıcı: setlerde ölçü yerine "Set İçeriği", "Materyal & Form" yok; tekil ürünler aynı kalır.
      // Set içeriği: ürün açıklamasındaki PAKET İÇERİĞİ; yoksa sihirbazdaki parça adımları (Matara, Bardak…).
      var isSet = !!rt.isSet, setHtml = '';
      if (isSet) {
        if (B.pack.length) setHtml = B.pack.join('');
        else {
          var parts = (this.steps || []).filter(function (sd) { return sd.kind === 'part' && !/K[İI]Ş[İI]SELLEŞT|ASKI|^RENK/i.test(sd._rawLabel || sd.label || ''); })
            .map(function (sd) { var l = String(sd._rawLabel || sd.label || '').toLocaleLowerCase('tr-TR'); return l.split(' ').map(function (w) { return w ? w.charAt(0).toLocaleUpperCase('tr-TR') + w.slice(1) : w; }).join(' '); });
          if (parts.length) setHtml = '<ul>' + parts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
        }
      }
      var items = [
        { title: 'Ürün Hakkında', body: B.intro.join('') + B.feat.join('') +
          // 20.10.2026 kullanıcı (bakım kremi): baskı alanı olmayan üründe Kişiselleştirme paragrafı yok (başlıktaki "Hediyeni Tamamla" ile aynı kural)
          (persOn ? '<h3>Kişiselleştirme</h3><p>İsim ve harf baskısı <strong>ücretsizdir</strong>; ürüne sıcak baskıyla (emboss) işlenir, boya değil kalıcı bir izdir.</p>' : '') + /* canlı önizleme kaldırıldı 13.10.2026, geliştirme listesinde: this._persDemoHtml() */
          (persOn && gate ? '<p style="margin-top:13px;">Baskı istemiyorsanız ilgili adımda "Baskı istemiyorum"u işaretlemeniz yeterli.</p>' : '') },
        { title: 'Ölçüler & Uyumluluk', body: dimsHtml },
        // 20.10.2026 kullanıcı: çantalarda (rt.noMatSplit) Materyal & Form sabit metin, maddeler hâlinde (full grain / top grain eklendi)
        // 20.10.2026 kullanıcı: başlık 'Materyal & Form' → 'Materyal & Bakım' (tüm ürünler)
        // 20.10.2026 kullanıcı: "tüm ürünlerde aynı kalsın" → her üründe bu metin ('çantana' → 'ürününe'); Silhouette serisinde patina maddesi farklı
        { title: 'Materyal & Bakım', body:
          '<ul><li>Türkiye’de, <strong>%100 dana derisinden</strong> el işçiliğiyle üretilir.</li>' +
          '<li>Derilerimiz <strong>full grain</strong> ve <strong>top grain</strong>’dir; ürün grubuna göre değişir.</li>' +
          '<li>İthal <strong>paslanmaz</strong> aksesuarlar kullanılır. Deriyle temas ettiği için kaplamada patina oluşabilir; aksesuarlar asla paslanmaz.</li>' +
          (rt.matSilhouette ? '<li>Dış yüzeyi patina yapmaz; özel bir kaplama dokusunu korur. Zamanla yumuşar ama formunu kaybetmez.</li>' :
          '<li>Deri zamanla patina yapar ve size özel, yeni bir görünüm kazanır.</li>') +
          // 20.10.2026 kullanıcı: Silhouette'te dış yüzey çizilmez; çizik ve bakım yalnız iç düz deri yüzeyler için
          (rt.matSilhouette ? '<li>Dış yüzeyi çizilmez. İç kısımdaki düz deride oluşan çizikler doğaldır; zamanla ürününüze karakter katar. Bunları gidermek için aşağıdaki bakım önerilerine göz atın.</li></ul>' :
          '<li>Çizikler doğaldır; zamanla ürününüze karakter katar. Çizikleri gidermek için aşağıdaki bakım önerilerine göz atın.</li></ul>') +
          // 20.10.2026 kullanıcı onayı: Bakım 5 madde; Silhouette serisinde krem yok, yalnız nemli bezle silinir (krem/çizik maddeleri çıkar)
          '<h3>Bakım</h3><ul>' +
          (rt.matSilhouette ? '<li>Kaplamalı dış yüzeyi yalnız nemli bir bezle silmen yeterli; bakım kremine gerek yoktur.</li>' +
          '<li>İç kısımdaki düz deri yüzeyleri 2–3 ayda bir, az miktarda doğal deri bakım kremiyle besleyebilirsiniz.</li>' :
          '<li>Deriyi 2–3 ayda bir, temiz ve yumuşak bir bezle az miktarda doğal deri bakım kremiyle besleyin; birkaç dakika sonra fazlasını silin.</li>') +
          '<li>Islanırsa kuru bir bezle hafifçe kurulayın ve oda sıcaklığında kendiliğinden kurumaya bırakın; saç kurutma makinesi ya da kalorifer kullanmayın.</li>' +
          '<li>Doğrudan güneşten ve ısı kaynaklarından uzak tutun; alkol ya da kimyasal temizleyici kullanmayın.</li>' +
          (rt.matSilhouette ? '<li>İç yüzeydeki hafif çizikleri parmak ucunuzla ovarak ya da biraz bakım kremiyle yumuşatabilirsiniz.</li>' :
          '<li>Yüzeydeki hafif çizikleri parmak ucunuzla ovarak ya da biraz bakım kremiyle yumuşatabilirsiniz.</li>') +
          '<li>Kullanmadığınız zamanlarda nemsiz ve havadar bir yerde, kutusunda ya da toz torbasında saklayın.</li></ul>' },
        { title: 'Paketleme', body: this._packBoxesHtml() + (B.pack.length && !isSet ? '<h3>Kutudan çıkanlar</h3>' + B.pack.join('') : '') +
          '<p>Siparişiniz, koruyucu ve sade <strong>Kolektif kraft kutusunda</strong> ücretsiz gönderilir.</p>' +
          (paidBox ? '<p>İsterseniz ücretli <strong>ahşap hediye kutusunu</strong> seçebilirsiniz: kapağı isme özel hazırlanır ve mühürlenir. Kutudaki QR kodu okutunca standart yapım videomuz açılır.</p>' : '') },
        { title: 'Kargo & Ödeme', body: this._shipWhenHtml() +
          '<p>Kredi ya da banka kartıyla PayTR güvencesinde veya Havale/EFT ile ödeyebilirsiniz; kart bilgileriniz bizde saklanmaz. 2.500 TL üzeri siparişlerde kredi kartına <strong>peşin fiyatına 3 taksit</strong> yapabilirsiniz.</p>' },
        { title: 'Değişim & İade', body: this._returnHtml() +
          '<h3>Garanti</h3><p>Ürünlerimiz ömür boyu garantilidir. <a href="/pages/omur-boyu-garanti">Ömür boyu garanti kapsamını inceleyin →</a></p>' }
      ];
      if (isSet) {
        items[1] = { title: 'Set İçeriği', body: setHtml || '<p>Setteki ürünler sihirbaz adımlarında tek tek gösterilir.</p>' };
        items.splice(2, 1); // Materyal & Bakım
        items.shift(); // 21.10.2026 kullanıcı: hediye setlerinde "Ürün Hakkında" yok; ilk (açık) satır Set İçeriği
      }
      // 20.10.2026 kullanıcı: deri olmayan ürünlerde deri metni yok → kendi kısa metni (liquid rt.matKind)
      var MK = { krem: { title: 'İçerik', body: '<ul><li>İçeriğinde <strong>doğal balmumu</strong> ve <strong>doğal zeytinyağı</strong> bulunur.</li></ul>' },
        kutu: { title: 'Materyal', body: '<ul><li><strong>Kavak kontrplaktan</strong>, elde üretilir.</li></ul>' },
        kalem: { title: 'Materyal', body: '<ul><li><strong>Plastik</strong> gövdelidir; refili değiştirilebilir.</li></ul>' } }[rt.matKind];
      if (MK && !isSet) items[2] = MK;
      return items;
    }
    // 20.10.2026 kullanıcı: açıklamadaki ölçü satırlarından tablo. 'A × B × C cm' → Genişlik / Yükseklik / Derinlik (G × Y × D sırası);
    // 'Etiket: A × B cm' → etiketli satır; 'İç göz …', 'Genişlik …' gibi satırlar adıyla; inç/laptop/MacBook geçenler 'Uyumluluk'.
    _dimsTable(arr) {
      if (!arr || !arr.length) return '';
      var box = document.createElement('div'); box.innerHTML = arr.join('');
      var lines = [];
      box.querySelectorAll('li, p, h3, h4').forEach(function (p) {
        if (p.tagName !== 'LI' && p.closest('li')) return;
        if (p.tagName === 'LI') { lines.push(p.textContent); return; }
        p.innerHTML.split(/<br\s*\/?>/i).forEach(function (x) { var d = document.createElement('div'); d.innerHTML = x; lines.push(d.textContent); });
      });
      var stop = lines.findIndex(function (l) { return /paket içeriği/.test(String(l).toLocaleLowerCase('tr-TR')); });
      if (stop > -1) lines = lines.slice(0, stop);
      var N = '(\\d+(?:[.,]\\d+)?)', S = '\\s*(?:cm)?\\s*[x×*\\-–]\\s*';
      var r3 = new RegExp(N + S + N + S + N + '\\s*cm', 'i'), r2 = new RegExp(N + S + N + '\\s*cm', 'i');
      var c = function (v) { return String(v).replace('.', ','); };
      var cap = function (w) { w = w.toLocaleLowerCase('tr-TR'); return w.charAt(0).toLocaleUpperCase('tr-TR') + w.slice(1); };
      var rows = [], main = false;
      lines.forEach(function (raw) {
        var t = String(raw || '').replace(/\s+/g, ' ').trim().replace(/[.;]$/, '');
        if (!t || /^ölçüler?\s*:?$/.test(t.toLocaleLowerCase('tr-TR'))) return;
        var lab = '', val = t, m = t.match(/^([^:]{2,30}):\s*(.+)$/);
        if (m) { lab = m[1].trim(); val = m[2].trim(); }
        if (/^ölçü(ler)?$/i.test(lab)) lab = '';
        var m3 = val.match(r3);
        if (m3 && !main && !lab) {
          main = true;
          rows.push(['Genişlik', c(m3[1]) + ' cm'], ['Yükseklik', c(m3[2]) + ' cm'], ['Derinlik', c(m3[3]) + ' cm']);
          var rest = val.replace(m3[0], '').replace(/\([^)]*\)/g, '').replace(/^[\s,;–-]+|[\s,;–-]+$/g, '');
          if (rest) rows.push([/inç|"|”|laptop|macbook|uygun|uyumlu/i.test(rest) ? 'Uyumluluk' : '', rest]);
          return;
        }
        if (m3) { rows.push([lab || 'Ölçü', c(m3[1]) + ' × ' + c(m3[2]) + ' × ' + c(m3[3]) + ' cm']); return; }
        var m2 = val.match(r2);
        if (m2) { rows.push([lab || 'Ölçü', c(m2[1]) + ' × ' + c(m2[2]) + ' cm']); return; }
        var wm = t.match(/^(genişlik|yükseklik|derinlik|uzunluk|çap|iç göz|en|boy)\b\s*:?\s*(.+)$/i);
        if (wm) { rows.push([cap(wm[1]), wm[2]]); return; }
        rows.push([lab || (/inç|"|”|laptop|macbook|uygun|uyumlu/i.test(t) ? 'Uyumluluk' : ''), val]);
      });
      return this._rowsTable(rows);
    }
    _rowsTable(rows) {
      if (!rows || !rows.length) return '';
      return '<table class="atlc-xacc__dims">' + rows.map(function (r) {
        return r[0] ? '<tr><th>' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>' : '<tr><td colspan="2">' + esc(r[1]) + '</td></tr>';
      }).join('') + '</table>';
    }
    // Paketleme satırı: Kolektif kraft kutu ve (varsa) ahşap kutu kartları — 13.10.2026 kullanıcı, tüm ürünler
    _packBoxesHtml() {
      // 17.10.2026 kullanıcı: Paketleme'de ürünün gönderileceği kutular — fiyat yazmaz; ahşap kutu ürüne göre (rt.packBox: ad, görsel, ölçü)
      var self = this, f = this._boxField(), paid = this.paidBoxValue(), pb = this.rt.packBox, bu = this.rt.boxUp;
      var card = function (img, name, desc, note) {
        return '<div class="atlc-packbox__c"><span class="atlc-packbox__img"' + (img ? ' style="' + bgImg(img) + '"' : '') + '></span>' +
          '<span class="atlc-packbox__t"><b>' + esc(name) + '</b><span>' + esc(desc) + '</span>' + (note ? '<em class="is-size">' + esc(note) + '</em>' : '') + '</span></div>';
      };
      // 20.10.2026 kullanıcı (sabit site metinler.pdf → Paketleme: "Kutu bölümündeki kutu seçeneklerini ekle"): KUTU adımı varsa
      // Paketleme'de aynı seçenekler aynı ad/görsel/açıklamayla (fiyatsız); yoksa eski kraft + ahşap kutu kartları
      if (f && (f.values || []).length) {
        return '<div class="atlc-packbox">' + f.values.map(function (v) {
          var isPaid = paid && tv(v.v) === tv(paid);
          var std = !isPaid && /karton/i.test(tv(v.v)) && self.rt.stdBoxImg;
          var im = std ? self.rt.stdBoxImg + '&width=' + imgW(160) : (v.img ? cdnSize(v.img, imgW(160)) : '');
          var ds = isPaid ? (/black edition|siyah/i.test(boxName(v.v)) ? 'İsme özel kapak. QR\'ı okutunca standart yapım videosu açılır.' : 'İsme özel kapak ve mühür. QR\'ı okutunca standart yapım videosu açılır.') : 'Koruyucu, sade sunum';
          return card(im, boxName(v.v), ds, isPaid && pb && pb.size && tv(pb.name) === tv(boxName(v.v)) ? 'Ölçü: ' + pb.size : '');
        }).join('') + '</div>';
      }
      var out = card(this.rt.stdBoxImg ? this.rt.stdBoxImg + '&width=' + imgW(160) : '', 'Kolektif Kraft Kutu', 'Koruyucu, sade sunum', '');
      var more = '';
      if (!/^hediye-kutusu-/.test(this.rt.handle || '') && (pb || paid || (bu && bu.id))) {
        var v = (f && paid) ? (f.values || []).find(function (x) { return tv(x.v) === tv(paid); }) : null;
        var name = pb ? pb.name : (paid ? boxName(paid) : 'Ahşap Hediye Kutusu');
        var img = (pb && pb.image) ? pb.image : (v && v.img ? cdnSize(v.img, imgW(160)) : (bu && bu.image) || '');
        out += card(img, name, /black edition|siyah/i.test(name) ? 'İsme özel kapak. QR\'ı okutunca standart yapım videosu açılır.' : 'İsme özel kapak ve mühür. QR\'ı okutunca standart yapım videosu açılır.', pb && pb.size ? 'Ölçü: ' + pb.size : '');
        if (!(f && paid)) more = '<a class="atlc-packbox__more" href="/collections/hediye-kutulari">Ahşap hediye kutularını görün →</a>';
      }
      return '<div class="atlc-packbox">' + out + '</div>' + more;
    }
    // 20.10.2026 kullanıcı: açıklamada ölçü yoksa Ölçüler & Uyumluluk tablosu sayfadaki boyut bölümünden (çanta: .asz data-bw/bh/bd;
    // cüzdan/aksesuar/kupa: .asm-dims kutucukları). Bölümler sihirbazdan sonra geldiği için sayfa yüklenince doldurulur.
    _dimsRowsFromPage() {
      var rows = [], a = document.querySelector('.asz[data-bw]');
      if (a && a.getAttribute('data-bw')) {
        [['Genişlik', 'data-bw'], ['Yükseklik', 'data-bh'], ['Derinlik', 'data-bd']].forEach(function (k) { var v = a.getAttribute(k[1]); if (v) rows.push([k[0], v + ' cm']); });
        return rows;
      }
      document.querySelectorAll('.asm .asm-dims > div').forEach(function (dv) {
        var b = dv.querySelector('b'), sp = dv.querySelector('span');
        if (b && b.textContent.trim()) rows.push([(sp && sp.textContent.trim()) || 'Ölçü', b.textContent.trim()]);
      });
      // 'Ölçü: A × B × C' + ayrıca 'Derinlik: X' (X üçünden biri) → Genişlik/Yükseklik kalan ikisi (ör. kanvas kese 13 × 15 × 12, derinlik 13)
      var num = function (v) { return (String(v).match(/\d+(?:[.,]\d+)?/g) || []); };
      var oi = rows.findIndex(function (r) { return r[0] === 'Ölçü' && num(r[1]).length === 3; });
      var di = rows.findIndex(function (r) { return r[0] === 'Derinlik'; });
      if (oi > -1 && di > -1) {
        var ns = num(rows[oi][1]), dv = num(rows[di][1])[0], k = ns.indexOf(dv);
        if (k > -1) { ns.splice(k, 1); var dRow = rows[di]; rows = rows.filter(function (r, i) { return i !== oi && i !== di; }); rows.unshift(['Genişlik', ns[0] + ' cm'], ['Yükseklik', ns[1] + ' cm'], dRow); }
      }
      return rows;
    }
    _fillDimsLater() {
      var self = this;
      var run = function () {
        var it = Array.prototype.find.call(self.$.accordions.querySelectorAll('.atlc-xacc__item'), function (i) { return /^Ölçüler/.test((i.querySelector('.atlc-xacc__head') || i).textContent.trim()); });
        if (!it) return;
        var panel = it.querySelector('.atlc-itabs__panel');
        if (!panel) return;
        // 20.10.2026 kullanıcı (kupalar): "boyut bölümündekini kullan" → küçük ürün boyut bölümü (.asm) varsa tablo ondan (açıklamadakinin yerine)
        var asm = document.querySelector('.asm .asm-dims > div');
        if (panel.querySelector('table') && !asm) return;
        var t = self._rowsTable(self._dimsRowsFromPage());
        if (!t) return;
        var old = panel.querySelector('table.atlc-xacc__dims');
        if (old) old.outerHTML = t; else panel.innerHTML = t + panel.innerHTML;
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else setTimeout(run, 0);
    }
    _renderAcc() {
      if (this.$.accordions.querySelector('.atlc-xacc')) return;
      var tabs = this._accData();
      this.$.accordions.innerHTML = '<div class="atlc-xacc">' + tabs.map(function (t, i) {
        return '<div class="atlc-xacc__item">' +
          '<button type="button" class="atlc-xacc__head" data-action="xacc" aria-expanded="false" aria-controls="atlc-xacc-' + i + '"><span>' + esc(t.title) + '</span><span class="atlc-xacc__pm" aria-hidden="true"></span></button>' +
          '<div class="atlc-xacc__body" id="atlc-xacc-' + i + '"><div class="atlc-xacc__in"><div class="atlc-itabs__panel">' + t.body + '</div></div></div></div>';
      }).join('') + '</div>';
      this._fillDimsLater();
    }
    _toggleAcc(btn) {
      var it = btn.closest('.atlc-xacc__item');
      var on = it.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(on));
      var self = this;
      if (on) it.querySelectorAll('.atlc-strap__text').forEach(function (el) { self._fitStrap(el); });
      // soldaki yapışkan galeri sabit kalsın (kullanıcı, 12.10.2026): sayfa sonunda galeri kapsayıcının dibine itilmiş olur;
      // satır açılıp sayfa uzayınca aşağı iner. Açılma animasyonu boyunca (≈.32s) kayma kadar sayfa kaydırılarak galeri ekranda yerinde tutulur.
      var gal = this.querySelector('.atlc-gallery');
      if (!gal || window.matchMedia('(max-width: 989px)').matches) return;
      var top0 = gal.getBoundingClientRect().top, t0 = performance.now();
      var keep = function () {
        var d = gal.getBoundingClientRect().top - top0;
        if (Math.abs(d) > 0.5) window.scrollBy(0, d);
        if (performance.now() - t0 < 450) requestAnimationFrame(keep);
      };
      requestAnimationFrame(keep);
    }
    _renderInfo() {
      if (this.rt.infoStyle === 'acc') return this._renderAcc();
      var tabs = this._infoTabsData();
      var active = this.state ? (this.state.infoTab || 0) : 0;
      if (active < 0 || active >= tabs.length) active = 0;
      if (!this.$.accordions.querySelector('.atlc-itabs')) {
        var bar = tabs.map(function (t, i) {
          return '<button type="button" class="atlc-itab" data-action="tab" data-idx="' + i + '" role="tab" title="' + esc(t.title) + '">' +
            '<span class="atlc-itab__ico">' + t.ico + '</span>' +
            '<span class="atlc-itab__slide"><span class="atlc-itab__label">' + esc(t.title) + '</span></span></button>';
        }).join('');
        this.$.accordions.innerHTML =
          '<div class="atlc-itabs">' +
            '<div class="atlc-itabs__bar" role="tablist">' + bar + '</div>' +
            '<div class="atlc-itabs__panel" role="tabpanel" data-itab-panel></div>' +
          '</div>';
      }
      this.$.accordions.querySelectorAll('.atlc-itab').forEach(function (b, i) {
        b.classList.toggle('is-active', i === active);
        b.setAttribute('aria-selected', String(i === active));
      });
      var panel = this.$.accordions.querySelector('[data-itab-panel]');
      panel.innerHTML = '<div class="atlc-itabs__active-title">' + esc(tabs[active].title) + '</div>' + tabs[active].body;
      var self = this;
      panel.querySelectorAll('.atlc-strap__text').forEach(function (el) { self._fitStrap(el); });
    }

    /* ---------- sepet ---------- */
    /* properties[...] BİREBİR canlı adlarla yazılır. Kurallar:
       - choice: props[propAlias||prop] = seçili değer (alias, gate'in Evet'ini ezer — Cloudlift davranışı)
       - gate'li text: skip -> gate=Hayır; değilse gate=Evet + props[prop]=BÜYÜK(text)
       - görünür düz text: doluysa props[prop]=BÜYÜK(text)
       - Evet/Hayır gate alanları: değerleri (Evet/Hayır) aynen yazılır */
    _buildItems() {
      var s = this.state, v = this.currentVariant(), self = this;
      // her sepete ekleme ayrı bir set: aynı ürünün farklı isimli iki seti birbirine karışmaz
      this._setId = String(Date.now()) + String(Math.floor(Math.random() * 1000));
      var props = {};
      this.steps.forEach(function (sd, si) {
        if (sd.kind === 'summary' || sd.kind === 'variant') return;
        (sd.fields || []).forEach(function (f) {
          if (!self.visible(f)) return;
          if (f.forLink || f.linkOnly) return; // bağlı ürünün (ör. 2. orta deri) özellikleri kendi satırına yazılır
          if (f.kind === 'choice') {
            if (f.nav) return; // renk adımı: ürünün kendisi, satır özelliği değil
            var val = s.vals[f.prop];
            if (val == null || val === '') return;
            if (isYesNo(f)) { props[(f.prop.charAt(0) === '_' ? '' : '_') + f.prop] = val; return; } // Evet/Hayır bayrakları müşteriye görünmez (admin'de görünür)
            props[f.propAlias || f.prop] = val;
          } else {
            if (f.gate) {
              // gate bayrakları '_' önekiyle: admin sipariş detayında görünür, müşteriye (sepet/checkout/e-posta) görünmez
              if (s.skips[f.gate.prop]) { props['_' + f.gate.prop] = f.gate.no || 'Hayır'; return; }
              props['_' + f.gate.prop] = f.gate.yes || 'Evet';
            }
            var t = tv(s.txts[f.prop]);
            if (t) props[f.prop] = trUpper(t);
          }
        });
      });
      // sihirbazdan gelen kutu/krem/çakmak ana ürüne bağlı (_set_role): sepette ana ürün silinince onlar da silinir,
      // kutu adedi ana ürünü izler (assets/cart.js AtlSets). Ayrıca eklenen krem bu bağa girmez.
      props['_set_id'] = this._setId;
      props['_set_role'] = 'ana';
      var bound = function (role) { return { '_set_id': self._setId, '_set_role': role, '_set_parent': self.rt.title || '' }; };
      // 21.10.2026 kullanıcı: ödeme sayfası, sipariş ve e-postada kutu satırının altında hangi ürün için olduğu görünsün (sepette kutu zaten ürünün satırında)
      var boxProps = function () { var bp = bound('kutu'); if (self.rt.title) bp['Ürün'] = self.rt.title; return bp; };
      var items = [{ id: v && v.id, quantity: s.qty || 1, properties: props }];
      if (this.boxUpActive()) items.push({ id: this.rt.boxUp.id, quantity: s.qty || 1, properties: boxProps() });
      if (this.creamOn() && this.rt.krem && this.rt.krem.id) items.push({ id: this.rt.krem.id, quantity: 1, properties: bound('ek') });
      var cv = this.cakmakOn() ? this.cakmakVariant() : null;
      if (cv && cv.id) items.push({ id: cv.id, quantity: 1, properties: bound('ek') });
      var sv = this.strapOn() ? this.strapVariant() : null;
      // deri askı (13.10.2026 kullanıcı): sepette ayrı ürün gibi görünmez, çantanın satırına dahil gösterilir ('dahil' rolü; adedi çantayı izler)
      if (sv && sv.id) { var pd = bound('dahil'); pd['_dahil_ad'] = 'Gerçek deri askı'; items.push({ id: sv.id, quantity: s.qty || 1, properties: pd }); }
      // kese ek ücreti (14.10.2026): deri askı gibi kupanın satırına dahil ('dahil' rolü; adedi kupayı izler)
      var kv = this.keseOn() ? this.keseVariant() : null;
      if (kv && kv.id) { var pk = bound('dahil'); pk['_dahil_ad'] = 'Mumlu kanvas kese (' + kv.title + ')'; items.push({ id: kv.id, quantity: s.qty || 1, properties: pk }); }
      // bağlı ürün (ör. kalemlik): kendi fiyatıyla ayrı satır, ana ürüne bağlı ('ek' rolü)
      this.linkPicks().forEach(function (p) { var lp = bound('ek'), xp = self._linkProps(p.f.prop); Object.keys(xp).forEach(function (k) { lp[k] = xp[k]; }); items.push({ id: p.v.id, quantity: (s.qty || 1) * (+p.val.q || 1), properties: lp }); });
      return items;
    }

    addToCart() {
      var self = this;
      this._funnel('personalization_cart_attempt');
      if (this._failed) { this._funnel('personalization_validation_error', { reason: 'load_failed' }); this._renderLoadFail(); return; } // seçenekler yüklenmeden sepete ekleme YOK
      this.$.err.textContent = ''; this.$.err.className = 'atlc-err';
      // seçili varyant tükendiyse (ya da birleşim yoksa) sepete ekleme yok -> varyant adımına dön
      if (this.soldOut()) {
        this._funnel('personalization_validation_error', { reason: 'sold_out' });
        this.$.err.classList.add('is-bad');
        this.$.err.textContent = this._soldOutMsg() + '. Lütfen başka bir seçenek seçin.';
        var vsi = this.steps.findIndex(function (x) { return x.kind === 'variant'; });
        if (vsi >= 0 && vsi !== this.state.step) this.goStep(vsi);
        else { this._renderNav(); this._renderCart(); }
        return;
      }
      var miss = this.missingAll();
      if (miss.length) {
        this._funnel('personalization_validation_error', { reason: 'required_text', missing_count: miss.length });
        this.state.tried = true;
        this.goStep(miss[0]._step);
        this._focusField(miss[0]);
        return;
      }
      var items = this._buildItems();
      if (this.rt.preview || !items[0].id) {
        this.state.added = true; this.state.tried = false; this._renderCart(); this._renderNav(); this._renderStepper();
        this.$.err.classList.add('is-ok');
        this.$.err.textContent = 'Önizleme: set sepete eklendi (gerçek mağazada Shopify sepetine gider).';
        return;
      }
      var btns = this.querySelectorAll('[data-action="cart"], [data-action="stickycta"]');
      btns.forEach(function (b) { b.disabled = true; });
      this._adding = true;
      fetch(this.rt.routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        // Shopify tek istekteki satırları ters sırada listeler; ters gönder ki sepette ana ürün üstte, ekleri altında dursun
        body: JSON.stringify({ items: items.slice().reverse(), sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Sepete eklenemedi.');
          if (self._edit) {
            return self._removeEditLines().then(function (d2) {
              self._edit = null; self._editDone = true;
              try { var u = new URL(window.location.href); u.searchParams.delete('duzenle'); history.replaceState(history.state, '', u.toString()); } catch (e) {}
              return { ok: true, d: d2 };
            });
          }
          self._editDone = false;
          return res;
        })
        .then(function (res) {
          self._funnel('personalization_cart_success');
          self.state.added = true; self.state.tried = false;
          self._renderCart(); self._renderNav(); self._renderStepper();
          var drawer = document.querySelector('cart-drawer');
          if (drawer && res.d.sections && typeof drawer.renderContents === 'function') { try { drawer.renderContents(res.d); return; } catch (e) {} }
          window.location = self.rt.routes.cart || '/cart';
        })
        .catch(function (e) { self._funnel('personalization_cart_error', { reason: 'cart_request_failed' }); self.$.err.classList.add('is-bad'); self.$.err.textContent = e.message; })
        .finally(function () { self._adding = false; btns.forEach(function (b) { b.disabled = false; }); });
    }
  }

  if (!customElements.get('atlanticus-customizer')) {
    customElements.define('atlanticus-customizer', AtlanticusCustomizer);
  }
})();
